// AUTO-GENERATED by scripts/ingest-microservices-register.mjs — do not edit by hand.
// Source: microservices_summary.csv (200 rows)
import type { Microservice } from "./microservices";
import { USD_TO_EUR } from "./microservices-pricing";

type Row = {
  id: string; slug: string; title: string; category: Microservice["category"];
  icon: string; description: string; valueProp: string; tagline: string; deliverable: string;
  tiers: { basic: number; standard: number; premium: number };
  days: number;
  subscriptionAvailable: boolean;
  steps: string[];
  integrations: string[];
  faq: { q: string; a: string }[];
};

const ROWS: Row[] = [
  {
    "id": "reg-001",
    "slug": "ai-video-generation",
    "title": "AI Video Generation",
    "category": "data-ai",
    "icon": "BrainCircuit",
    "description": "Create AI-generated videos for marketing or training",
    "valueProp": "Create AI-generated videos for marketing or training",
    "tagline": "Create AI-generated videos for marketing or training",
    "deliverable": "AI model, automation workflow",
    "tiers": {
      "basic": 117,
      "standard": 452,
      "premium": 823
    },
    "days": 7,
    "subscriptionAvailable": true,
    "steps": [
      "Consultation to understand your automation needs",
      "Develop or fine‑tune AI models or workflows",
      "Integrate with existing tools",
      "Test thoroughly and deliver a turnkey solution"
    ],
    "integrations": [
      "Zapier",
      "OpenAI APIs",
      "Python",
      "Slack",
      "CRM systems"
    ],
    "faq": [
      {
        "q": "What is included in the AI Video Generation service?",
        "a": "Each AI Video Generation engagement includes AI model, automation workflow, delivered within 7 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for AI Video Generation?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start AI Video Generation?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Zapier, OpenAI APIs, Python, Slack)."
      },
      {
        "q": "How many revisions are included in AI Video Generation?",
        "a": "Each AI Video Generation engagement includes AI model, automation workflow, delivered within 7 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after AI Video Generation?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-002",
    "slug": "ai-content-writing",
    "title": "AI Content Writing",
    "category": "data-ai",
    "icon": "BrainCircuit",
    "description": "Use AI tools to write engaging articles",
    "valueProp": "Use AI tools to write engaging articles",
    "tagline": "Use AI tools to write engaging articles",
    "deliverable": "AI model, automation workflow",
    "tiers": {
      "basic": 183,
      "standard": 318,
      "premium": 612
    },
    "days": 4,
    "subscriptionAvailable": true,
    "steps": [
      "Consultation to understand your automation needs",
      "Develop or fine‑tune AI models or workflows",
      "Integrate with existing tools",
      "Test thoroughly and deliver a turnkey solution"
    ],
    "integrations": [
      "Zapier",
      "OpenAI APIs",
      "Python",
      "Slack",
      "CRM systems"
    ],
    "faq": [
      {
        "q": "What is included in the AI Content Writing service?",
        "a": "Each AI Content Writing engagement includes AI model, automation workflow, delivered within 4 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for AI Content Writing?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start AI Content Writing?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Zapier, OpenAI APIs, Python, Slack)."
      },
      {
        "q": "How many revisions are included in AI Content Writing?",
        "a": "Each AI Content Writing engagement includes AI model, automation workflow, delivered within 4 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after AI Content Writing?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-003",
    "slug": "ai-voice-over",
    "title": "AI Voice-Over",
    "category": "data-ai",
    "icon": "BrainCircuit",
    "description": "Generate synthetic voice narration using AI",
    "valueProp": "Generate synthetic voice narration using AI",
    "tagline": "Generate synthetic voice narration using AI",
    "deliverable": "AI model, automation workflow",
    "tiers": {
      "basic": 191,
      "standard": 205,
      "premium": 794
    },
    "days": 6,
    "subscriptionAvailable": true,
    "steps": [
      "Consultation to understand your automation needs",
      "Develop or fine‑tune AI models or workflows",
      "Integrate with existing tools",
      "Test thoroughly and deliver a turnkey solution"
    ],
    "integrations": [
      "Zapier",
      "OpenAI APIs",
      "Python",
      "Slack",
      "CRM systems"
    ],
    "faq": [
      {
        "q": "What is included in the AI Voice-Over service?",
        "a": "Each AI Voice-Over engagement includes AI model, automation workflow, delivered within 6 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for AI Voice-Over?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start AI Voice-Over?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Zapier, OpenAI APIs, Python, Slack)."
      },
      {
        "q": "How many revisions are included in AI Voice-Over?",
        "a": "Each AI Voice-Over engagement includes AI model, automation workflow, delivered within 6 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after AI Voice-Over?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-004",
    "slug": "ai-image-creation",
    "title": "AI Image Creation",
    "category": "data-ai",
    "icon": "BrainCircuit",
    "description": "Produce AI-generated images and artwork",
    "valueProp": "Produce AI-generated images and artwork",
    "tagline": "Produce AI-generated images and artwork",
    "deliverable": "AI model, automation workflow",
    "tiers": {
      "basic": 156,
      "standard": 430,
      "premium": 706
    },
    "days": 11,
    "subscriptionAvailable": true,
    "steps": [
      "Consultation to understand your automation needs",
      "Develop or fine‑tune AI models or workflows",
      "Integrate with existing tools",
      "Test thoroughly and deliver a turnkey solution"
    ],
    "integrations": [
      "Zapier",
      "OpenAI APIs",
      "Python",
      "Slack",
      "CRM systems"
    ],
    "faq": [
      {
        "q": "What is included in the AI Image Creation service?",
        "a": "Each AI Image Creation engagement includes AI model, automation workflow, delivered within 11 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for AI Image Creation?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start AI Image Creation?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Zapier, OpenAI APIs, Python, Slack)."
      },
      {
        "q": "How many revisions are included in AI Image Creation?",
        "a": "Each AI Image Creation engagement includes AI model, automation workflow, delivered within 11 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after AI Image Creation?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-005",
    "slug": "chatbot-development",
    "title": "Chatbot Development",
    "category": "data-ai",
    "icon": "BrainCircuit",
    "description": "Build conversational chatbots for customer support",
    "valueProp": "Build conversational chatbots for customer support",
    "tagline": "Build conversational chatbots for customer support",
    "deliverable": "AI model, automation workflow",
    "tiers": {
      "basic": 154,
      "standard": 352,
      "premium": 971
    },
    "days": 4,
    "subscriptionAvailable": true,
    "steps": [
      "Consultation to understand your automation needs",
      "Develop or fine‑tune AI models or workflows",
      "Integrate with existing tools",
      "Test thoroughly and deliver a turnkey solution"
    ],
    "integrations": [
      "Zapier",
      "OpenAI APIs",
      "Python",
      "Slack",
      "CRM systems"
    ],
    "faq": [
      {
        "q": "What is included in the Chatbot Development service?",
        "a": "Each Chatbot Development engagement includes AI model, automation workflow, delivered within 4 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Chatbot Development?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Chatbot Development?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Zapier, OpenAI APIs, Python, Slack)."
      },
      {
        "q": "How many revisions are included in Chatbot Development?",
        "a": "Each Chatbot Development engagement includes AI model, automation workflow, delivered within 4 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Chatbot Development?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-006",
    "slug": "machine-learning-models",
    "title": "Machine Learning Models",
    "category": "data-ai",
    "icon": "BrainCircuit",
    "description": "Develop custom ML models for predictions",
    "valueProp": "Develop custom ML models for predictions",
    "tagline": "Develop custom ML models for predictions",
    "deliverable": "AI model, automation workflow",
    "tiers": {
      "basic": 128,
      "standard": 461,
      "premium": 562
    },
    "days": 13,
    "subscriptionAvailable": true,
    "steps": [
      "Consultation to understand your automation needs",
      "Develop or fine‑tune AI models or workflows",
      "Integrate with existing tools",
      "Test thoroughly and deliver a turnkey solution"
    ],
    "integrations": [
      "Zapier",
      "OpenAI APIs",
      "Python",
      "Slack",
      "CRM systems"
    ],
    "faq": [
      {
        "q": "What is included in the Machine Learning Models service?",
        "a": "Each Machine Learning Models engagement includes AI model, automation workflow, delivered within 13 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Machine Learning Models?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Machine Learning Models?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Zapier, OpenAI APIs, Python, Slack)."
      },
      {
        "q": "How many revisions are included in Machine Learning Models?",
        "a": "Each Machine Learning Models engagement includes AI model, automation workflow, delivered within 13 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Machine Learning Models?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-007",
    "slug": "automation-workflow-setup",
    "title": "Automation Workflow Setup",
    "category": "data-ai",
    "icon": "BrainCircuit",
    "description": "Implement automated workflows using tools like Zapier",
    "valueProp": "Implement automated workflows using tools like Zapier",
    "tagline": "Implement automated workflows using tools like Zapier",
    "deliverable": "AI model, automation workflow",
    "tiers": {
      "basic": 139,
      "standard": 356,
      "premium": 818
    },
    "days": 3,
    "subscriptionAvailable": true,
    "steps": [
      "Consultation to understand your automation needs",
      "Develop or fine‑tune AI models or workflows",
      "Integrate with existing tools",
      "Test thoroughly and deliver a turnkey solution"
    ],
    "integrations": [
      "Zapier",
      "OpenAI APIs",
      "Python",
      "Slack",
      "CRM systems"
    ],
    "faq": [
      {
        "q": "What is included in the Automation Workflow Setup service?",
        "a": "Each Automation Workflow Setup engagement includes AI model, automation workflow, delivered within 3 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Automation Workflow Setup?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Automation Workflow Setup?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Zapier, OpenAI APIs, Python, Slack)."
      },
      {
        "q": "How many revisions are included in Automation Workflow Setup?",
        "a": "Each Automation Workflow Setup engagement includes AI model, automation workflow, delivered within 3 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Automation Workflow Setup?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-008",
    "slug": "prompt-engineering",
    "title": "Prompt Engineering",
    "category": "data-ai",
    "icon": "BrainCircuit",
    "description": "Craft effective prompts for large language models",
    "valueProp": "Craft effective prompts for large language models",
    "tagline": "Craft effective prompts for large language models",
    "deliverable": "AI model, automation workflow",
    "tiers": {
      "basic": 174,
      "standard": 267,
      "premium": 632
    },
    "days": 6,
    "subscriptionAvailable": true,
    "steps": [
      "Consultation to understand your automation needs",
      "Develop or fine‑tune AI models or workflows",
      "Integrate with existing tools",
      "Test thoroughly and deliver a turnkey solution"
    ],
    "integrations": [
      "Zapier",
      "OpenAI APIs",
      "Python",
      "Slack",
      "CRM systems"
    ],
    "faq": [
      {
        "q": "What is included in the Prompt Engineering service?",
        "a": "Each Prompt Engineering engagement includes AI model, automation workflow, delivered within 6 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Prompt Engineering?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Prompt Engineering?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Zapier, OpenAI APIs, Python, Slack)."
      },
      {
        "q": "How many revisions are included in Prompt Engineering?",
        "a": "Each Prompt Engineering engagement includes AI model, automation workflow, delivered within 6 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Prompt Engineering?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-009",
    "slug": "ai-integration",
    "title": "AI Integration",
    "category": "data-ai",
    "icon": "BrainCircuit",
    "description": "Integrate AI services with business tools",
    "valueProp": "Integrate AI services with business tools",
    "tagline": "Integrate AI services with business tools",
    "deliverable": "AI model, automation workflow",
    "tiers": {
      "basic": 118,
      "standard": 318,
      "premium": 632
    },
    "days": 4,
    "subscriptionAvailable": true,
    "steps": [
      "Consultation to understand your automation needs",
      "Develop or fine‑tune AI models or workflows",
      "Integrate with existing tools",
      "Test thoroughly and deliver a turnkey solution"
    ],
    "integrations": [
      "Zapier",
      "OpenAI APIs",
      "Python",
      "Slack",
      "CRM systems"
    ],
    "faq": [
      {
        "q": "What is included in the AI Integration service?",
        "a": "Each AI Integration engagement includes AI model, automation workflow, delivered within 4 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for AI Integration?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start AI Integration?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Zapier, OpenAI APIs, Python, Slack)."
      },
      {
        "q": "How many revisions are included in AI Integration?",
        "a": "Each AI Integration engagement includes AI model, automation workflow, delivered within 4 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after AI Integration?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-010",
    "slug": "ai-consultation",
    "title": "AI Consultation",
    "category": "data-ai",
    "icon": "BrainCircuit",
    "description": "Advise on AI adoption and strategy",
    "valueProp": "Advise on AI adoption and strategy",
    "tagline": "Advise on AI adoption and strategy",
    "deliverable": "AI model, automation workflow",
    "tiers": {
      "basic": 145,
      "standard": 451,
      "premium": 565
    },
    "days": 11,
    "subscriptionAvailable": true,
    "steps": [
      "Consultation to understand your automation needs",
      "Develop or fine‑tune AI models or workflows",
      "Integrate with existing tools",
      "Test thoroughly and deliver a turnkey solution"
    ],
    "integrations": [
      "Zapier",
      "OpenAI APIs",
      "Python",
      "Slack",
      "CRM systems"
    ],
    "faq": [
      {
        "q": "What is included in the AI Consultation service?",
        "a": "Each AI Consultation engagement includes AI model, automation workflow, delivered within 11 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for AI Consultation?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start AI Consultation?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Zapier, OpenAI APIs, Python, Slack)."
      },
      {
        "q": "How many revisions are included in AI Consultation?",
        "a": "Each AI Consultation engagement includes AI model, automation workflow, delivered within 11 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after AI Consultation?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-011",
    "slug": "voice-assistant-skills",
    "title": "Voice Assistant Skills",
    "category": "data-ai",
    "icon": "BrainCircuit",
    "description": "Create skills for voice assistants (Alexa, Google)",
    "valueProp": "Create skills for voice assistants (Alexa, Google)",
    "tagline": "Create skills for voice assistants (Alexa, Google)",
    "deliverable": "AI model, automation workflow",
    "tiers": {
      "basic": 157,
      "standard": 251,
      "premium": 877
    },
    "days": 11,
    "subscriptionAvailable": true,
    "steps": [
      "Consultation to understand your automation needs",
      "Develop or fine‑tune AI models or workflows",
      "Integrate with existing tools",
      "Test thoroughly and deliver a turnkey solution"
    ],
    "integrations": [
      "Zapier",
      "OpenAI APIs",
      "Python",
      "Slack",
      "CRM systems"
    ],
    "faq": [
      {
        "q": "What is included in the Voice Assistant Skills service?",
        "a": "Each Voice Assistant Skills engagement includes AI model, automation workflow, delivered within 11 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Voice Assistant Skills?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Voice Assistant Skills?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Zapier, OpenAI APIs, Python, Slack)."
      },
      {
        "q": "How many revisions are included in Voice Assistant Skills?",
        "a": "Each Voice Assistant Skills engagement includes AI model, automation workflow, delivered within 11 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Voice Assistant Skills?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-012",
    "slug": "ai-data-labeling",
    "title": "AI Data Labeling",
    "category": "data-ai",
    "icon": "BrainCircuit",
    "description": "Label datasets for AI training",
    "valueProp": "Label datasets for AI training",
    "tagline": "Label datasets for AI training",
    "deliverable": "AI model, automation workflow",
    "tiers": {
      "basic": 139,
      "standard": 474,
      "premium": 776
    },
    "days": 10,
    "subscriptionAvailable": true,
    "steps": [
      "Consultation to understand your automation needs",
      "Develop or fine‑tune AI models or workflows",
      "Integrate with existing tools",
      "Test thoroughly and deliver a turnkey solution"
    ],
    "integrations": [
      "Zapier",
      "OpenAI APIs",
      "Python",
      "Slack",
      "CRM systems"
    ],
    "faq": [
      {
        "q": "What is included in the AI Data Labeling service?",
        "a": "Each AI Data Labeling engagement includes AI model, automation workflow, delivered within 10 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for AI Data Labeling?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start AI Data Labeling?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Zapier, OpenAI APIs, Python, Slack)."
      },
      {
        "q": "How many revisions are included in AI Data Labeling?",
        "a": "Each AI Data Labeling engagement includes AI model, automation workflow, delivered within 10 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after AI Data Labeling?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-013",
    "slug": "ai-model-fine-tuning",
    "title": "AI Model Fine-Tuning",
    "category": "data-ai",
    "icon": "BrainCircuit",
    "description": "Fine-tune existing AI models to specific tasks",
    "valueProp": "Fine-tune existing AI models to specific tasks",
    "tagline": "Fine-tune existing AI models to specific tasks",
    "deliverable": "AI model, automation workflow",
    "tiers": {
      "basic": 115,
      "standard": 440,
      "premium": 784
    },
    "days": 10,
    "subscriptionAvailable": true,
    "steps": [
      "Consultation to understand your automation needs",
      "Develop or fine‑tune AI models or workflows",
      "Integrate with existing tools",
      "Test thoroughly and deliver a turnkey solution"
    ],
    "integrations": [
      "Zapier",
      "OpenAI APIs",
      "Python",
      "Slack",
      "CRM systems"
    ],
    "faq": [
      {
        "q": "What is included in the AI Model Fine-Tuning service?",
        "a": "Each AI Model Fine-Tuning engagement includes AI model, automation workflow, delivered within 10 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for AI Model Fine-Tuning?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start AI Model Fine-Tuning?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Zapier, OpenAI APIs, Python, Slack)."
      },
      {
        "q": "How many revisions are included in AI Model Fine-Tuning?",
        "a": "Each AI Model Fine-Tuning engagement includes AI model, automation workflow, delivered within 10 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after AI Model Fine-Tuning?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-014",
    "slug": "generative-ai-consulting",
    "title": "Generative AI Consulting",
    "category": "data-ai",
    "icon": "BrainCircuit",
    "description": "Plan generative AI applications for business",
    "valueProp": "Plan generative AI applications for business",
    "tagline": "Plan generative AI applications for business",
    "deliverable": "AI model, automation workflow",
    "tiers": {
      "basic": 153,
      "standard": 375,
      "premium": 862
    },
    "days": 5,
    "subscriptionAvailable": true,
    "steps": [
      "Consultation to understand your automation needs",
      "Develop or fine‑tune AI models or workflows",
      "Integrate with existing tools",
      "Test thoroughly and deliver a turnkey solution"
    ],
    "integrations": [
      "Zapier",
      "OpenAI APIs",
      "Python",
      "Slack",
      "CRM systems"
    ],
    "faq": [
      {
        "q": "What is included in the Generative AI Consulting service?",
        "a": "Each Generative AI Consulting engagement includes AI model, automation workflow, delivered within 5 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Generative AI Consulting?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Generative AI Consulting?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Zapier, OpenAI APIs, Python, Slack)."
      },
      {
        "q": "How many revisions are included in Generative AI Consulting?",
        "a": "Each Generative AI Consulting engagement includes AI model, automation workflow, delivered within 5 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Generative AI Consulting?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-015",
    "slug": "ai-driven-market-research",
    "title": "AI-Driven Market Research",
    "category": "data-ai",
    "icon": "BrainCircuit",
    "description": "Use AI to analyze market trends",
    "valueProp": "Use AI to analyze market trends",
    "tagline": "Use AI to analyze market trends",
    "deliverable": "AI model, automation workflow",
    "tiers": {
      "basic": 183,
      "standard": 424,
      "premium": 500
    },
    "days": 9,
    "subscriptionAvailable": true,
    "steps": [
      "Consultation to understand your automation needs",
      "Develop or fine‑tune AI models or workflows",
      "Integrate with existing tools",
      "Test thoroughly and deliver a turnkey solution"
    ],
    "integrations": [
      "Zapier",
      "OpenAI APIs",
      "Python",
      "Slack",
      "CRM systems"
    ],
    "faq": [
      {
        "q": "What is included in the AI-Driven Market Research service?",
        "a": "Each AI-Driven Market Research engagement includes AI model, automation workflow, delivered within 9 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for AI-Driven Market Research?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start AI-Driven Market Research?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Zapier, OpenAI APIs, Python, Slack)."
      },
      {
        "q": "How many revisions are included in AI-Driven Market Research?",
        "a": "Each AI-Driven Market Research engagement includes AI model, automation workflow, delivered within 9 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after AI-Driven Market Research?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-016",
    "slug": "full-stack-development",
    "title": "Full-Stack Development",
    "category": "web-mobile",
    "icon": "Code2",
    "description": "Develop front-end and back-end solutions",
    "valueProp": "Develop front-end and back-end solutions",
    "tagline": "Develop front-end and back-end solutions",
    "deliverable": "Source code, application",
    "tiers": {
      "basic": 140,
      "standard": 479,
      "premium": 636
    },
    "days": 9,
    "subscriptionAvailable": true,
    "steps": [
      "Gather requirements and objectives",
      "Architect the solution",
      "Develop and test each component",
      "Deploy in your environment",
      "And provide post‑launch support and maintenance"
    ],
    "integrations": [
      "GitHub",
      "AWS",
      "GitLab",
      "Slack",
      "Trello",
      "Jira"
    ],
    "faq": [
      {
        "q": "What is included in the Full-Stack Development service?",
        "a": "Each Full-Stack Development engagement includes Source code, application, delivered within 9 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Full-Stack Development?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Full-Stack Development?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (GitHub, AWS, GitLab, Slack)."
      },
      {
        "q": "How many revisions are included in Full-Stack Development?",
        "a": "Each Full-Stack Development engagement includes Source code, application, delivered within 9 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Full-Stack Development?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-017",
    "slug": "wordpress-site-development",
    "title": "WordPress Site Development",
    "category": "web-mobile",
    "icon": "Code2",
    "description": "Build and customize WordPress websites",
    "valueProp": "Build and customize WordPress websites",
    "tagline": "Build and customize WordPress websites",
    "deliverable": "Source code, application",
    "tiers": {
      "basic": 140,
      "standard": 244,
      "premium": 509
    },
    "days": 7,
    "subscriptionAvailable": true,
    "steps": [
      "Gather requirements and objectives",
      "Architect the solution",
      "Develop and test each component",
      "Deploy in your environment",
      "And provide post‑launch support and maintenance"
    ],
    "integrations": [
      "GitHub",
      "AWS",
      "GitLab",
      "Slack",
      "Trello",
      "Jira"
    ],
    "faq": [
      {
        "q": "What is included in the WordPress Site Development service?",
        "a": "Each WordPress Site Development engagement includes Source code, application, delivered within 7 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for WordPress Site Development?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start WordPress Site Development?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (GitHub, AWS, GitLab, Slack)."
      },
      {
        "q": "How many revisions are included in WordPress Site Development?",
        "a": "Each WordPress Site Development engagement includes Source code, application, delivered within 7 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after WordPress Site Development?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-018",
    "slug": "web-development",
    "title": "Web Development",
    "category": "web-mobile",
    "icon": "Code2",
    "description": "Create responsive websites and web apps",
    "valueProp": "Create responsive websites and web apps",
    "tagline": "Create responsive websites and web apps",
    "deliverable": "Source code, application",
    "tiers": {
      "basic": 107,
      "standard": 311,
      "premium": 914
    },
    "days": 12,
    "subscriptionAvailable": true,
    "steps": [
      "Gather requirements and objectives",
      "Architect the solution",
      "Develop and test each component",
      "Deploy in your environment",
      "And provide post‑launch support and maintenance"
    ],
    "integrations": [
      "GitHub",
      "AWS",
      "GitLab",
      "Slack",
      "Trello",
      "Jira"
    ],
    "faq": [
      {
        "q": "What is included in the Web Development service?",
        "a": "Each Web Development engagement includes Source code, application, delivered within 12 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Web Development?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Web Development?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (GitHub, AWS, GitLab, Slack)."
      },
      {
        "q": "How many revisions are included in Web Development?",
        "a": "Each Web Development engagement includes Source code, application, delivered within 12 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Web Development?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-019",
    "slug": "shopify-store-setup",
    "title": "Shopify Store Setup",
    "category": "web-mobile",
    "icon": "Code2",
    "description": "Launch and customize Shopify e-commerce stores",
    "valueProp": "Launch and customize Shopify e-commerce stores",
    "tagline": "Launch and customize Shopify e-commerce stores",
    "deliverable": "Source code, application",
    "tiers": {
      "basic": 121,
      "standard": 460,
      "premium": 633
    },
    "days": 4,
    "subscriptionAvailable": true,
    "steps": [
      "Gather requirements and objectives",
      "Architect the solution",
      "Develop and test each component",
      "Deploy in your environment",
      "And provide post‑launch support and maintenance"
    ],
    "integrations": [
      "GitHub",
      "AWS",
      "GitLab",
      "Slack",
      "Trello",
      "Jira"
    ],
    "faq": [
      {
        "q": "What is included in the Shopify Store Setup service?",
        "a": "Each Shopify Store Setup engagement includes Source code, application, delivered within 4 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Shopify Store Setup?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Shopify Store Setup?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (GitHub, AWS, GitLab, Slack)."
      },
      {
        "q": "How many revisions are included in Shopify Store Setup?",
        "a": "Each Shopify Store Setup engagement includes Source code, application, delivered within 4 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Shopify Store Setup?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-020",
    "slug": "mobile-app-development",
    "title": "Mobile App Development",
    "category": "web-mobile",
    "icon": "Code2",
    "description": "Develop native or cross-platform mobile apps",
    "valueProp": "Develop native or cross-platform mobile apps",
    "tagline": "Develop native or cross-platform mobile apps",
    "deliverable": "Source code, application",
    "tiers": {
      "basic": 128,
      "standard": 429,
      "premium": 842
    },
    "days": 11,
    "subscriptionAvailable": true,
    "steps": [
      "Gather requirements and objectives",
      "Architect the solution",
      "Develop and test each component",
      "Deploy in your environment",
      "And provide post‑launch support and maintenance"
    ],
    "integrations": [
      "GitHub",
      "AWS",
      "GitLab",
      "Slack",
      "Trello",
      "Jira"
    ],
    "faq": [
      {
        "q": "What is included in the Mobile App Development service?",
        "a": "Each Mobile App Development engagement includes Source code, application, delivered within 11 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Mobile App Development?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Mobile App Development?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (GitHub, AWS, GitLab, Slack)."
      },
      {
        "q": "How many revisions are included in Mobile App Development?",
        "a": "Each Mobile App Development engagement includes Source code, application, delivered within 11 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Mobile App Development?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-021",
    "slug": "webflow-development",
    "title": "Webflow Development",
    "category": "web-mobile",
    "icon": "Code2",
    "description": "Build no-code websites using Webflow",
    "valueProp": "Build no-code websites using Webflow",
    "tagline": "Build no-code websites using Webflow",
    "deliverable": "Source code, application",
    "tiers": {
      "basic": 106,
      "standard": 234,
      "premium": 838
    },
    "days": 6,
    "subscriptionAvailable": true,
    "steps": [
      "Gather requirements and objectives",
      "Architect the solution",
      "Develop and test each component",
      "Deploy in your environment",
      "And provide post‑launch support and maintenance"
    ],
    "integrations": [
      "GitHub",
      "AWS",
      "GitLab",
      "Slack",
      "Trello",
      "Jira"
    ],
    "faq": [
      {
        "q": "What is included in the Webflow Development service?",
        "a": "Each Webflow Development engagement includes Source code, application, delivered within 6 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Webflow Development?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Webflow Development?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (GitHub, AWS, GitLab, Slack)."
      },
      {
        "q": "How many revisions are included in Webflow Development?",
        "a": "Each Webflow Development engagement includes Source code, application, delivered within 6 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Webflow Development?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-022",
    "slug": "front-end-development",
    "title": "Front-End Development",
    "category": "web-mobile",
    "icon": "Code2",
    "description": "Design pixel-perfect interfaces and UX",
    "valueProp": "Design pixel-perfect interfaces and UX",
    "tagline": "Design pixel-perfect interfaces and UX",
    "deliverable": "Source code, application",
    "tiers": {
      "basic": 162,
      "standard": 481,
      "premium": 824
    },
    "days": 12,
    "subscriptionAvailable": true,
    "steps": [
      "Gather requirements and objectives",
      "Architect the solution",
      "Develop and test each component",
      "Deploy in your environment",
      "And provide post‑launch support and maintenance"
    ],
    "integrations": [
      "GitHub",
      "AWS",
      "GitLab",
      "Slack",
      "Trello",
      "Jira"
    ],
    "faq": [
      {
        "q": "What is included in the Front-End Development service?",
        "a": "Each Front-End Development engagement includes Source code, application, delivered within 12 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Front-End Development?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Front-End Development?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (GitHub, AWS, GitLab, Slack)."
      },
      {
        "q": "How many revisions are included in Front-End Development?",
        "a": "Each Front-End Development engagement includes Source code, application, delivered within 12 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Front-End Development?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-023",
    "slug": "ecommerce-website-development",
    "title": "Ecommerce Website Development",
    "category": "web-mobile",
    "icon": "Code2",
    "description": "Build scalable online stores",
    "valueProp": "Build scalable online stores",
    "tagline": "Build scalable online stores",
    "deliverable": "Source code, application",
    "tiers": {
      "basic": 163,
      "standard": 310,
      "premium": 970
    },
    "days": 4,
    "subscriptionAvailable": true,
    "steps": [
      "Gather requirements and objectives",
      "Architect the solution",
      "Develop and test each component",
      "Deploy in your environment",
      "And provide post‑launch support and maintenance"
    ],
    "integrations": [
      "GitHub",
      "AWS",
      "GitLab",
      "Slack",
      "Trello",
      "Jira"
    ],
    "faq": [
      {
        "q": "What is included in the Ecommerce Website Development service?",
        "a": "Each Ecommerce Website Development engagement includes Source code, application, delivered within 4 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Ecommerce Website Development?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Ecommerce Website Development?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (GitHub, AWS, GitLab, Slack)."
      },
      {
        "q": "How many revisions are included in Ecommerce Website Development?",
        "a": "Each Ecommerce Website Development engagement includes Source code, application, delivered within 4 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Ecommerce Website Development?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-024",
    "slug": "react-js-development",
    "title": "React JS Development",
    "category": "web-mobile",
    "icon": "Code2",
    "description": "Create dynamic UIs with React",
    "valueProp": "Create dynamic UIs with React",
    "tagline": "Create dynamic UIs with React",
    "deliverable": "Source code, application",
    "tiers": {
      "basic": 198,
      "standard": 428,
      "premium": 575
    },
    "days": 10,
    "subscriptionAvailable": true,
    "steps": [
      "Gather requirements and objectives",
      "Architect the solution",
      "Develop and test each component",
      "Deploy in your environment",
      "And provide post‑launch support and maintenance"
    ],
    "integrations": [
      "GitHub",
      "AWS",
      "GitLab",
      "Slack",
      "Trello",
      "Jira"
    ],
    "faq": [
      {
        "q": "What is included in the React JS Development service?",
        "a": "Each React JS Development engagement includes Source code, application, delivered within 10 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for React JS Development?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start React JS Development?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (GitHub, AWS, GitLab, Slack)."
      },
      {
        "q": "How many revisions are included in React JS Development?",
        "a": "Each React JS Development engagement includes Source code, application, delivered within 10 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after React JS Development?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-025",
    "slug": "bubble-no-code-apps",
    "title": "Bubble No-Code Apps",
    "category": "web-mobile",
    "icon": "Code2",
    "description": "Develop apps on Bubble platform",
    "valueProp": "Develop apps on Bubble platform",
    "tagline": "Develop apps on Bubble platform",
    "deliverable": "Source code, application",
    "tiers": {
      "basic": 104,
      "standard": 231,
      "premium": 509
    },
    "days": 12,
    "subscriptionAvailable": true,
    "steps": [
      "Gather requirements and objectives",
      "Architect the solution",
      "Develop and test each component",
      "Deploy in your environment",
      "And provide post‑launch support and maintenance"
    ],
    "integrations": [
      "GitHub",
      "AWS",
      "GitLab",
      "Slack",
      "Trello",
      "Jira"
    ],
    "faq": [
      {
        "q": "What is included in the Bubble No-Code Apps service?",
        "a": "Each Bubble No-Code Apps engagement includes Source code, application, delivered within 12 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Bubble No-Code Apps?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Bubble No-Code Apps?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (GitHub, AWS, GitLab, Slack)."
      },
      {
        "q": "How many revisions are included in Bubble No-Code Apps?",
        "a": "Each Bubble No-Code Apps engagement includes Source code, application, delivered within 12 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Bubble No-Code Apps?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-026",
    "slug": "api-integration",
    "title": "API Integration",
    "category": "web-mobile",
    "icon": "Code2",
    "description": "Connect and integrate external APIs",
    "valueProp": "Connect and integrate external APIs",
    "tagline": "Connect and integrate external APIs",
    "deliverable": "Source code, application",
    "tiers": {
      "basic": 157,
      "standard": 201,
      "premium": 923
    },
    "days": 10,
    "subscriptionAvailable": true,
    "steps": [
      "Gather requirements and objectives",
      "Architect the solution",
      "Develop and test each component",
      "Deploy in your environment",
      "And provide post‑launch support and maintenance"
    ],
    "integrations": [
      "GitHub",
      "AWS",
      "GitLab",
      "Slack",
      "Trello",
      "Jira"
    ],
    "faq": [
      {
        "q": "What is included in the API Integration service?",
        "a": "Each API Integration engagement includes Source code, application, delivered within 10 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for API Integration?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start API Integration?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (GitHub, AWS, GitLab, Slack)."
      },
      {
        "q": "How many revisions are included in API Integration?",
        "a": "Each API Integration engagement includes Source code, application, delivered within 10 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after API Integration?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-027",
    "slug": "custom-software-development",
    "title": "Custom Software Development",
    "category": "web-mobile",
    "icon": "Code2",
    "description": "Build bespoke software solutions",
    "valueProp": "Build bespoke software solutions",
    "tagline": "Build bespoke software solutions",
    "deliverable": "Source code, application",
    "tiers": {
      "basic": 122,
      "standard": 249,
      "premium": 634
    },
    "days": 3,
    "subscriptionAvailable": true,
    "steps": [
      "Gather requirements and objectives",
      "Architect the solution",
      "Develop and test each component",
      "Deploy in your environment",
      "And provide post‑launch support and maintenance"
    ],
    "integrations": [
      "GitHub",
      "AWS",
      "GitLab",
      "Slack",
      "Trello",
      "Jira"
    ],
    "faq": [
      {
        "q": "What is included in the Custom Software Development service?",
        "a": "Each Custom Software Development engagement includes Source code, application, delivered within 3 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Custom Software Development?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Custom Software Development?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (GitHub, AWS, GitLab, Slack)."
      },
      {
        "q": "How many revisions are included in Custom Software Development?",
        "a": "Each Custom Software Development engagement includes Source code, application, delivered within 3 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Custom Software Development?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-028",
    "slug": "python-scripting",
    "title": "Python Scripting",
    "category": "web-mobile",
    "icon": "Code2",
    "description": "Automate tasks with Python scripts",
    "valueProp": "Automate tasks with Python scripts",
    "tagline": "Automate tasks with Python scripts",
    "deliverable": "Source code, application",
    "tiers": {
      "basic": 187,
      "standard": 396,
      "premium": 748
    },
    "days": 3,
    "subscriptionAvailable": true,
    "steps": [
      "Gather requirements and objectives",
      "Architect the solution",
      "Develop and test each component",
      "Deploy in your environment",
      "And provide post‑launch support and maintenance"
    ],
    "integrations": [
      "GitHub",
      "AWS",
      "GitLab",
      "Slack",
      "Trello",
      "Jira"
    ],
    "faq": [
      {
        "q": "What is included in the Python Scripting service?",
        "a": "Each Python Scripting engagement includes Source code, application, delivered within 3 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Python Scripting?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Python Scripting?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (GitHub, AWS, GitLab, Slack)."
      },
      {
        "q": "How many revisions are included in Python Scripting?",
        "a": "Each Python Scripting engagement includes Source code, application, delivered within 3 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Python Scripting?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-029",
    "slug": "cybersecurity-assessment",
    "title": "Cybersecurity Assessment",
    "category": "web-mobile",
    "icon": "Code2",
    "description": "Assess and improve security posture",
    "valueProp": "Assess and improve security posture",
    "tagline": "Assess and improve security posture",
    "deliverable": "Source code, application",
    "tiers": {
      "basic": 185,
      "standard": 309,
      "premium": 809
    },
    "days": 3,
    "subscriptionAvailable": true,
    "steps": [
      "Gather requirements and objectives",
      "Architect the solution",
      "Develop and test each component",
      "Deploy in your environment",
      "And provide post‑launch support and maintenance"
    ],
    "integrations": [
      "GitHub",
      "AWS",
      "GitLab",
      "Slack",
      "Trello",
      "Jira"
    ],
    "faq": [
      {
        "q": "What is included in the Cybersecurity Assessment service?",
        "a": "Each Cybersecurity Assessment engagement includes Source code, application, delivered within 3 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Cybersecurity Assessment?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Cybersecurity Assessment?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (GitHub, AWS, GitLab, Slack)."
      },
      {
        "q": "How many revisions are included in Cybersecurity Assessment?",
        "a": "Each Cybersecurity Assessment engagement includes Source code, application, delivered within 3 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Cybersecurity Assessment?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-030",
    "slug": "cloud-architecture",
    "title": "Cloud Architecture",
    "category": "web-mobile",
    "icon": "Code2",
    "description": "Design and deploy cloud infrastructure",
    "valueProp": "Design and deploy cloud infrastructure",
    "tagline": "Design and deploy cloud infrastructure",
    "deliverable": "Source code, application",
    "tiers": {
      "basic": 108,
      "standard": 234,
      "premium": 782
    },
    "days": 10,
    "subscriptionAvailable": true,
    "steps": [
      "Gather requirements and objectives",
      "Architect the solution",
      "Develop and test each component",
      "Deploy in your environment",
      "And provide post‑launch support and maintenance"
    ],
    "integrations": [
      "GitHub",
      "AWS",
      "GitLab",
      "Slack",
      "Trello",
      "Jira"
    ],
    "faq": [
      {
        "q": "What is included in the Cloud Architecture service?",
        "a": "Each Cloud Architecture engagement includes Source code, application, delivered within 10 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Cloud Architecture?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Cloud Architecture?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (GitHub, AWS, GitLab, Slack)."
      },
      {
        "q": "How many revisions are included in Cloud Architecture?",
        "a": "Each Cloud Architecture engagement includes Source code, application, delivered within 10 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Cloud Architecture?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-031",
    "slug": "saas-product-development",
    "title": "SaaS Product Development",
    "category": "web-mobile",
    "icon": "Code2",
    "description": "Create software-as-a-service products",
    "valueProp": "Create software-as-a-service products",
    "tagline": "Create software-as-a-service products",
    "deliverable": "Source code, application",
    "tiers": {
      "basic": 193,
      "standard": 316,
      "premium": 557
    },
    "days": 5,
    "subscriptionAvailable": true,
    "steps": [
      "Gather requirements and objectives",
      "Architect the solution",
      "Develop and test each component",
      "Deploy in your environment",
      "And provide post‑launch support and maintenance"
    ],
    "integrations": [
      "GitHub",
      "AWS",
      "GitLab",
      "Slack",
      "Trello",
      "Jira"
    ],
    "faq": [
      {
        "q": "What is included in the SaaS Product Development service?",
        "a": "Each SaaS Product Development engagement includes Source code, application, delivered within 5 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for SaaS Product Development?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start SaaS Product Development?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (GitHub, AWS, GitLab, Slack)."
      },
      {
        "q": "How many revisions are included in SaaS Product Development?",
        "a": "Each SaaS Product Development engagement includes Source code, application, delivered within 5 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after SaaS Product Development?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-032",
    "slug": "blockchain-development",
    "title": "Blockchain Development",
    "category": "web-mobile",
    "icon": "Code2",
    "description": "Develop blockchain-based applications",
    "valueProp": "Develop blockchain-based applications",
    "tagline": "Develop blockchain-based applications",
    "deliverable": "Source code, application",
    "tiers": {
      "basic": 177,
      "standard": 204,
      "premium": 780
    },
    "days": 10,
    "subscriptionAvailable": true,
    "steps": [
      "Gather requirements and objectives",
      "Architect the solution",
      "Develop and test each component",
      "Deploy in your environment",
      "And provide post‑launch support and maintenance"
    ],
    "integrations": [
      "GitHub",
      "AWS",
      "GitLab",
      "Slack",
      "Trello",
      "Jira"
    ],
    "faq": [
      {
        "q": "What is included in the Blockchain Development service?",
        "a": "Each Blockchain Development engagement includes Source code, application, delivered within 10 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Blockchain Development?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Blockchain Development?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (GitHub, AWS, GitLab, Slack)."
      },
      {
        "q": "How many revisions are included in Blockchain Development?",
        "a": "Each Blockchain Development engagement includes Source code, application, delivered within 10 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Blockchain Development?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-033",
    "slug": "data-engineering",
    "title": "Data Engineering",
    "category": "web-mobile",
    "icon": "Code2",
    "description": "Build data pipelines and ETL processes",
    "valueProp": "Build data pipelines and ETL processes",
    "tagline": "Build data pipelines and ETL processes",
    "deliverable": "Source code, application",
    "tiers": {
      "basic": 132,
      "standard": 459,
      "premium": 607
    },
    "days": 9,
    "subscriptionAvailable": true,
    "steps": [
      "Gather requirements and objectives",
      "Architect the solution",
      "Develop and test each component",
      "Deploy in your environment",
      "And provide post‑launch support and maintenance"
    ],
    "integrations": [
      "GitHub",
      "AWS",
      "GitLab",
      "Slack",
      "Trello",
      "Jira"
    ],
    "faq": [
      {
        "q": "What is included in the Data Engineering service?",
        "a": "Each Data Engineering engagement includes Source code, application, delivered within 9 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Data Engineering?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Data Engineering?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (GitHub, AWS, GitLab, Slack)."
      },
      {
        "q": "How many revisions are included in Data Engineering?",
        "a": "Each Data Engineering engagement includes Source code, application, delivered within 9 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Data Engineering?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-034",
    "slug": "crm-customization",
    "title": "CRM Customization",
    "category": "web-mobile",
    "icon": "Code2",
    "description": "Customize CRM systems to business needs",
    "valueProp": "Customize CRM systems to business needs",
    "tagline": "Customize CRM systems to business needs",
    "deliverable": "Source code, application",
    "tiers": {
      "basic": 178,
      "standard": 443,
      "premium": 799
    },
    "days": 4,
    "subscriptionAvailable": true,
    "steps": [
      "Gather requirements and objectives",
      "Architect the solution",
      "Develop and test each component",
      "Deploy in your environment",
      "And provide post‑launch support and maintenance"
    ],
    "integrations": [
      "GitHub",
      "AWS",
      "GitLab",
      "Slack",
      "Trello",
      "Jira"
    ],
    "faq": [
      {
        "q": "What is included in the CRM Customization service?",
        "a": "Each CRM Customization engagement includes Source code, application, delivered within 4 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for CRM Customization?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start CRM Customization?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (GitHub, AWS, GitLab, Slack)."
      },
      {
        "q": "How many revisions are included in CRM Customization?",
        "a": "Each CRM Customization engagement includes Source code, application, delivered within 4 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after CRM Customization?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-035",
    "slug": "erp-integration",
    "title": "ERP Integration",
    "category": "web-mobile",
    "icon": "Code2",
    "description": "Integrate ERP solutions for efficiency",
    "valueProp": "Integrate ERP solutions for efficiency",
    "tagline": "Integrate ERP solutions for efficiency",
    "deliverable": "Source code, application",
    "tiers": {
      "basic": 145,
      "standard": 461,
      "premium": 845
    },
    "days": 3,
    "subscriptionAvailable": true,
    "steps": [
      "Gather requirements and objectives",
      "Architect the solution",
      "Develop and test each component",
      "Deploy in your environment",
      "And provide post‑launch support and maintenance"
    ],
    "integrations": [
      "GitHub",
      "AWS",
      "GitLab",
      "Slack",
      "Trello",
      "Jira"
    ],
    "faq": [
      {
        "q": "What is included in the ERP Integration service?",
        "a": "Each ERP Integration engagement includes Source code, application, delivered within 3 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for ERP Integration?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start ERP Integration?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (GitHub, AWS, GitLab, Slack)."
      },
      {
        "q": "How many revisions are included in ERP Integration?",
        "a": "Each ERP Integration engagement includes Source code, application, delivered within 3 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after ERP Integration?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-036",
    "slug": "cms-development",
    "title": "CMS Development",
    "category": "web-mobile",
    "icon": "Code2",
    "description": "Develop content management systems",
    "valueProp": "Develop content management systems",
    "tagline": "Develop content management systems",
    "deliverable": "Source code, application",
    "tiers": {
      "basic": 120,
      "standard": 465,
      "premium": 555
    },
    "days": 12,
    "subscriptionAvailable": true,
    "steps": [
      "Gather requirements and objectives",
      "Architect the solution",
      "Develop and test each component",
      "Deploy in your environment",
      "And provide post‑launch support and maintenance"
    ],
    "integrations": [
      "GitHub",
      "AWS",
      "GitLab",
      "Slack",
      "Trello",
      "Jira"
    ],
    "faq": [
      {
        "q": "What is included in the CMS Development service?",
        "a": "Each CMS Development engagement includes Source code, application, delivered within 12 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for CMS Development?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start CMS Development?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (GitHub, AWS, GitLab, Slack)."
      },
      {
        "q": "How many revisions are included in CMS Development?",
        "a": "Each CMS Development engagement includes Source code, application, delivered within 12 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after CMS Development?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-037",
    "slug": "chatbot-integration",
    "title": "Chatbot Integration",
    "category": "web-mobile",
    "icon": "Code2",
    "description": "Integrate chatbots into websites",
    "valueProp": "Integrate chatbots into websites",
    "tagline": "Integrate chatbots into websites",
    "deliverable": "Source code, application",
    "tiers": {
      "basic": 178,
      "standard": 432,
      "premium": 735
    },
    "days": 11,
    "subscriptionAvailable": true,
    "steps": [
      "Gather requirements and objectives",
      "Architect the solution",
      "Develop and test each component",
      "Deploy in your environment",
      "And provide post‑launch support and maintenance"
    ],
    "integrations": [
      "GitHub",
      "AWS",
      "GitLab",
      "Slack",
      "Trello",
      "Jira"
    ],
    "faq": [
      {
        "q": "What is included in the Chatbot Integration service?",
        "a": "Each Chatbot Integration engagement includes Source code, application, delivered within 11 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Chatbot Integration?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Chatbot Integration?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (GitHub, AWS, GitLab, Slack)."
      },
      {
        "q": "How many revisions are included in Chatbot Integration?",
        "a": "Each Chatbot Integration engagement includes Source code, application, delivered within 11 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Chatbot Integration?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-038",
    "slug": "iot-application-development",
    "title": "IoT Application Development",
    "category": "web-mobile",
    "icon": "Code2",
    "description": "Develop Internet of Things solutions",
    "valueProp": "Develop Internet of Things solutions",
    "tagline": "Develop Internet of Things solutions",
    "deliverable": "Source code, application",
    "tiers": {
      "basic": 166,
      "standard": 334,
      "premium": 756
    },
    "days": 6,
    "subscriptionAvailable": true,
    "steps": [
      "Gather requirements and objectives",
      "Architect the solution",
      "Develop and test each component",
      "Deploy in your environment",
      "And provide post‑launch support and maintenance"
    ],
    "integrations": [
      "GitHub",
      "AWS",
      "GitLab",
      "Slack",
      "Trello",
      "Jira"
    ],
    "faq": [
      {
        "q": "What is included in the IoT Application Development service?",
        "a": "Each IoT Application Development engagement includes Source code, application, delivered within 6 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for IoT Application Development?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start IoT Application Development?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (GitHub, AWS, GitLab, Slack)."
      },
      {
        "q": "How many revisions are included in IoT Application Development?",
        "a": "Each IoT Application Development engagement includes Source code, application, delivered within 6 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after IoT Application Development?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-039",
    "slug": "devops-automation",
    "title": "DevOps Automation",
    "category": "web-mobile",
    "icon": "Code2",
    "description": "Implement CI/CD and automation pipelines",
    "valueProp": "Implement CI/CD and automation pipelines",
    "tagline": "Implement CI/CD and automation pipelines",
    "deliverable": "Source code, application",
    "tiers": {
      "basic": 104,
      "standard": 261,
      "premium": 723
    },
    "days": 13,
    "subscriptionAvailable": true,
    "steps": [
      "Gather requirements and objectives",
      "Architect the solution",
      "Develop and test each component",
      "Deploy in your environment",
      "And provide post‑launch support and maintenance"
    ],
    "integrations": [
      "GitHub",
      "AWS",
      "GitLab",
      "Slack",
      "Trello",
      "Jira"
    ],
    "faq": [
      {
        "q": "What is included in the DevOps Automation service?",
        "a": "Each DevOps Automation engagement includes Source code, application, delivered within 13 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for DevOps Automation?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start DevOps Automation?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (GitHub, AWS, GitLab, Slack)."
      },
      {
        "q": "How many revisions are included in DevOps Automation?",
        "a": "Each DevOps Automation engagement includes Source code, application, delivered within 13 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after DevOps Automation?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-040",
    "slug": "api-documentation",
    "title": "API Documentation",
    "category": "web-mobile",
    "icon": "Code2",
    "description": "Write documentation for APIs",
    "valueProp": "Write documentation for APIs",
    "tagline": "Write documentation for APIs",
    "deliverable": "Source code, application",
    "tiers": {
      "basic": 113,
      "standard": 330,
      "premium": 801
    },
    "days": 14,
    "subscriptionAvailable": true,
    "steps": [
      "Gather requirements and objectives",
      "Architect the solution",
      "Develop and test each component",
      "Deploy in your environment",
      "And provide post‑launch support and maintenance"
    ],
    "integrations": [
      "GitHub",
      "AWS",
      "GitLab",
      "Slack",
      "Trello",
      "Jira"
    ],
    "faq": [
      {
        "q": "What is included in the API Documentation service?",
        "a": "Each API Documentation engagement includes Source code, application, delivered within 14 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for API Documentation?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start API Documentation?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (GitHub, AWS, GitLab, Slack)."
      },
      {
        "q": "How many revisions are included in API Documentation?",
        "a": "Each API Documentation engagement includes Source code, application, delivered within 14 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after API Documentation?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-041",
    "slug": "database-design",
    "title": "Database Design",
    "category": "web-mobile",
    "icon": "Code2",
    "description": "Design efficient database schemas",
    "valueProp": "Design efficient database schemas",
    "tagline": "Design efficient database schemas",
    "deliverable": "Source code, application",
    "tiers": {
      "basic": 150,
      "standard": 450,
      "premium": 587
    },
    "days": 7,
    "subscriptionAvailable": true,
    "steps": [
      "Gather requirements and objectives",
      "Architect the solution",
      "Develop and test each component",
      "Deploy in your environment",
      "And provide post‑launch support and maintenance"
    ],
    "integrations": [
      "GitHub",
      "AWS",
      "GitLab",
      "Slack",
      "Trello",
      "Jira"
    ],
    "faq": [
      {
        "q": "What is included in the Database Design service?",
        "a": "Each Database Design engagement includes Source code, application, delivered within 7 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Database Design?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Database Design?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (GitHub, AWS, GitLab, Slack)."
      },
      {
        "q": "How many revisions are included in Database Design?",
        "a": "Each Database Design engagement includes Source code, application, delivered within 7 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Database Design?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-042",
    "slug": "microservices-architecture",
    "title": "Microservices Architecture",
    "category": "web-mobile",
    "icon": "Code2",
    "description": "Architect microservices for scalability",
    "valueProp": "Architect microservices for scalability",
    "tagline": "Architect microservices for scalability",
    "deliverable": "Source code, application",
    "tiers": {
      "basic": 112,
      "standard": 442,
      "premium": 993
    },
    "days": 14,
    "subscriptionAvailable": true,
    "steps": [
      "Gather requirements and objectives",
      "Architect the solution",
      "Develop and test each component",
      "Deploy in your environment",
      "And provide post‑launch support and maintenance"
    ],
    "integrations": [
      "GitHub",
      "AWS",
      "GitLab",
      "Slack",
      "Trello",
      "Jira"
    ],
    "faq": [
      {
        "q": "What is included in the Microservices Architecture service?",
        "a": "Each Microservices Architecture engagement includes Source code, application, delivered within 14 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Microservices Architecture?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Microservices Architecture?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (GitHub, AWS, GitLab, Slack)."
      },
      {
        "q": "How many revisions are included in Microservices Architecture?",
        "a": "Each Microservices Architecture engagement includes Source code, application, delivered within 14 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Microservices Architecture?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-043",
    "slug": "quality-assurance-testing",
    "title": "Quality Assurance Testing",
    "category": "web-mobile",
    "icon": "Code2",
    "description": "Perform manual and automated QA testing",
    "valueProp": "Perform manual and automated QA testing",
    "tagline": "Perform manual and automated QA testing",
    "deliverable": "Source code, application",
    "tiers": {
      "basic": 200,
      "standard": 403,
      "premium": 742
    },
    "days": 5,
    "subscriptionAvailable": true,
    "steps": [
      "Gather requirements and objectives",
      "Architect the solution",
      "Develop and test each component",
      "Deploy in your environment",
      "And provide post‑launch support and maintenance"
    ],
    "integrations": [
      "GitHub",
      "AWS",
      "GitLab",
      "Slack",
      "Trello",
      "Jira"
    ],
    "faq": [
      {
        "q": "What is included in the Quality Assurance Testing service?",
        "a": "Each Quality Assurance Testing engagement includes Source code, application, delivered within 5 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Quality Assurance Testing?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Quality Assurance Testing?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "How many revisions are included in Quality Assurance Testing?",
        "a": "Each Quality Assurance Testing engagement includes Source code, application, delivered within 5 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Quality Assurance Testing?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      }
    ]
  },
  {
    "id": "reg-044",
    "slug": "it-support-and-maintenance",
    "title": "IT Support & Maintenance",
    "category": "web-mobile",
    "icon": "Code2",
    "description": "Provide ongoing IT support",
    "valueProp": "Provide ongoing IT support",
    "tagline": "Provide ongoing IT support",
    "deliverable": "Source code, application",
    "tiers": {
      "basic": 197,
      "standard": 365,
      "premium": 812
    },
    "days": 6,
    "subscriptionAvailable": true,
    "steps": [
      "Gather requirements and objectives",
      "Architect the solution",
      "Develop and test each component",
      "Deploy in your environment",
      "And provide post‑launch support and maintenance"
    ],
    "integrations": [
      "GitHub",
      "AWS",
      "GitLab",
      "Slack",
      "Trello",
      "Jira"
    ],
    "faq": [
      {
        "q": "What is included in the IT Support & Maintenance service?",
        "a": "Each IT Support & Maintenance engagement includes Source code, application, delivered within 6 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for IT Support & Maintenance?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start IT Support & Maintenance?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (GitHub, AWS, GitLab, Slack)."
      },
      {
        "q": "How many revisions are included in IT Support & Maintenance?",
        "a": "Each IT Support & Maintenance engagement includes Source code, application, delivered within 6 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after IT Support & Maintenance?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-045",
    "slug": "network-setup-and-configuration",
    "title": "Network Setup & Configuration",
    "category": "web-mobile",
    "icon": "Code2",
    "description": "Set up and configure business networks",
    "valueProp": "Set up and configure business networks",
    "tagline": "Set up and configure business networks",
    "deliverable": "Source code, application",
    "tiers": {
      "basic": 152,
      "standard": 422,
      "premium": 594
    },
    "days": 8,
    "subscriptionAvailable": true,
    "steps": [
      "Gather requirements and objectives",
      "Architect the solution",
      "Develop and test each component",
      "Deploy in your environment",
      "And provide post‑launch support and maintenance"
    ],
    "integrations": [
      "GitHub",
      "AWS",
      "GitLab",
      "Slack",
      "Trello",
      "Jira"
    ],
    "faq": [
      {
        "q": "What is included in the Network Setup & Configuration service?",
        "a": "Each Network Setup & Configuration engagement includes Source code, application, delivered within 8 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Network Setup & Configuration?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Network Setup & Configuration?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (GitHub, AWS, GitLab, Slack)."
      },
      {
        "q": "How many revisions are included in Network Setup & Configuration?",
        "a": "Each Network Setup & Configuration engagement includes Source code, application, delivered within 8 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Network Setup & Configuration?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-046",
    "slug": "logo-design",
    "title": "Logo Design",
    "category": "branding-design",
    "icon": "Palette",
    "description": "Create distinctive logos for brands",
    "valueProp": "Create distinctive logos for brands",
    "tagline": "Create distinctive logos for brands",
    "deliverable": "Design files (PNG, PSD)",
    "tiers": {
      "basic": 137,
      "standard": 319,
      "premium": 658
    },
    "days": 4,
    "subscriptionAvailable": false,
    "steps": [
      "Gather brand guidelines and preferences",
      "Create initial concepts",
      "Iterate with feedback",
      "Finalize the chosen design",
      "And deliver all files ready for use"
    ],
    "integrations": [
      "Adobe Creative Suite",
      "Figma",
      "Canva",
      "Sketch"
    ],
    "faq": [
      {
        "q": "What is included in the Logo Design service?",
        "a": "Each Logo Design engagement includes Design files (PNG, PSD), delivered within 4 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Logo Design?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Logo Design?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Adobe Creative Suite, Figma, Canva, Sketch)."
      },
      {
        "q": "How many revisions are included in Logo Design?",
        "a": "Each Logo Design engagement includes Design files (PNG, PSD), delivered within 4 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Logo Design?",
        "a": "A 14-day support window is included after delivery for adjustments and bug fixes. Longer engagements can be quoted on request."
      }
    ]
  },
  {
    "id": "reg-047",
    "slug": "brand-identity-design",
    "title": "Brand Identity Design",
    "category": "branding-design",
    "icon": "Palette",
    "description": "Develop cohesive visual identity systems",
    "valueProp": "Develop cohesive visual identity systems",
    "tagline": "Develop cohesive visual identity systems",
    "deliverable": "Design files (PNG, PSD)",
    "tiers": {
      "basic": 115,
      "standard": 244,
      "premium": 783
    },
    "days": 10,
    "subscriptionAvailable": false,
    "steps": [
      "Gather brand guidelines and preferences",
      "Create initial concepts",
      "Iterate with feedback",
      "Finalize the chosen design",
      "And deliver all files ready for use"
    ],
    "integrations": [
      "Adobe Creative Suite",
      "Figma",
      "Canva",
      "Sketch"
    ],
    "faq": [
      {
        "q": "What is included in the Brand Identity Design service?",
        "a": "Each Brand Identity Design engagement includes Design files (PNG, PSD), delivered within 10 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Brand Identity Design?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Brand Identity Design?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Adobe Creative Suite, Figma, Canva, Sketch)."
      },
      {
        "q": "How many revisions are included in Brand Identity Design?",
        "a": "Each Brand Identity Design engagement includes Design files (PNG, PSD), delivered within 10 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Brand Identity Design?",
        "a": "A 14-day support window is included after delivery for adjustments and bug fixes. Longer engagements can be quoted on request."
      }
    ]
  },
  {
    "id": "reg-048",
    "slug": "graphic-design",
    "title": "Graphic Design",
    "category": "branding-design",
    "icon": "Palette",
    "description": "Produce visual assets for campaigns",
    "valueProp": "Produce visual assets for campaigns",
    "tagline": "Produce visual assets for campaigns",
    "deliverable": "Design files (PNG, PSD)",
    "tiers": {
      "basic": 126,
      "standard": 302,
      "premium": 624
    },
    "days": 2,
    "subscriptionAvailable": false,
    "steps": [
      "Gather brand guidelines and preferences",
      "Create initial concepts",
      "Iterate with feedback",
      "Finalize the chosen design",
      "And deliver all files ready for use"
    ],
    "integrations": [
      "Adobe Creative Suite",
      "Figma",
      "Canva",
      "Sketch"
    ],
    "faq": [
      {
        "q": "What is included in the Graphic Design service?",
        "a": "Each Graphic Design engagement includes Design files (PNG, PSD), delivered within 2 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Graphic Design?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Graphic Design?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Adobe Creative Suite, Figma, Canva, Sketch)."
      },
      {
        "q": "How many revisions are included in Graphic Design?",
        "a": "Each Graphic Design engagement includes Design files (PNG, PSD), delivered within 2 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Graphic Design?",
        "a": "A 14-day support window is included after delivery for adjustments and bug fixes. Longer engagements can be quoted on request."
      }
    ]
  },
  {
    "id": "reg-049",
    "slug": "illustration",
    "title": "Illustration",
    "category": "branding-design",
    "icon": "Palette",
    "description": "Provide custom artwork and illustrations",
    "valueProp": "Provide custom artwork and illustrations",
    "tagline": "Provide custom artwork and illustrations",
    "deliverable": "Design files (PNG, PSD)",
    "tiers": {
      "basic": 112,
      "standard": 245,
      "premium": 541
    },
    "days": 10,
    "subscriptionAvailable": false,
    "steps": [
      "Gather brand guidelines and preferences",
      "Create initial concepts",
      "Iterate with feedback",
      "Finalize the chosen design",
      "And deliver all files ready for use"
    ],
    "integrations": [
      "Adobe Creative Suite",
      "Figma",
      "Canva",
      "Sketch"
    ],
    "faq": [
      {
        "q": "What is included in the Illustration service?",
        "a": "Each Illustration engagement includes Design files (PNG, PSD), delivered within 10 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Illustration?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Illustration?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Adobe Creative Suite, Figma, Canva, Sketch)."
      },
      {
        "q": "How many revisions are included in Illustration?",
        "a": "Each Illustration engagement includes Design files (PNG, PSD), delivered within 10 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Illustration?",
        "a": "A 14-day support window is included after delivery for adjustments and bug fixes. Longer engagements can be quoted on request."
      }
    ]
  },
  {
    "id": "reg-050",
    "slug": "photo-editing",
    "title": "Photo Editing",
    "category": "branding-design",
    "icon": "Palette",
    "description": "Retouch and enhance photos",
    "valueProp": "Retouch and enhance photos",
    "tagline": "Retouch and enhance photos",
    "deliverable": "Design files (PNG, PSD)",
    "tiers": {
      "basic": 85,
      "standard": 327,
      "premium": 597
    },
    "days": 9,
    "subscriptionAvailable": false,
    "steps": [
      "Gather brand guidelines and preferences",
      "Create initial concepts",
      "Iterate with feedback",
      "Finalize the chosen design",
      "And deliver all files ready for use"
    ],
    "integrations": [
      "Adobe Creative Suite",
      "Figma",
      "Canva",
      "Sketch"
    ],
    "faq": [
      {
        "q": "What is included in the Photo Editing service?",
        "a": "Each Photo Editing engagement includes Design files (PNG, PSD), delivered within 9 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Photo Editing?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Photo Editing?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Adobe Creative Suite, Figma, Canva, Sketch)."
      },
      {
        "q": "How many revisions are included in Photo Editing?",
        "a": "Each Photo Editing engagement includes Design files (PNG, PSD), delivered within 9 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Photo Editing?",
        "a": "A 14-day support window is included after delivery for adjustments and bug fixes. Longer engagements can be quoted on request."
      }
    ]
  },
  {
    "id": "reg-051",
    "slug": "video-editing",
    "title": "Video Editing",
    "category": "branding-design",
    "icon": "Palette",
    "description": "Edit videos for various platforms",
    "valueProp": "Edit videos for various platforms",
    "tagline": "Edit videos for various platforms",
    "deliverable": "Design files (PNG, PSD)",
    "tiers": {
      "basic": 56,
      "standard": 201,
      "premium": 520
    },
    "days": 4,
    "subscriptionAvailable": false,
    "steps": [
      "Gather brand guidelines and preferences",
      "Create initial concepts",
      "Iterate with feedback",
      "Finalize the chosen design",
      "And deliver all files ready for use"
    ],
    "integrations": [
      "Adobe Creative Suite",
      "Figma",
      "Canva",
      "Sketch"
    ],
    "faq": [
      {
        "q": "What is included in the Video Editing service?",
        "a": "Each Video Editing engagement includes Design files (PNG, PSD), delivered within 4 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Video Editing?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Video Editing?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Adobe Creative Suite, Figma, Canva, Sketch)."
      },
      {
        "q": "How many revisions are included in Video Editing?",
        "a": "Each Video Editing engagement includes Design files (PNG, PSD), delivered within 4 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Video Editing?",
        "a": "A 14-day support window is included after delivery for adjustments and bug fixes. Longer engagements can be quoted on request."
      }
    ]
  },
  {
    "id": "reg-052",
    "slug": "3d-modeling-and-rendering",
    "title": "3D Modeling & Rendering",
    "category": "branding-design",
    "icon": "Palette",
    "description": "Create 3D assets and renders",
    "valueProp": "Create 3D assets and renders",
    "tagline": "Create 3D assets and renders",
    "deliverable": "Design files (PNG, PSD)",
    "tiers": {
      "basic": 119,
      "standard": 206,
      "premium": 657
    },
    "days": 7,
    "subscriptionAvailable": false,
    "steps": [
      "Gather brand guidelines and preferences",
      "Create initial concepts",
      "Iterate with feedback",
      "Finalize the chosen design",
      "And deliver all files ready for use"
    ],
    "integrations": [
      "Adobe Creative Suite",
      "Figma",
      "Canva",
      "Sketch"
    ],
    "faq": [
      {
        "q": "What is included in the 3D Modeling & Rendering service?",
        "a": "Each 3D Modeling & Rendering engagement includes Design files (PNG, PSD), delivered within 7 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for 3D Modeling & Rendering?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start 3D Modeling & Rendering?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Adobe Creative Suite, Figma, Canva, Sketch)."
      },
      {
        "q": "How many revisions are included in 3D Modeling & Rendering?",
        "a": "Each 3D Modeling & Rendering engagement includes Design files (PNG, PSD), delivered within 7 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after 3D Modeling & Rendering?",
        "a": "A 14-day support window is included after delivery for adjustments and bug fixes. Longer engagements can be quoted on request."
      }
    ]
  },
  {
    "id": "reg-053",
    "slug": "cad-design",
    "title": "CAD Design",
    "category": "branding-design",
    "icon": "Palette",
    "description": "Produce technical drawings and models",
    "valueProp": "Produce technical drawings and models",
    "tagline": "Produce technical drawings and models",
    "deliverable": "Design files (PNG, PSD)",
    "tiers": {
      "basic": 67,
      "standard": 344,
      "premium": 553
    },
    "days": 6,
    "subscriptionAvailable": false,
    "steps": [
      "Gather brand guidelines and preferences",
      "Create initial concepts",
      "Iterate with feedback",
      "Finalize the chosen design",
      "And deliver all files ready for use"
    ],
    "integrations": [
      "Adobe Creative Suite",
      "Figma",
      "Canva",
      "Sketch"
    ],
    "faq": [
      {
        "q": "What is included in the CAD Design service?",
        "a": "Each CAD Design engagement includes Design files (PNG, PSD), delivered within 6 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for CAD Design?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start CAD Design?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Adobe Creative Suite, Figma, Canva, Sketch)."
      },
      {
        "q": "How many revisions are included in CAD Design?",
        "a": "Each CAD Design engagement includes Design files (PNG, PSD), delivered within 6 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after CAD Design?",
        "a": "A 14-day support window is included after delivery for adjustments and bug fixes. Longer engagements can be quoted on request."
      }
    ]
  },
  {
    "id": "reg-054",
    "slug": "ux-ui-design",
    "title": "UX/UI Design",
    "category": "branding-design",
    "icon": "Palette",
    "description": "Design user interfaces with research",
    "valueProp": "Design user interfaces with research",
    "tagline": "Design user interfaces with research",
    "deliverable": "Design files (PNG, PSD)",
    "tiers": {
      "basic": 89,
      "standard": 373,
      "premium": 472
    },
    "days": 3,
    "subscriptionAvailable": false,
    "steps": [
      "Gather brand guidelines and preferences",
      "Create initial concepts",
      "Iterate with feedback",
      "Finalize the chosen design",
      "And deliver all files ready for use"
    ],
    "integrations": [
      "Adobe Creative Suite",
      "Figma",
      "Canva",
      "Sketch"
    ],
    "faq": [
      {
        "q": "What is included in the UX/UI Design service?",
        "a": "Each UX/UI Design engagement includes Design files (PNG, PSD), delivered within 3 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for UX/UI Design?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start UX/UI Design?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Adobe Creative Suite, Figma, Canva, Sketch)."
      },
      {
        "q": "How many revisions are included in UX/UI Design?",
        "a": "Each UX/UI Design engagement includes Design files (PNG, PSD), delivered within 3 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after UX/UI Design?",
        "a": "A 14-day support window is included after delivery for adjustments and bug fixes. Longer engagements can be quoted on request."
      }
    ]
  },
  {
    "id": "reg-055",
    "slug": "presentation-design",
    "title": "Presentation Design",
    "category": "branding-design",
    "icon": "Palette",
    "description": "Create compelling presentations",
    "valueProp": "Create compelling presentations",
    "tagline": "Create compelling presentations",
    "deliverable": "Design files (PNG, PSD)",
    "tiers": {
      "basic": 131,
      "standard": 308,
      "premium": 648
    },
    "days": 7,
    "subscriptionAvailable": false,
    "steps": [
      "Gather brand guidelines and preferences",
      "Create initial concepts",
      "Iterate with feedback",
      "Finalize the chosen design",
      "And deliver all files ready for use"
    ],
    "integrations": [
      "Adobe Creative Suite",
      "Figma",
      "Canva",
      "Sketch"
    ],
    "faq": [
      {
        "q": "What is included in the Presentation Design service?",
        "a": "Each Presentation Design engagement includes Design files (PNG, PSD), delivered within 7 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Presentation Design?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Presentation Design?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Adobe Creative Suite, Figma, Canva, Sketch)."
      },
      {
        "q": "How many revisions are included in Presentation Design?",
        "a": "Each Presentation Design engagement includes Design files (PNG, PSD), delivered within 7 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Presentation Design?",
        "a": "A 14-day support window is included after delivery for adjustments and bug fixes. Longer engagements can be quoted on request."
      }
    ]
  },
  {
    "id": "reg-056",
    "slug": "book-cover-design",
    "title": "Book Cover Design",
    "category": "branding-design",
    "icon": "Palette",
    "description": "Design covers for books and ebooks",
    "valueProp": "Design covers for books and ebooks",
    "tagline": "Design covers for books and ebooks",
    "deliverable": "Design files (PNG, PSD)",
    "tiers": {
      "basic": 148,
      "standard": 333,
      "premium": 654
    },
    "days": 5,
    "subscriptionAvailable": false,
    "steps": [
      "Gather brand guidelines and preferences",
      "Create initial concepts",
      "Iterate with feedback",
      "Finalize the chosen design",
      "And deliver all files ready for use"
    ],
    "integrations": [
      "Adobe Creative Suite",
      "Figma",
      "Canva",
      "Sketch"
    ],
    "faq": [
      {
        "q": "What is included in the Book Cover Design service?",
        "a": "Each Book Cover Design engagement includes Design files (PNG, PSD), delivered within 5 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Book Cover Design?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Book Cover Design?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Adobe Creative Suite, Figma, Canva, Sketch)."
      },
      {
        "q": "How many revisions are included in Book Cover Design?",
        "a": "Each Book Cover Design engagement includes Design files (PNG, PSD), delivered within 5 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Book Cover Design?",
        "a": "A 14-day support window is included after delivery for adjustments and bug fixes. Longer engagements can be quoted on request."
      }
    ]
  },
  {
    "id": "reg-057",
    "slug": "packaging-design",
    "title": "Packaging Design",
    "category": "branding-design",
    "icon": "Palette",
    "description": "Design packaging for products",
    "valueProp": "Design packaging for products",
    "tagline": "Design packaging for products",
    "deliverable": "Design files (PNG, PSD)",
    "tiers": {
      "basic": 61,
      "standard": 333,
      "premium": 705
    },
    "days": 9,
    "subscriptionAvailable": false,
    "steps": [
      "Gather brand guidelines and preferences",
      "Create initial concepts",
      "Iterate with feedback",
      "Finalize the chosen design",
      "And deliver all files ready for use"
    ],
    "integrations": [
      "Adobe Creative Suite",
      "Figma",
      "Canva",
      "Sketch"
    ],
    "faq": [
      {
        "q": "What is included in the Packaging Design service?",
        "a": "Each Packaging Design engagement includes Design files (PNG, PSD), delivered within 9 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Packaging Design?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Packaging Design?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Adobe Creative Suite, Figma, Canva, Sketch)."
      },
      {
        "q": "How many revisions are included in Packaging Design?",
        "a": "Each Packaging Design engagement includes Design files (PNG, PSD), delivered within 9 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Packaging Design?",
        "a": "A 14-day support window is included after delivery for adjustments and bug fixes. Longer engagements can be quoted on request."
      }
    ]
  },
  {
    "id": "reg-058",
    "slug": "infographic-design",
    "title": "Infographic Design",
    "category": "branding-design",
    "icon": "Palette",
    "description": "Create infographics for data storytelling",
    "valueProp": "Create infographics for data storytelling",
    "tagline": "Create infographics for data storytelling",
    "deliverable": "Design files (PNG, PSD)",
    "tiers": {
      "basic": 74,
      "standard": 256,
      "premium": 599
    },
    "days": 4,
    "subscriptionAvailable": false,
    "steps": [
      "Gather brand guidelines and preferences",
      "Create initial concepts",
      "Iterate with feedback",
      "Finalize the chosen design",
      "And deliver all files ready for use"
    ],
    "integrations": [
      "Adobe Creative Suite",
      "Figma",
      "Canva",
      "Sketch"
    ],
    "faq": [
      {
        "q": "What is included in the Infographic Design service?",
        "a": "Each Infographic Design engagement includes Design files (PNG, PSD), delivered within 4 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Infographic Design?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Infographic Design?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Adobe Creative Suite, Figma, Canva, Sketch)."
      },
      {
        "q": "How many revisions are included in Infographic Design?",
        "a": "Each Infographic Design engagement includes Design files (PNG, PSD), delivered within 4 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Infographic Design?",
        "a": "A 14-day support window is included after delivery for adjustments and bug fixes. Longer engagements can be quoted on request."
      }
    ]
  },
  {
    "id": "reg-059",
    "slug": "social-media-graphics",
    "title": "Social Media Graphics",
    "category": "branding-design",
    "icon": "Palette",
    "description": "Design graphics for social media posts",
    "valueProp": "Design graphics for social media posts",
    "tagline": "Design graphics for social media posts",
    "deliverable": "Design files (PNG, PSD)",
    "tiers": {
      "basic": 121,
      "standard": 237,
      "premium": 657
    },
    "days": 6,
    "subscriptionAvailable": false,
    "steps": [
      "Gather brand guidelines and preferences",
      "Create initial concepts",
      "Iterate with feedback",
      "Finalize the chosen design",
      "And deliver all files ready for use"
    ],
    "integrations": [
      "Adobe Creative Suite",
      "Figma",
      "Canva",
      "Sketch"
    ],
    "faq": [
      {
        "q": "What is included in the Social Media Graphics service?",
        "a": "Each Social Media Graphics engagement includes Design files (PNG, PSD), delivered within 6 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Social Media Graphics?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Social Media Graphics?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Adobe Creative Suite, Figma, Canva, Sketch)."
      },
      {
        "q": "How many revisions are included in Social Media Graphics?",
        "a": "Each Social Media Graphics engagement includes Design files (PNG, PSD), delivered within 6 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Social Media Graphics?",
        "a": "A 14-day support window is included after delivery for adjustments and bug fixes. Longer engagements can be quoted on request."
      }
    ]
  },
  {
    "id": "reg-060",
    "slug": "animated-graphics",
    "title": "Animated Graphics",
    "category": "branding-design",
    "icon": "Palette",
    "description": "Produce motion graphics for digital use",
    "valueProp": "Produce motion graphics for digital use",
    "tagline": "Produce motion graphics for digital use",
    "deliverable": "Design files (PNG, PSD)",
    "tiers": {
      "basic": 63,
      "standard": 371,
      "premium": 526
    },
    "days": 8,
    "subscriptionAvailable": false,
    "steps": [
      "Gather brand guidelines and preferences",
      "Create initial concepts",
      "Iterate with feedback",
      "Finalize the chosen design",
      "And deliver all files ready for use"
    ],
    "integrations": [
      "Adobe Creative Suite",
      "Figma",
      "Canva",
      "Sketch"
    ],
    "faq": [
      {
        "q": "What is included in the Animated Graphics service?",
        "a": "Each Animated Graphics engagement includes Design files (PNG, PSD), delivered within 8 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Animated Graphics?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Animated Graphics?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Adobe Creative Suite, Figma, Canva, Sketch)."
      },
      {
        "q": "How many revisions are included in Animated Graphics?",
        "a": "Each Animated Graphics engagement includes Design files (PNG, PSD), delivered within 8 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Animated Graphics?",
        "a": "A 14-day support window is included after delivery for adjustments and bug fixes. Longer engagements can be quoted on request."
      }
    ]
  },
  {
    "id": "reg-061",
    "slug": "product-design",
    "title": "Product Design",
    "category": "branding-design",
    "icon": "Palette",
    "description": "Design physical or digital products",
    "valueProp": "Design physical or digital products",
    "tagline": "Design physical or digital products",
    "deliverable": "Design files (PNG, PSD)",
    "tiers": {
      "basic": 116,
      "standard": 183,
      "premium": 505
    },
    "days": 10,
    "subscriptionAvailable": false,
    "steps": [
      "Gather brand guidelines and preferences",
      "Create initial concepts",
      "Iterate with feedback",
      "Finalize the chosen design",
      "And deliver all files ready for use"
    ],
    "integrations": [
      "Adobe Creative Suite",
      "Figma",
      "Canva",
      "Sketch"
    ],
    "faq": [
      {
        "q": "What is included in the Product Design service?",
        "a": "Each Product Design engagement includes Design files (PNG, PSD), delivered within 10 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Product Design?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Product Design?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Adobe Creative Suite, Figma, Canva, Sketch)."
      },
      {
        "q": "How many revisions are included in Product Design?",
        "a": "Each Product Design engagement includes Design files (PNG, PSD), delivered within 10 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Product Design?",
        "a": "A 14-day support window is included after delivery for adjustments and bug fixes. Longer engagements can be quoted on request."
      }
    ]
  },
  {
    "id": "reg-062",
    "slug": "character-design",
    "title": "Character Design",
    "category": "branding-design",
    "icon": "Palette",
    "description": "Create character illustrations for media",
    "valueProp": "Create character illustrations for media",
    "tagline": "Create character illustrations for media",
    "deliverable": "Design files (PNG, PSD)",
    "tiers": {
      "basic": 89,
      "standard": 394,
      "premium": 508
    },
    "days": 7,
    "subscriptionAvailable": false,
    "steps": [
      "Gather brand guidelines and preferences",
      "Create initial concepts",
      "Iterate with feedback",
      "Finalize the chosen design",
      "And deliver all files ready for use"
    ],
    "integrations": [
      "Adobe Creative Suite",
      "Figma",
      "Canva",
      "Sketch"
    ],
    "faq": [
      {
        "q": "What is included in the Character Design service?",
        "a": "Each Character Design engagement includes Design files (PNG, PSD), delivered within 7 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Character Design?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Character Design?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Adobe Creative Suite, Figma, Canva, Sketch)."
      },
      {
        "q": "How many revisions are included in Character Design?",
        "a": "Each Character Design engagement includes Design files (PNG, PSD), delivered within 7 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Character Design?",
        "a": "A 14-day support window is included after delivery for adjustments and bug fixes. Longer engagements can be quoted on request."
      }
    ]
  },
  {
    "id": "reg-063",
    "slug": "motion-graphics",
    "title": "Motion Graphics",
    "category": "branding-design",
    "icon": "Palette",
    "description": "Design animated motion visuals",
    "valueProp": "Design animated motion visuals",
    "tagline": "Design animated motion visuals",
    "deliverable": "Design files (PNG, PSD)",
    "tiers": {
      "basic": 83,
      "standard": 302,
      "premium": 635
    },
    "days": 5,
    "subscriptionAvailable": false,
    "steps": [
      "Gather brand guidelines and preferences",
      "Create initial concepts",
      "Iterate with feedback",
      "Finalize the chosen design",
      "And deliver all files ready for use"
    ],
    "integrations": [
      "Adobe Creative Suite",
      "Figma",
      "Canva",
      "Sketch"
    ],
    "faq": [
      {
        "q": "What is included in the Motion Graphics service?",
        "a": "Each Motion Graphics engagement includes Design files (PNG, PSD), delivered within 5 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Motion Graphics?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Motion Graphics?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Adobe Creative Suite, Figma, Canva, Sketch)."
      },
      {
        "q": "How many revisions are included in Motion Graphics?",
        "a": "Each Motion Graphics engagement includes Design files (PNG, PSD), delivered within 5 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Motion Graphics?",
        "a": "A 14-day support window is included after delivery for adjustments and bug fixes. Longer engagements can be quoted on request."
      }
    ]
  },
  {
    "id": "reg-064",
    "slug": "game-art",
    "title": "Game Art",
    "category": "branding-design",
    "icon": "Palette",
    "description": "Develop art assets for games",
    "valueProp": "Develop art assets for games",
    "tagline": "Develop art assets for games",
    "deliverable": "Design files (PNG, PSD)",
    "tiers": {
      "basic": 131,
      "standard": 321,
      "premium": 602
    },
    "days": 7,
    "subscriptionAvailable": false,
    "steps": [
      "Gather brand guidelines and preferences",
      "Create initial concepts",
      "Iterate with feedback",
      "Finalize the chosen design",
      "And deliver all files ready for use"
    ],
    "integrations": [
      "Adobe Creative Suite",
      "Figma",
      "Canva",
      "Sketch"
    ],
    "faq": [
      {
        "q": "What is included in the Game Art service?",
        "a": "Each Game Art engagement includes Design files (PNG, PSD), delivered within 7 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Game Art?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Game Art?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Adobe Creative Suite, Figma, Canva, Sketch)."
      },
      {
        "q": "How many revisions are included in Game Art?",
        "a": "Each Game Art engagement includes Design files (PNG, PSD), delivered within 7 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Game Art?",
        "a": "A 14-day support window is included after delivery for adjustments and bug fixes. Longer engagements can be quoted on request."
      }
    ]
  },
  {
    "id": "reg-065",
    "slug": "brand-guidelines",
    "title": "Brand Guidelines",
    "category": "branding-design",
    "icon": "Palette",
    "description": "Create brand guideline documentation",
    "valueProp": "Create brand guideline documentation",
    "tagline": "Create brand guideline documentation",
    "deliverable": "Design files (PNG, PSD)",
    "tiers": {
      "basic": 56,
      "standard": 269,
      "premium": 575
    },
    "days": 5,
    "subscriptionAvailable": false,
    "steps": [
      "Gather brand guidelines and preferences",
      "Create initial concepts",
      "Iterate with feedback",
      "Finalize the chosen design",
      "And deliver all files ready for use"
    ],
    "integrations": [
      "Adobe Creative Suite",
      "Figma",
      "Canva",
      "Sketch"
    ],
    "faq": [
      {
        "q": "What is included in the Brand Guidelines service?",
        "a": "Each Brand Guidelines engagement includes Design files (PNG, PSD), delivered within 5 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Brand Guidelines?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Brand Guidelines?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Adobe Creative Suite, Figma, Canva, Sketch)."
      },
      {
        "q": "How many revisions are included in Brand Guidelines?",
        "a": "Each Brand Guidelines engagement includes Design files (PNG, PSD), delivered within 5 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Brand Guidelines?",
        "a": "A 14-day support window is included after delivery for adjustments and bug fixes. Longer engagements can be quoted on request."
      }
    ]
  },
  {
    "id": "reg-066",
    "slug": "color-palette-creation",
    "title": "Color Palette Creation",
    "category": "branding-design",
    "icon": "Palette",
    "description": "Develop color schemes for brands",
    "valueProp": "Develop color schemes for brands",
    "tagline": "Develop color schemes for brands",
    "deliverable": "Design files (PNG, PSD)",
    "tiers": {
      "basic": 115,
      "standard": 389,
      "premium": 542
    },
    "days": 6,
    "subscriptionAvailable": false,
    "steps": [
      "Gather brand guidelines and preferences",
      "Create initial concepts",
      "Iterate with feedback",
      "Finalize the chosen design",
      "And deliver all files ready for use"
    ],
    "integrations": [
      "Adobe Creative Suite",
      "Figma",
      "Canva",
      "Sketch"
    ],
    "faq": [
      {
        "q": "What is included in the Color Palette Creation service?",
        "a": "Each Color Palette Creation engagement includes Design files (PNG, PSD), delivered within 6 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Color Palette Creation?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Color Palette Creation?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Adobe Creative Suite, Figma, Canva, Sketch)."
      },
      {
        "q": "How many revisions are included in Color Palette Creation?",
        "a": "Each Color Palette Creation engagement includes Design files (PNG, PSD), delivered within 6 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Color Palette Creation?",
        "a": "A 14-day support window is included after delivery for adjustments and bug fixes. Longer engagements can be quoted on request."
      }
    ]
  },
  {
    "id": "reg-067",
    "slug": "app-icon-design",
    "title": "App Icon Design",
    "category": "branding-design",
    "icon": "Palette",
    "description": "Design app icons for platforms",
    "valueProp": "Design app icons for platforms",
    "tagline": "Design app icons for platforms",
    "deliverable": "Design files (PNG, PSD)",
    "tiers": {
      "basic": 145,
      "standard": 394,
      "premium": 789
    },
    "days": 8,
    "subscriptionAvailable": false,
    "steps": [
      "Gather brand guidelines and preferences",
      "Create initial concepts",
      "Iterate with feedback",
      "Finalize the chosen design",
      "And deliver all files ready for use"
    ],
    "integrations": [
      "Adobe Creative Suite",
      "Figma",
      "Canva",
      "Sketch"
    ],
    "faq": [
      {
        "q": "What is included in the App Icon Design service?",
        "a": "Each App Icon Design engagement includes Design files (PNG, PSD), delivered within 8 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for App Icon Design?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start App Icon Design?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Adobe Creative Suite, Figma, Canva, Sketch)."
      },
      {
        "q": "How many revisions are included in App Icon Design?",
        "a": "Each App Icon Design engagement includes Design files (PNG, PSD), delivered within 8 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after App Icon Design?",
        "a": "A 14-day support window is included after delivery for adjustments and bug fixes. Longer engagements can be quoted on request."
      }
    ]
  },
  {
    "id": "reg-068",
    "slug": "stationery-design",
    "title": "Stationery Design",
    "category": "branding-design",
    "icon": "Palette",
    "description": "Design business stationery items",
    "valueProp": "Design business stationery items",
    "tagline": "Design business stationery items",
    "deliverable": "Design files (PNG, PSD)",
    "tiers": {
      "basic": 131,
      "standard": 289,
      "premium": 461
    },
    "days": 4,
    "subscriptionAvailable": false,
    "steps": [
      "Gather brand guidelines and preferences",
      "Create initial concepts",
      "Iterate with feedback",
      "Finalize the chosen design",
      "And deliver all files ready for use"
    ],
    "integrations": [
      "Adobe Creative Suite",
      "Figma",
      "Canva",
      "Sketch"
    ],
    "faq": [
      {
        "q": "What is included in the Stationery Design service?",
        "a": "Each Stationery Design engagement includes Design files (PNG, PSD), delivered within 4 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Stationery Design?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Stationery Design?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Adobe Creative Suite, Figma, Canva, Sketch)."
      },
      {
        "q": "How many revisions are included in Stationery Design?",
        "a": "Each Stationery Design engagement includes Design files (PNG, PSD), delivered within 4 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Stationery Design?",
        "a": "A 14-day support window is included after delivery for adjustments and bug fixes. Longer engagements can be quoted on request."
      }
    ]
  },
  {
    "id": "reg-069",
    "slug": "magazine-layout",
    "title": "Magazine Layout",
    "category": "branding-design",
    "icon": "Palette",
    "description": "Design layouts for magazines",
    "valueProp": "Design layouts for magazines",
    "tagline": "Design layouts for magazines",
    "deliverable": "Design files (PNG, PSD)",
    "tiers": {
      "basic": 119,
      "standard": 164,
      "premium": 500
    },
    "days": 10,
    "subscriptionAvailable": false,
    "steps": [
      "Gather brand guidelines and preferences",
      "Create initial concepts",
      "Iterate with feedback",
      "Finalize the chosen design",
      "And deliver all files ready for use"
    ],
    "integrations": [
      "Adobe Creative Suite",
      "Figma",
      "Canva",
      "Sketch"
    ],
    "faq": [
      {
        "q": "What is included in the Magazine Layout service?",
        "a": "Each Magazine Layout engagement includes Design files (PNG, PSD), delivered within 10 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Magazine Layout?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Magazine Layout?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Adobe Creative Suite, Figma, Canva, Sketch)."
      },
      {
        "q": "How many revisions are included in Magazine Layout?",
        "a": "Each Magazine Layout engagement includes Design files (PNG, PSD), delivered within 10 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Magazine Layout?",
        "a": "A 14-day support window is included after delivery for adjustments and bug fixes. Longer engagements can be quoted on request."
      }
    ]
  },
  {
    "id": "reg-070",
    "slug": "storyboarding",
    "title": "Storyboarding",
    "category": "branding-design",
    "icon": "Palette",
    "description": "Create storyboards for films",
    "valueProp": "Create storyboards for films",
    "tagline": "Create storyboards for films",
    "deliverable": "Design files (PNG, PSD)",
    "tiers": {
      "basic": 90,
      "standard": 168,
      "premium": 686
    },
    "days": 4,
    "subscriptionAvailable": false,
    "steps": [
      "Gather brand guidelines and preferences",
      "Create initial concepts",
      "Iterate with feedback",
      "Finalize the chosen design",
      "And deliver all files ready for use"
    ],
    "integrations": [
      "Adobe Creative Suite",
      "Figma",
      "Canva",
      "Sketch"
    ],
    "faq": [
      {
        "q": "What is included in the Storyboarding service?",
        "a": "Each Storyboarding engagement includes Design files (PNG, PSD), delivered within 4 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Storyboarding?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Storyboarding?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Adobe Creative Suite, Figma, Canva, Sketch)."
      },
      {
        "q": "How many revisions are included in Storyboarding?",
        "a": "Each Storyboarding engagement includes Design files (PNG, PSD), delivered within 4 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Storyboarding?",
        "a": "A 14-day support window is included after delivery for adjustments and bug fixes. Longer engagements can be quoted on request."
      }
    ]
  },
  {
    "id": "reg-071",
    "slug": "typography-design",
    "title": "Typography Design",
    "category": "branding-design",
    "icon": "Palette",
    "description": "Develop custom typography",
    "valueProp": "Develop custom typography",
    "tagline": "Develop custom typography",
    "deliverable": "Design files (PNG, PSD)",
    "tiers": {
      "basic": 107,
      "standard": 368,
      "premium": 420
    },
    "days": 2,
    "subscriptionAvailable": false,
    "steps": [
      "Gather brand guidelines and preferences",
      "Create initial concepts",
      "Iterate with feedback",
      "Finalize the chosen design",
      "And deliver all files ready for use"
    ],
    "integrations": [
      "Adobe Creative Suite",
      "Figma",
      "Canva",
      "Sketch"
    ],
    "faq": [
      {
        "q": "What is included in the Typography Design service?",
        "a": "Each Typography Design engagement includes Design files (PNG, PSD), delivered within 2 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Typography Design?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Typography Design?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Adobe Creative Suite, Figma, Canva, Sketch)."
      },
      {
        "q": "How many revisions are included in Typography Design?",
        "a": "Each Typography Design engagement includes Design files (PNG, PSD), delivered within 2 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Typography Design?",
        "a": "A 14-day support window is included after delivery for adjustments and bug fixes. Longer engagements can be quoted on request."
      }
    ]
  },
  {
    "id": "reg-072",
    "slug": "interactive-design",
    "title": "Interactive Design",
    "category": "branding-design",
    "icon": "Palette",
    "description": "Design interactive digital experiences",
    "valueProp": "Design interactive digital experiences",
    "tagline": "Design interactive digital experiences",
    "deliverable": "Design files (PNG, PSD)",
    "tiers": {
      "basic": 104,
      "standard": 163,
      "premium": 719
    },
    "days": 2,
    "subscriptionAvailable": false,
    "steps": [
      "Gather brand guidelines and preferences",
      "Create initial concepts",
      "Iterate with feedback",
      "Finalize the chosen design",
      "And deliver all files ready for use"
    ],
    "integrations": [
      "Adobe Creative Suite",
      "Figma",
      "Canva",
      "Sketch"
    ],
    "faq": [
      {
        "q": "What is included in the Interactive Design service?",
        "a": "Each Interactive Design engagement includes Design files (PNG, PSD), delivered within 2 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Interactive Design?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Interactive Design?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Adobe Creative Suite, Figma, Canva, Sketch)."
      },
      {
        "q": "How many revisions are included in Interactive Design?",
        "a": "Each Interactive Design engagement includes Design files (PNG, PSD), delivered within 2 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Interactive Design?",
        "a": "A 14-day support window is included after delivery for adjustments and bug fixes. Longer engagements can be quoted on request."
      }
    ]
  },
  {
    "id": "reg-073",
    "slug": "event-branding",
    "title": "Event Branding",
    "category": "branding-design",
    "icon": "Palette",
    "description": "Create branding for events",
    "valueProp": "Create branding for events",
    "tagline": "Create branding for events",
    "deliverable": "Design files (PNG, PSD)",
    "tiers": {
      "basic": 70,
      "standard": 284,
      "premium": 786
    },
    "days": 2,
    "subscriptionAvailable": false,
    "steps": [
      "Gather brand guidelines and preferences",
      "Create initial concepts",
      "Iterate with feedback",
      "Finalize the chosen design",
      "And deliver all files ready for use"
    ],
    "integrations": [
      "Adobe Creative Suite",
      "Figma",
      "Canva",
      "Sketch"
    ],
    "faq": [
      {
        "q": "What is included in the Event Branding service?",
        "a": "Each Event Branding engagement includes Design files (PNG, PSD), delivered within 2 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Event Branding?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Event Branding?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Adobe Creative Suite, Figma, Canva, Sketch)."
      },
      {
        "q": "How many revisions are included in Event Branding?",
        "a": "Each Event Branding engagement includes Design files (PNG, PSD), delivered within 2 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Event Branding?",
        "a": "A 14-day support window is included after delivery for adjustments and bug fixes. Longer engagements can be quoted on request."
      }
    ]
  },
  {
    "id": "reg-074",
    "slug": "album-cover-design",
    "title": "Album Cover Design",
    "category": "branding-design",
    "icon": "Palette",
    "description": "Design covers for music albums",
    "valueProp": "Design covers for music albums",
    "tagline": "Design covers for music albums",
    "deliverable": "Design files (PNG, PSD)",
    "tiers": {
      "basic": 54,
      "standard": 206,
      "premium": 767
    },
    "days": 9,
    "subscriptionAvailable": false,
    "steps": [
      "Gather brand guidelines and preferences",
      "Create initial concepts",
      "Iterate with feedback",
      "Finalize the chosen design",
      "And deliver all files ready for use"
    ],
    "integrations": [
      "Adobe Creative Suite",
      "Figma",
      "Canva",
      "Sketch"
    ],
    "faq": [
      {
        "q": "What is included in the Album Cover Design service?",
        "a": "Each Album Cover Design engagement includes Design files (PNG, PSD), delivered within 9 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Album Cover Design?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Album Cover Design?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Adobe Creative Suite, Figma, Canva, Sketch)."
      },
      {
        "q": "How many revisions are included in Album Cover Design?",
        "a": "Each Album Cover Design engagement includes Design files (PNG, PSD), delivered within 9 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Album Cover Design?",
        "a": "A 14-day support window is included after delivery for adjustments and bug fixes. Longer engagements can be quoted on request."
      }
    ]
  },
  {
    "id": "reg-075",
    "slug": "print-advertising-design",
    "title": "Print Advertising Design",
    "category": "branding-design",
    "icon": "Palette",
    "description": "Design print ads for marketing",
    "valueProp": "Design print ads for marketing",
    "tagline": "Design print ads for marketing",
    "deliverable": "Design files (PNG, PSD)",
    "tiers": {
      "basic": 143,
      "standard": 172,
      "premium": 485
    },
    "days": 8,
    "subscriptionAvailable": false,
    "steps": [
      "Gather brand guidelines and preferences",
      "Create initial concepts",
      "Iterate with feedback",
      "Finalize the chosen design",
      "And deliver all files ready for use"
    ],
    "integrations": [
      "Adobe Creative Suite",
      "Figma",
      "Canva",
      "Sketch"
    ],
    "faq": [
      {
        "q": "What is included in the Print Advertising Design service?",
        "a": "Each Print Advertising Design engagement includes Design files (PNG, PSD), delivered within 8 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Print Advertising Design?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Print Advertising Design?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Adobe Creative Suite, Figma, Canva, Sketch)."
      },
      {
        "q": "How many revisions are included in Print Advertising Design?",
        "a": "Each Print Advertising Design engagement includes Design files (PNG, PSD), delivered within 8 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Print Advertising Design?",
        "a": "A 14-day support window is included after delivery for adjustments and bug fixes. Longer engagements can be quoted on request."
      }
    ]
  },
  {
    "id": "reg-076",
    "slug": "copywriting",
    "title": "Copywriting",
    "category": "content-seo",
    "icon": "PenLine",
    "description": "Write persuasive marketing copy",
    "valueProp": "Write persuasive marketing copy",
    "tagline": "Write persuasive marketing copy",
    "deliverable": "Document (PDF/Word)",
    "tiers": {
      "basic": 53,
      "standard": 123,
      "premium": 490
    },
    "days": 5,
    "subscriptionAvailable": true,
    "steps": [
      "Understand the audience and purpose",
      "Research the topic",
      "Draft engaging content",
      "Incorporate client feedback through revisions",
      "And deliver polished copy ready for publication"
    ],
    "integrations": [
      "Google Docs",
      "Microsoft Word",
      "Grammarly",
      "Notion"
    ],
    "faq": [
      {
        "q": "What is included in the Copywriting service?",
        "a": "Each Copywriting engagement includes Document (PDF/Word), delivered within 5 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Copywriting?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Copywriting?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Google Docs, Microsoft Word, Grammarly, Notion)."
      },
      {
        "q": "How many revisions are included in Copywriting?",
        "a": "Each Copywriting engagement includes Document (PDF/Word), delivered within 5 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Copywriting?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-077",
    "slug": "blog-post-writing",
    "title": "Blog Post Writing",
    "category": "content-seo",
    "icon": "PenLine",
    "description": "Write informative blog articles",
    "valueProp": "Write informative blog articles",
    "tagline": "Write informative blog articles",
    "deliverable": "Document (PDF/Word)",
    "tiers": {
      "basic": 49,
      "standard": 183,
      "premium": 460
    },
    "days": 4,
    "subscriptionAvailable": true,
    "steps": [
      "Understand the audience and purpose",
      "Research the topic",
      "Draft engaging content",
      "Incorporate client feedback through revisions",
      "And deliver polished copy ready for publication"
    ],
    "integrations": [
      "Google Docs",
      "Microsoft Word",
      "Grammarly",
      "Notion"
    ],
    "faq": [
      {
        "q": "What is included in the Blog Post Writing service?",
        "a": "Each Blog Post Writing engagement includes Document (PDF/Word), delivered within 4 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Blog Post Writing?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Blog Post Writing?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Google Docs, Microsoft Word, Grammarly, Notion)."
      },
      {
        "q": "How many revisions are included in Blog Post Writing?",
        "a": "Each Blog Post Writing engagement includes Document (PDF/Word), delivered within 4 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Blog Post Writing?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-078",
    "slug": "seo-article-writing",
    "title": "SEO Article Writing",
    "category": "content-seo",
    "icon": "PenLine",
    "description": "Create SEO-optimized articles",
    "valueProp": "Create SEO-optimized articles",
    "tagline": "Create SEO-optimized articles",
    "deliverable": "Document (PDF/Word)",
    "tiers": {
      "basic": 63,
      "standard": 280,
      "premium": 618
    },
    "days": 3,
    "subscriptionAvailable": true,
    "steps": [
      "Understand the audience and purpose",
      "Research the topic",
      "Draft engaging content",
      "Incorporate client feedback through revisions",
      "And deliver polished copy ready for publication"
    ],
    "integrations": [
      "Google Docs",
      "Microsoft Word",
      "Grammarly",
      "Notion"
    ],
    "faq": [
      {
        "q": "What is included in the SEO Article Writing service?",
        "a": "Each SEO Article Writing engagement includes Document (PDF/Word), delivered within 3 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for SEO Article Writing?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start SEO Article Writing?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Google Docs, Microsoft Word, Grammarly, Notion)."
      },
      {
        "q": "How many revisions are included in SEO Article Writing?",
        "a": "Each SEO Article Writing engagement includes Document (PDF/Word), delivered within 3 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after SEO Article Writing?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-079",
    "slug": "technical-writing",
    "title": "Technical Writing",
    "category": "content-seo",
    "icon": "PenLine",
    "description": "Document complex technical topics",
    "valueProp": "Document complex technical topics",
    "tagline": "Document complex technical topics",
    "deliverable": "Document (PDF/Word)",
    "tiers": {
      "basic": 34,
      "standard": 205,
      "premium": 686
    },
    "days": 1,
    "subscriptionAvailable": true,
    "steps": [
      "Understand the audience and purpose",
      "Research the topic",
      "Draft engaging content",
      "Incorporate client feedback through revisions",
      "And deliver polished copy ready for publication"
    ],
    "integrations": [
      "Google Docs",
      "Microsoft Word",
      "Grammarly",
      "Notion"
    ],
    "faq": [
      {
        "q": "What is included in the Technical Writing service?",
        "a": "Each Technical Writing engagement includes Document (PDF/Word), delivered within 1 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Technical Writing?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Technical Writing?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Google Docs, Microsoft Word, Grammarly, Notion)."
      },
      {
        "q": "How many revisions are included in Technical Writing?",
        "a": "Each Technical Writing engagement includes Document (PDF/Word), delivered within 1 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Technical Writing?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-080",
    "slug": "script-writing",
    "title": "Script Writing",
    "category": "content-seo",
    "icon": "PenLine",
    "description": "Write scripts for video or audio",
    "valueProp": "Write scripts for video or audio",
    "tagline": "Write scripts for video or audio",
    "deliverable": "Document (PDF/Word)",
    "tiers": {
      "basic": 59,
      "standard": 286,
      "premium": 394
    },
    "days": 5,
    "subscriptionAvailable": true,
    "steps": [
      "Understand the audience and purpose",
      "Research the topic",
      "Draft engaging content",
      "Incorporate client feedback through revisions",
      "And deliver polished copy ready for publication"
    ],
    "integrations": [
      "Google Docs",
      "Microsoft Word",
      "Grammarly",
      "Notion"
    ],
    "faq": [
      {
        "q": "What is included in the Script Writing service?",
        "a": "Each Script Writing engagement includes Document (PDF/Word), delivered within 5 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Script Writing?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Script Writing?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Google Docs, Microsoft Word, Grammarly, Notion)."
      },
      {
        "q": "How many revisions are included in Script Writing?",
        "a": "Each Script Writing engagement includes Document (PDF/Word), delivered within 5 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Script Writing?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-081",
    "slug": "resume-writing",
    "title": "Resume Writing",
    "category": "content-seo",
    "icon": "PenLine",
    "description": "Craft professional resumes",
    "valueProp": "Craft professional resumes",
    "tagline": "Craft professional resumes",
    "deliverable": "Document (PDF/Word)",
    "tiers": {
      "basic": 60,
      "standard": 135,
      "premium": 443
    },
    "days": 3,
    "subscriptionAvailable": true,
    "steps": [
      "Understand the audience and purpose",
      "Research the topic",
      "Draft engaging content",
      "Incorporate client feedback through revisions",
      "And deliver polished copy ready for publication"
    ],
    "integrations": [
      "Google Docs",
      "Microsoft Word",
      "Grammarly",
      "Notion"
    ],
    "faq": [
      {
        "q": "What is included in the Resume Writing service?",
        "a": "Each Resume Writing engagement includes Document (PDF/Word), delivered within 3 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Resume Writing?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Resume Writing?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Google Docs, Microsoft Word, Grammarly, Notion)."
      },
      {
        "q": "How many revisions are included in Resume Writing?",
        "a": "Each Resume Writing engagement includes Document (PDF/Word), delivered within 3 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Resume Writing?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-082",
    "slug": "grant-proposal-writing",
    "title": "Grant Proposal Writing",
    "category": "content-seo",
    "icon": "PenLine",
    "description": "Write proposals to secure funding",
    "valueProp": "Write proposals to secure funding",
    "tagline": "Write proposals to secure funding",
    "deliverable": "Document (PDF/Word)",
    "tiers": {
      "basic": 78,
      "standard": 153,
      "premium": 394
    },
    "days": 6,
    "subscriptionAvailable": true,
    "steps": [
      "Understand the audience and purpose",
      "Research the topic",
      "Draft engaging content",
      "Incorporate client feedback through revisions",
      "And deliver polished copy ready for publication"
    ],
    "integrations": [
      "Google Docs",
      "Microsoft Word",
      "Grammarly",
      "Notion"
    ],
    "faq": [
      {
        "q": "What is included in the Grant Proposal Writing service?",
        "a": "Each Grant Proposal Writing engagement includes Document (PDF/Word), delivered within 6 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Grant Proposal Writing?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Grant Proposal Writing?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Google Docs, Microsoft Word, Grammarly, Notion)."
      },
      {
        "q": "How many revisions are included in Grant Proposal Writing?",
        "a": "Each Grant Proposal Writing engagement includes Document (PDF/Word), delivered within 6 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Grant Proposal Writing?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-083",
    "slug": "ghostwriting",
    "title": "Ghostwriting",
    "category": "content-seo",
    "icon": "PenLine",
    "description": "Write on behalf of clients anonymously",
    "valueProp": "Write on behalf of clients anonymously",
    "tagline": "Write on behalf of clients anonymously",
    "deliverable": "Document (PDF/Word)",
    "tiers": {
      "basic": 86,
      "standard": 212,
      "premium": 536
    },
    "days": 3,
    "subscriptionAvailable": true,
    "steps": [
      "Understand the audience and purpose",
      "Research the topic",
      "Draft engaging content",
      "Incorporate client feedback through revisions",
      "And deliver polished copy ready for publication"
    ],
    "integrations": [
      "Google Docs",
      "Microsoft Word",
      "Grammarly",
      "Notion"
    ],
    "faq": [
      {
        "q": "What is included in the Ghostwriting service?",
        "a": "Each Ghostwriting engagement includes Document (PDF/Word), delivered within 3 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Ghostwriting?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Ghostwriting?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Google Docs, Microsoft Word, Grammarly, Notion)."
      },
      {
        "q": "How many revisions are included in Ghostwriting?",
        "a": "Each Ghostwriting engagement includes Document (PDF/Word), delivered within 3 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Ghostwriting?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-084",
    "slug": "ebook-writing",
    "title": "eBook Writing",
    "category": "content-seo",
    "icon": "PenLine",
    "description": "Create ebooks on various topics",
    "valueProp": "Create ebooks on various topics",
    "tagline": "Create ebooks on various topics",
    "deliverable": "Document (PDF/Word)",
    "tiers": {
      "basic": 35,
      "standard": 121,
      "premium": 304
    },
    "days": 5,
    "subscriptionAvailable": true,
    "steps": [
      "Understand the audience and purpose",
      "Research the topic",
      "Draft engaging content",
      "Incorporate client feedback through revisions",
      "And deliver polished copy ready for publication"
    ],
    "integrations": [
      "Google Docs",
      "Microsoft Word",
      "Grammarly",
      "Notion"
    ],
    "faq": [
      {
        "q": "What is included in the eBook Writing service?",
        "a": "Each eBook Writing engagement includes Document (PDF/Word), delivered within 5 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for eBook Writing?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start eBook Writing?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Google Docs, Microsoft Word, Grammarly, Notion)."
      },
      {
        "q": "How many revisions are included in eBook Writing?",
        "a": "Each eBook Writing engagement includes Document (PDF/Word), delivered within 5 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after eBook Writing?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-085",
    "slug": "press-release-writing",
    "title": "Press Release Writing",
    "category": "content-seo",
    "icon": "PenLine",
    "description": "Draft press releases for news",
    "valueProp": "Draft press releases for news",
    "tagline": "Draft press releases for news",
    "deliverable": "Document (PDF/Word)",
    "tiers": {
      "basic": 89,
      "standard": 171,
      "premium": 621
    },
    "days": 5,
    "subscriptionAvailable": true,
    "steps": [
      "Understand the audience and purpose",
      "Research the topic",
      "Draft engaging content",
      "Incorporate client feedback through revisions",
      "And deliver polished copy ready for publication"
    ],
    "integrations": [
      "Google Docs",
      "Microsoft Word",
      "Grammarly",
      "Notion"
    ],
    "faq": [
      {
        "q": "What is included in the Press Release Writing service?",
        "a": "Each Press Release Writing engagement includes Document (PDF/Word), delivered within 5 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Press Release Writing?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Press Release Writing?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Google Docs, Microsoft Word, Grammarly, Notion)."
      },
      {
        "q": "How many revisions are included in Press Release Writing?",
        "a": "Each Press Release Writing engagement includes Document (PDF/Word), delivered within 5 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Press Release Writing?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-086",
    "slug": "product-description-writing",
    "title": "Product Description Writing",
    "category": "content-seo",
    "icon": "PenLine",
    "description": "Write product descriptions for e-commerce",
    "valueProp": "Write product descriptions for e-commerce",
    "tagline": "Write product descriptions for e-commerce",
    "deliverable": "Document (PDF/Word)",
    "tiers": {
      "basic": 55,
      "standard": 225,
      "premium": 344
    },
    "days": 6,
    "subscriptionAvailable": true,
    "steps": [
      "Understand the audience and purpose",
      "Research the topic",
      "Draft engaging content",
      "Incorporate client feedback through revisions",
      "And deliver polished copy ready for publication"
    ],
    "integrations": [
      "Google Docs",
      "Microsoft Word",
      "Grammarly",
      "Notion"
    ],
    "faq": [
      {
        "q": "What is included in the Product Description Writing service?",
        "a": "Each Product Description Writing engagement includes Document (PDF/Word), delivered within 6 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Product Description Writing?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Product Description Writing?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Google Docs, Microsoft Word, Grammarly, Notion)."
      },
      {
        "q": "How many revisions are included in Product Description Writing?",
        "a": "Each Product Description Writing engagement includes Document (PDF/Word), delivered within 6 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Product Description Writing?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-087",
    "slug": "translation-services",
    "title": "Translation Services",
    "category": "content-seo",
    "icon": "PenLine",
    "description": "Translate content between languages",
    "valueProp": "Translate content between languages",
    "tagline": "Translate content between languages",
    "deliverable": "Document (PDF/Word)",
    "tiers": {
      "basic": 78,
      "standard": 182,
      "premium": 427
    },
    "days": 3,
    "subscriptionAvailable": true,
    "steps": [
      "Understand the audience and purpose",
      "Research the topic",
      "Draft engaging content",
      "Incorporate client feedback through revisions",
      "And deliver polished copy ready for publication"
    ],
    "integrations": [
      "Google Docs",
      "Microsoft Word",
      "Grammarly",
      "Notion"
    ],
    "faq": [
      {
        "q": "What is included in the Translation Services service?",
        "a": "Each Translation Services engagement includes Document (PDF/Word), delivered within 3 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Translation Services?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Translation Services?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Google Docs, Microsoft Word, Grammarly, Notion)."
      },
      {
        "q": "How many revisions are included in Translation Services?",
        "a": "Each Translation Services engagement includes Document (PDF/Word), delivered within 3 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Translation Services?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-088",
    "slug": "transcription-services",
    "title": "Transcription Services",
    "category": "content-seo",
    "icon": "PenLine",
    "description": "Transcribe audio and video files",
    "valueProp": "Transcribe audio and video files",
    "tagline": "Transcribe audio and video files",
    "deliverable": "Document (PDF/Word)",
    "tiers": {
      "basic": 51,
      "standard": 234,
      "premium": 455
    },
    "days": 4,
    "subscriptionAvailable": true,
    "steps": [
      "Understand the audience and purpose",
      "Research the topic",
      "Draft engaging content",
      "Incorporate client feedback through revisions",
      "And deliver polished copy ready for publication"
    ],
    "integrations": [
      "Google Docs",
      "Microsoft Word",
      "Grammarly",
      "Notion"
    ],
    "faq": [
      {
        "q": "What is included in the Transcription Services service?",
        "a": "Each Transcription Services engagement includes Document (PDF/Word), delivered within 4 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Transcription Services?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Transcription Services?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Google Docs, Microsoft Word, Grammarly, Notion)."
      },
      {
        "q": "How many revisions are included in Transcription Services?",
        "a": "Each Transcription Services engagement includes Document (PDF/Word), delivered within 4 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Transcription Services?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-089",
    "slug": "subtitling-and-captioning",
    "title": "Subtitling & Captioning",
    "category": "content-seo",
    "icon": "PenLine",
    "description": "Add subtitles to video content",
    "valueProp": "Add subtitles to video content",
    "tagline": "Add subtitles to video content",
    "deliverable": "Document (PDF/Word)",
    "tiers": {
      "basic": 57,
      "standard": 194,
      "premium": 380
    },
    "days": 5,
    "subscriptionAvailable": true,
    "steps": [
      "Understand the audience and purpose",
      "Research the topic",
      "Draft engaging content",
      "Incorporate client feedback through revisions",
      "And deliver polished copy ready for publication"
    ],
    "integrations": [
      "Google Docs",
      "Microsoft Word",
      "Grammarly",
      "Notion"
    ],
    "faq": [
      {
        "q": "What is included in the Subtitling & Captioning service?",
        "a": "Each Subtitling & Captioning engagement includes Document (PDF/Word), delivered within 5 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Subtitling & Captioning?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Subtitling & Captioning?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Google Docs, Microsoft Word, Grammarly, Notion)."
      },
      {
        "q": "How many revisions are included in Subtitling & Captioning?",
        "a": "Each Subtitling & Captioning engagement includes Document (PDF/Word), delivered within 5 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Subtitling & Captioning?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-090",
    "slug": "white-paper-writing",
    "title": "White Paper Writing",
    "category": "content-seo",
    "icon": "PenLine",
    "description": "Write authoritative white papers",
    "valueProp": "Write authoritative white papers",
    "tagline": "Write authoritative white papers",
    "deliverable": "Document (PDF/Word)",
    "tiers": {
      "basic": 38,
      "standard": 112,
      "premium": 323
    },
    "days": 5,
    "subscriptionAvailable": true,
    "steps": [
      "Understand the audience and purpose",
      "Research the topic",
      "Draft engaging content",
      "Incorporate client feedback through revisions",
      "And deliver polished copy ready for publication"
    ],
    "integrations": [
      "Google Docs",
      "Microsoft Word",
      "Grammarly",
      "Notion"
    ],
    "faq": [
      {
        "q": "What is included in the White Paper Writing service?",
        "a": "Each White Paper Writing engagement includes Document (PDF/Word), delivered within 5 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for White Paper Writing?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start White Paper Writing?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Google Docs, Microsoft Word, Grammarly, Notion)."
      },
      {
        "q": "How many revisions are included in White Paper Writing?",
        "a": "Each White Paper Writing engagement includes Document (PDF/Word), delivered within 5 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after White Paper Writing?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-091",
    "slug": "newsletter-writing",
    "title": "Newsletter Writing",
    "category": "content-seo",
    "icon": "PenLine",
    "description": "Compose newsletters for audiences",
    "valueProp": "Compose newsletters for audiences",
    "tagline": "Compose newsletters for audiences",
    "deliverable": "Document (PDF/Word)",
    "tiers": {
      "basic": 92,
      "standard": 165,
      "premium": 472
    },
    "days": 6,
    "subscriptionAvailable": true,
    "steps": [
      "Understand the audience and purpose",
      "Research the topic",
      "Draft engaging content",
      "Incorporate client feedback through revisions",
      "And deliver polished copy ready for publication"
    ],
    "integrations": [
      "Google Docs",
      "Microsoft Word",
      "Grammarly",
      "Notion"
    ],
    "faq": [
      {
        "q": "What is included in the Newsletter Writing service?",
        "a": "Each Newsletter Writing engagement includes Document (PDF/Word), delivered within 6 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Newsletter Writing?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Newsletter Writing?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Google Docs, Microsoft Word, Grammarly, Notion)."
      },
      {
        "q": "How many revisions are included in Newsletter Writing?",
        "a": "Each Newsletter Writing engagement includes Document (PDF/Word), delivered within 6 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Newsletter Writing?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-092",
    "slug": "social-media-caption-writing",
    "title": "Social Media Caption Writing",
    "category": "content-seo",
    "icon": "PenLine",
    "description": "Write captions for social media",
    "valueProp": "Write captions for social media",
    "tagline": "Write captions for social media",
    "deliverable": "Document (PDF/Word)",
    "tiers": {
      "basic": 36,
      "standard": 290,
      "premium": 326
    },
    "days": 6,
    "subscriptionAvailable": true,
    "steps": [
      "Understand the audience and purpose",
      "Research the topic",
      "Draft engaging content",
      "Incorporate client feedback through revisions",
      "And deliver polished copy ready for publication"
    ],
    "integrations": [
      "Google Docs",
      "Microsoft Word",
      "Grammarly",
      "Notion"
    ],
    "faq": [
      {
        "q": "What is included in the Social Media Caption Writing service?",
        "a": "Each Social Media Caption Writing engagement includes Document (PDF/Word), delivered within 6 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Social Media Caption Writing?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Social Media Caption Writing?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Google Docs, Microsoft Word, Grammarly, Notion)."
      },
      {
        "q": "How many revisions are included in Social Media Caption Writing?",
        "a": "Each Social Media Caption Writing engagement includes Document (PDF/Word), delivered within 6 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Social Media Caption Writing?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-093",
    "slug": "research-paper-writing",
    "title": "Research Paper Writing",
    "category": "content-seo",
    "icon": "PenLine",
    "description": "Write research reports or papers",
    "valueProp": "Write research reports or papers",
    "tagline": "Write research reports or papers",
    "deliverable": "Document (PDF/Word)",
    "tiers": {
      "basic": 86,
      "standard": 243,
      "premium": 583
    },
    "days": 2,
    "subscriptionAvailable": true,
    "steps": [
      "Understand the audience and purpose",
      "Research the topic",
      "Draft engaging content",
      "Incorporate client feedback through revisions",
      "And deliver polished copy ready for publication"
    ],
    "integrations": [
      "Google Docs",
      "Microsoft Word",
      "Grammarly",
      "Notion"
    ],
    "faq": [
      {
        "q": "What is included in the Research Paper Writing service?",
        "a": "Each Research Paper Writing engagement includes Document (PDF/Word), delivered within 2 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Research Paper Writing?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Research Paper Writing?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Google Docs, Microsoft Word, Grammarly, Notion)."
      },
      {
        "q": "How many revisions are included in Research Paper Writing?",
        "a": "Each Research Paper Writing engagement includes Document (PDF/Word), delivered within 2 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Research Paper Writing?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-094",
    "slug": "editing-and-proofreading",
    "title": "Editing & Proofreading",
    "category": "content-seo",
    "icon": "PenLine",
    "description": "Polish and correct written content",
    "valueProp": "Polish and correct written content",
    "tagline": "Polish and correct written content",
    "deliverable": "Document (PDF/Word)",
    "tiers": {
      "basic": 74,
      "standard": 298,
      "premium": 338
    },
    "days": 7,
    "subscriptionAvailable": true,
    "steps": [
      "Understand the audience and purpose",
      "Research the topic",
      "Draft engaging content",
      "Incorporate client feedback through revisions",
      "And deliver polished copy ready for publication"
    ],
    "integrations": [
      "Google Docs",
      "Microsoft Word",
      "Grammarly",
      "Notion"
    ],
    "faq": [
      {
        "q": "What is included in the Editing & Proofreading service?",
        "a": "Each Editing & Proofreading engagement includes Document (PDF/Word), delivered within 7 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Editing & Proofreading?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Editing & Proofreading?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Google Docs, Microsoft Word, Grammarly, Notion)."
      },
      {
        "q": "How many revisions are included in Editing & Proofreading?",
        "a": "Each Editing & Proofreading engagement includes Document (PDF/Word), delivered within 7 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Editing & Proofreading?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-095",
    "slug": "speech-writing",
    "title": "Speech Writing",
    "category": "content-seo",
    "icon": "PenLine",
    "description": "Write speeches for events",
    "valueProp": "Write speeches for events",
    "tagline": "Write speeches for events",
    "deliverable": "Document (PDF/Word)",
    "tiers": {
      "basic": 56,
      "standard": 249,
      "premium": 426
    },
    "days": 7,
    "subscriptionAvailable": true,
    "steps": [
      "Understand the audience and purpose",
      "Research the topic",
      "Draft engaging content",
      "Incorporate client feedback through revisions",
      "And deliver polished copy ready for publication"
    ],
    "integrations": [
      "Google Docs",
      "Microsoft Word",
      "Grammarly",
      "Notion"
    ],
    "faq": [
      {
        "q": "What is included in the Speech Writing service?",
        "a": "Each Speech Writing engagement includes Document (PDF/Word), delivered within 7 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Speech Writing?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Speech Writing?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Google Docs, Microsoft Word, Grammarly, Notion)."
      },
      {
        "q": "How many revisions are included in Speech Writing?",
        "a": "Each Speech Writing engagement includes Document (PDF/Word), delivered within 7 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Speech Writing?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-096",
    "slug": "case-study-writing",
    "title": "Case Study Writing",
    "category": "content-seo",
    "icon": "PenLine",
    "description": "Develop case studies highlighting success",
    "valueProp": "Develop case studies highlighting success",
    "tagline": "Develop case studies highlighting success",
    "deliverable": "Document (PDF/Word)",
    "tiers": {
      "basic": 86,
      "standard": 137,
      "premium": 673
    },
    "days": 2,
    "subscriptionAvailable": true,
    "steps": [
      "Understand the audience and purpose",
      "Research the topic",
      "Draft engaging content",
      "Incorporate client feedback through revisions",
      "And deliver polished copy ready for publication"
    ],
    "integrations": [
      "Google Docs",
      "Microsoft Word",
      "Grammarly",
      "Notion"
    ],
    "faq": [
      {
        "q": "What is included in the Case Study Writing service?",
        "a": "Each Case Study Writing engagement includes Document (PDF/Word), delivered within 2 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Case Study Writing?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Case Study Writing?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Google Docs, Microsoft Word, Grammarly, Notion)."
      },
      {
        "q": "How many revisions are included in Case Study Writing?",
        "a": "Each Case Study Writing engagement includes Document (PDF/Word), delivered within 2 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Case Study Writing?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-097",
    "slug": "podcast-show-notes",
    "title": "Podcast Show Notes",
    "category": "content-seo",
    "icon": "PenLine",
    "description": "Write summaries for podcast episodes",
    "valueProp": "Write summaries for podcast episodes",
    "tagline": "Write summaries for podcast episodes",
    "deliverable": "Document (PDF/Word)",
    "tiers": {
      "basic": 40,
      "standard": 171,
      "premium": 473
    },
    "days": 4,
    "subscriptionAvailable": true,
    "steps": [
      "Understand the audience and purpose",
      "Research the topic",
      "Draft engaging content",
      "Incorporate client feedback through revisions",
      "And deliver polished copy ready for publication"
    ],
    "integrations": [
      "Google Docs",
      "Microsoft Word",
      "Grammarly",
      "Notion"
    ],
    "faq": [
      {
        "q": "What is included in the Podcast Show Notes service?",
        "a": "Each Podcast Show Notes engagement includes Document (PDF/Word), delivered within 4 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Podcast Show Notes?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Podcast Show Notes?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Google Docs, Microsoft Word, Grammarly, Notion)."
      },
      {
        "q": "How many revisions are included in Podcast Show Notes?",
        "a": "Each Podcast Show Notes engagement includes Document (PDF/Word), delivered within 4 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Podcast Show Notes?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-098",
    "slug": "curriculum-design",
    "title": "Curriculum Design",
    "category": "content-seo",
    "icon": "PenLine",
    "description": "Develop educational curricula",
    "valueProp": "Develop educational curricula",
    "tagline": "Develop educational curricula",
    "deliverable": "Document (PDF/Word)",
    "tiers": {
      "basic": 73,
      "standard": 290,
      "premium": 585
    },
    "days": 2,
    "subscriptionAvailable": true,
    "steps": [
      "Understand the audience and purpose",
      "Research the topic",
      "Draft engaging content",
      "Incorporate client feedback through revisions",
      "And deliver polished copy ready for publication"
    ],
    "integrations": [
      "Google Docs",
      "Microsoft Word",
      "Grammarly",
      "Notion"
    ],
    "faq": [
      {
        "q": "What is included in the Curriculum Design service?",
        "a": "Each Curriculum Design engagement includes Document (PDF/Word), delivered within 2 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Curriculum Design?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Curriculum Design?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Google Docs, Microsoft Word, Grammarly, Notion)."
      },
      {
        "q": "How many revisions are included in Curriculum Design?",
        "a": "Each Curriculum Design engagement includes Document (PDF/Word), delivered within 2 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Curriculum Design?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-099",
    "slug": "business-plan-writing",
    "title": "Business Plan Writing",
    "category": "content-seo",
    "icon": "PenLine",
    "description": "Write business plans for startups",
    "valueProp": "Write business plans for startups",
    "tagline": "Write business plans for startups",
    "deliverable": "Document (PDF/Word)",
    "tiers": {
      "basic": 37,
      "standard": 161,
      "premium": 374
    },
    "days": 5,
    "subscriptionAvailable": true,
    "steps": [
      "Understand the audience and purpose",
      "Research the topic",
      "Draft engaging content",
      "Incorporate client feedback through revisions",
      "And deliver polished copy ready for publication"
    ],
    "integrations": [
      "Google Docs",
      "Microsoft Word",
      "Grammarly",
      "Notion"
    ],
    "faq": [
      {
        "q": "What is included in the Business Plan Writing service?",
        "a": "Each Business Plan Writing engagement includes Document (PDF/Word), delivered within 5 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Business Plan Writing?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Business Plan Writing?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Google Docs, Microsoft Word, Grammarly, Notion)."
      },
      {
        "q": "How many revisions are included in Business Plan Writing?",
        "a": "Each Business Plan Writing engagement includes Document (PDF/Word), delivered within 5 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Business Plan Writing?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-100",
    "slug": "linkedin-profile-optimization",
    "title": "LinkedIn Profile Optimization",
    "category": "content-seo",
    "icon": "PenLine",
    "description": "Optimize LinkedIn profiles",
    "valueProp": "Optimize LinkedIn profiles",
    "tagline": "Optimize LinkedIn profiles",
    "deliverable": "Document (PDF/Word)",
    "tiers": {
      "basic": 81,
      "standard": 238,
      "premium": 463
    },
    "days": 1,
    "subscriptionAvailable": true,
    "steps": [
      "Understand the audience and purpose",
      "Research the topic",
      "Draft engaging content",
      "Incorporate client feedback through revisions",
      "And deliver polished copy ready for publication"
    ],
    "integrations": [
      "Google Docs",
      "Microsoft Word",
      "Grammarly",
      "Notion"
    ],
    "faq": [
      {
        "q": "What is included in the LinkedIn Profile Optimization service?",
        "a": "Each LinkedIn Profile Optimization engagement includes Document (PDF/Word), delivered within 1 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for LinkedIn Profile Optimization?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start LinkedIn Profile Optimization?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Google Docs, Microsoft Word, Grammarly, Notion)."
      },
      {
        "q": "How many revisions are included in LinkedIn Profile Optimization?",
        "a": "Each LinkedIn Profile Optimization engagement includes Document (PDF/Word), delivered within 1 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after LinkedIn Profile Optimization?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-101",
    "slug": "seo-audit-and-optimization",
    "title": "SEO Audit & Optimization",
    "category": "marketing-acquisition",
    "icon": "Megaphone",
    "description": "Assess and optimize SEO performance",
    "valueProp": "Assess and optimize SEO performance",
    "tagline": "Assess and optimize SEO performance",
    "deliverable": "Campaign report",
    "tiers": {
      "basic": 105,
      "standard": 182,
      "premium": 515
    },
    "days": 2,
    "subscriptionAvailable": true,
    "steps": [
      "Audit current marketing efforts",
      "Define goals and target audience",
      "Develop a strategy and campaign assets",
      "Execute and monitor performance",
      "And provide detailed reporting and optimization"
    ],
    "integrations": [
      "MailChimp",
      "HubSpot",
      "Google Analytics",
      "Hootsuite",
      "Facebook Ads"
    ],
    "faq": [
      {
        "q": "What is included in the SEO Audit & Optimization service?",
        "a": "Each SEO Audit & Optimization engagement includes Campaign report, delivered within 2 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for SEO Audit & Optimization?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start SEO Audit & Optimization?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (MailChimp, HubSpot, Google Analytics, Hootsuite)."
      },
      {
        "q": "How many revisions are included in SEO Audit & Optimization?",
        "a": "Each SEO Audit & Optimization engagement includes Campaign report, delivered within 2 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after SEO Audit & Optimization?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-102",
    "slug": "social-media-management",
    "title": "Social Media Management",
    "category": "marketing-acquisition",
    "icon": "Megaphone",
    "description": "Manage social media accounts",
    "valueProp": "Manage social media accounts",
    "tagline": "Manage social media accounts",
    "deliverable": "Campaign report",
    "tiers": {
      "basic": 140,
      "standard": 249,
      "premium": 491
    },
    "days": 2,
    "subscriptionAvailable": true,
    "steps": [
      "Audit current marketing efforts",
      "Define goals and target audience",
      "Develop a strategy and campaign assets",
      "Execute and monitor performance",
      "And provide detailed reporting and optimization"
    ],
    "integrations": [
      "MailChimp",
      "HubSpot",
      "Google Analytics",
      "Hootsuite",
      "Facebook Ads"
    ],
    "faq": [
      {
        "q": "What is included in the Social Media Management service?",
        "a": "Each Social Media Management engagement includes Campaign report, delivered within 2 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Social Media Management?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Social Media Management?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (MailChimp, HubSpot, Google Analytics, Hootsuite)."
      },
      {
        "q": "How many revisions are included in Social Media Management?",
        "a": "Each Social Media Management engagement includes Campaign report, delivered within 2 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Social Media Management?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-103",
    "slug": "social-media-strategy",
    "title": "Social Media Strategy",
    "category": "marketing-acquisition",
    "icon": "Megaphone",
    "description": "Plan content and engagement strategies",
    "valueProp": "Plan content and engagement strategies",
    "tagline": "Plan content and engagement strategies",
    "deliverable": "Campaign report",
    "tiers": {
      "basic": 128,
      "standard": 239,
      "premium": 527
    },
    "days": 2,
    "subscriptionAvailable": true,
    "steps": [
      "Audit current marketing efforts",
      "Define goals and target audience",
      "Develop a strategy and campaign assets",
      "Execute and monitor performance",
      "And provide detailed reporting and optimization"
    ],
    "integrations": [
      "MailChimp",
      "HubSpot",
      "Google Analytics",
      "Hootsuite",
      "Facebook Ads"
    ],
    "faq": [
      {
        "q": "What is included in the Social Media Strategy service?",
        "a": "Each Social Media Strategy engagement includes Campaign report, delivered within 2 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Social Media Strategy?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Social Media Strategy?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (MailChimp, HubSpot, Google Analytics, Hootsuite)."
      },
      {
        "q": "How many revisions are included in Social Media Strategy?",
        "a": "Each Social Media Strategy engagement includes Campaign report, delivered within 2 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Social Media Strategy?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-104",
    "slug": "pay-per-click-campaign",
    "title": "Pay-Per-Click Campaign",
    "category": "marketing-acquisition",
    "icon": "Megaphone",
    "description": "Manage PPC advertising campaigns",
    "valueProp": "Manage PPC advertising campaigns",
    "tagline": "Manage PPC advertising campaigns",
    "deliverable": "Campaign report",
    "tiers": {
      "basic": 105,
      "standard": 258,
      "premium": 781
    },
    "days": 5,
    "subscriptionAvailable": true,
    "steps": [
      "Audit current marketing efforts",
      "Define goals and target audience",
      "Develop a strategy and campaign assets",
      "Execute and monitor performance",
      "And provide detailed reporting and optimization"
    ],
    "integrations": [
      "MailChimp",
      "HubSpot",
      "Google Analytics",
      "Hootsuite",
      "Facebook Ads"
    ],
    "faq": [
      {
        "q": "What is included in the Pay-Per-Click Campaign service?",
        "a": "Each Pay-Per-Click Campaign engagement includes Campaign report, delivered within 5 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Pay-Per-Click Campaign?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Pay-Per-Click Campaign?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (MailChimp, HubSpot, Google Analytics, Hootsuite)."
      },
      {
        "q": "How many revisions are included in Pay-Per-Click Campaign?",
        "a": "Each Pay-Per-Click Campaign engagement includes Campaign report, delivered within 5 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Pay-Per-Click Campaign?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-105",
    "slug": "email-marketing-campaign",
    "title": "Email Marketing Campaign",
    "category": "marketing-acquisition",
    "icon": "Megaphone",
    "description": "Design and execute email campaigns",
    "valueProp": "Design and execute email campaigns",
    "tagline": "Design and execute email campaigns",
    "deliverable": "Campaign report",
    "tiers": {
      "basic": 68,
      "standard": 190,
      "premium": 789
    },
    "days": 3,
    "subscriptionAvailable": true,
    "steps": [
      "Audit current marketing efforts",
      "Define goals and target audience",
      "Develop a strategy and campaign assets",
      "Execute and monitor performance",
      "And provide detailed reporting and optimization"
    ],
    "integrations": [
      "MailChimp",
      "HubSpot",
      "Google Analytics",
      "Hootsuite",
      "Facebook Ads"
    ],
    "faq": [
      {
        "q": "What is included in the Email Marketing Campaign service?",
        "a": "Each Email Marketing Campaign engagement includes Campaign report, delivered within 3 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Email Marketing Campaign?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Email Marketing Campaign?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (MailChimp, HubSpot, Google Analytics, Hootsuite)."
      },
      {
        "q": "How many revisions are included in Email Marketing Campaign?",
        "a": "Each Email Marketing Campaign engagement includes Campaign report, delivered within 3 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Email Marketing Campaign?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-106",
    "slug": "lead-generation",
    "title": "Lead Generation",
    "category": "marketing-acquisition",
    "icon": "Megaphone",
    "description": "Generate qualified leads for businesses",
    "valueProp": "Generate qualified leads for businesses",
    "tagline": "Generate qualified leads for businesses",
    "deliverable": "Campaign report",
    "tiers": {
      "basic": 141,
      "standard": 263,
      "premium": 480
    },
    "days": 3,
    "subscriptionAvailable": true,
    "steps": [
      "Audit current marketing efforts",
      "Define goals and target audience",
      "Develop a strategy and campaign assets",
      "Execute and monitor performance",
      "And provide detailed reporting and optimization"
    ],
    "integrations": [
      "MailChimp",
      "HubSpot",
      "Google Analytics",
      "Hootsuite",
      "Facebook Ads"
    ],
    "faq": [
      {
        "q": "What is included in the Lead Generation service?",
        "a": "Each Lead Generation engagement includes Campaign report, delivered within 3 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Lead Generation?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Lead Generation?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (MailChimp, HubSpot, Google Analytics, Hootsuite)."
      },
      {
        "q": "How many revisions are included in Lead Generation?",
        "a": "Each Lead Generation engagement includes Campaign report, delivered within 3 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Lead Generation?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-107",
    "slug": "marketing-automation-setup",
    "title": "Marketing Automation Setup",
    "category": "marketing-acquisition",
    "icon": "Megaphone",
    "description": "Implement marketing automation systems",
    "valueProp": "Implement marketing automation systems",
    "tagline": "Implement marketing automation systems",
    "deliverable": "Campaign report",
    "tiers": {
      "basic": 112,
      "standard": 276,
      "premium": 712
    },
    "days": 3,
    "subscriptionAvailable": true,
    "steps": [
      "Audit current marketing efforts",
      "Define goals and target audience",
      "Develop a strategy and campaign assets",
      "Execute and monitor performance",
      "And provide detailed reporting and optimization"
    ],
    "integrations": [
      "MailChimp",
      "HubSpot",
      "Google Analytics",
      "Hootsuite",
      "Facebook Ads"
    ],
    "faq": [
      {
        "q": "What is included in the Marketing Automation Setup service?",
        "a": "Each Marketing Automation Setup engagement includes Campaign report, delivered within 3 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Marketing Automation Setup?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Marketing Automation Setup?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (MailChimp, HubSpot, Google Analytics, Hootsuite)."
      },
      {
        "q": "How many revisions are included in Marketing Automation Setup?",
        "a": "Each Marketing Automation Setup engagement includes Campaign report, delivered within 3 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Marketing Automation Setup?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-108",
    "slug": "marketing-strategy-consulting",
    "title": "Marketing Strategy Consulting",
    "category": "marketing-acquisition",
    "icon": "Megaphone",
    "description": "Provide strategic marketing guidance",
    "valueProp": "Provide strategic marketing guidance",
    "tagline": "Provide strategic marketing guidance",
    "deliverable": "Campaign report",
    "tiers": {
      "basic": 56,
      "standard": 374,
      "premium": 744
    },
    "days": 3,
    "subscriptionAvailable": true,
    "steps": [
      "Audit current marketing efforts",
      "Define goals and target audience",
      "Develop a strategy and campaign assets",
      "Execute and monitor performance",
      "And provide detailed reporting and optimization"
    ],
    "integrations": [
      "MailChimp",
      "HubSpot",
      "Google Analytics",
      "Hootsuite",
      "Facebook Ads"
    ],
    "faq": [
      {
        "q": "What is included in the Marketing Strategy Consulting service?",
        "a": "Each Marketing Strategy Consulting engagement includes Campaign report, delivered within 3 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Marketing Strategy Consulting?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Marketing Strategy Consulting?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (MailChimp, HubSpot, Google Analytics, Hootsuite)."
      },
      {
        "q": "How many revisions are included in Marketing Strategy Consulting?",
        "a": "Each Marketing Strategy Consulting engagement includes Campaign report, delivered within 3 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Marketing Strategy Consulting?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-109",
    "slug": "content-marketing-plan",
    "title": "Content Marketing Plan",
    "category": "marketing-acquisition",
    "icon": "Megaphone",
    "description": "Plan and manage content strategy",
    "valueProp": "Plan and manage content strategy",
    "tagline": "Plan and manage content strategy",
    "deliverable": "Campaign report",
    "tiers": {
      "basic": 110,
      "standard": 194,
      "premium": 690
    },
    "days": 3,
    "subscriptionAvailable": true,
    "steps": [
      "Audit current marketing efforts",
      "Define goals and target audience",
      "Develop a strategy and campaign assets",
      "Execute and monitor performance",
      "And provide detailed reporting and optimization"
    ],
    "integrations": [
      "MailChimp",
      "HubSpot",
      "Google Analytics",
      "Hootsuite",
      "Facebook Ads"
    ],
    "faq": [
      {
        "q": "What is included in the Content Marketing Plan service?",
        "a": "Each Content Marketing Plan engagement includes Campaign report, delivered within 3 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Content Marketing Plan?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Content Marketing Plan?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (MailChimp, HubSpot, Google Analytics, Hootsuite)."
      },
      {
        "q": "How many revisions are included in Content Marketing Plan?",
        "a": "Each Content Marketing Plan engagement includes Campaign report, delivered within 3 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Content Marketing Plan?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-110",
    "slug": "influencer-marketing-campaign",
    "title": "Influencer Marketing Campaign",
    "category": "marketing-acquisition",
    "icon": "Megaphone",
    "description": "Coordinate influencer partnerships",
    "valueProp": "Coordinate influencer partnerships",
    "tagline": "Coordinate influencer partnerships",
    "deliverable": "Campaign report",
    "tiers": {
      "basic": 63,
      "standard": 302,
      "premium": 626
    },
    "days": 3,
    "subscriptionAvailable": true,
    "steps": [
      "Audit current marketing efforts",
      "Define goals and target audience",
      "Develop a strategy and campaign assets",
      "Execute and monitor performance",
      "And provide detailed reporting and optimization"
    ],
    "integrations": [
      "MailChimp",
      "HubSpot",
      "Google Analytics",
      "Hootsuite",
      "Facebook Ads"
    ],
    "faq": [
      {
        "q": "What is included in the Influencer Marketing Campaign service?",
        "a": "Each Influencer Marketing Campaign engagement includes Campaign report, delivered within 3 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Influencer Marketing Campaign?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Influencer Marketing Campaign?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (MailChimp, HubSpot, Google Analytics, Hootsuite)."
      },
      {
        "q": "How many revisions are included in Influencer Marketing Campaign?",
        "a": "Each Influencer Marketing Campaign engagement includes Campaign report, delivered within 3 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Influencer Marketing Campaign?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-111",
    "slug": "analytics-and-reporting",
    "title": "Analytics & Reporting",
    "category": "marketing-acquisition",
    "icon": "Megaphone",
    "description": "Track and report marketing performance",
    "valueProp": "Track and report marketing performance",
    "tagline": "Track and report marketing performance",
    "deliverable": "Campaign report",
    "tiers": {
      "basic": 59,
      "standard": 205,
      "premium": 703
    },
    "days": 3,
    "subscriptionAvailable": true,
    "steps": [
      "Audit current marketing efforts",
      "Define goals and target audience",
      "Develop a strategy and campaign assets",
      "Execute and monitor performance",
      "And provide detailed reporting and optimization"
    ],
    "integrations": [
      "MailChimp",
      "HubSpot",
      "Google Analytics",
      "Hootsuite",
      "Facebook Ads"
    ],
    "faq": [
      {
        "q": "What is included in the Analytics & Reporting service?",
        "a": "Each Analytics & Reporting engagement includes Campaign report, delivered within 3 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Analytics & Reporting?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Analytics & Reporting?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (MailChimp, HubSpot, Google Analytics, Hootsuite)."
      },
      {
        "q": "How many revisions are included in Analytics & Reporting?",
        "a": "Each Analytics & Reporting engagement includes Campaign report, delivered within 3 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Analytics & Reporting?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-112",
    "slug": "conversion-rate-optimization",
    "title": "Conversion Rate Optimization",
    "category": "marketing-acquisition",
    "icon": "Megaphone",
    "description": "Improve website conversion rates",
    "valueProp": "Improve website conversion rates",
    "tagline": "Improve website conversion rates",
    "deliverable": "Campaign report",
    "tiers": {
      "basic": 65,
      "standard": 318,
      "premium": 467
    },
    "days": 4,
    "subscriptionAvailable": true,
    "steps": [
      "Audit current marketing efforts",
      "Define goals and target audience",
      "Develop a strategy and campaign assets",
      "Execute and monitor performance",
      "And provide detailed reporting and optimization"
    ],
    "integrations": [
      "MailChimp",
      "HubSpot",
      "Google Analytics",
      "Hootsuite",
      "Facebook Ads"
    ],
    "faq": [
      {
        "q": "What is included in the Conversion Rate Optimization service?",
        "a": "Each Conversion Rate Optimization engagement includes Campaign report, delivered within 4 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Conversion Rate Optimization?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Conversion Rate Optimization?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (MailChimp, HubSpot, Google Analytics, Hootsuite)."
      },
      {
        "q": "How many revisions are included in Conversion Rate Optimization?",
        "a": "Each Conversion Rate Optimization engagement includes Campaign report, delivered within 4 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Conversion Rate Optimization?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-113",
    "slug": "brand-awareness-campaign",
    "title": "Brand Awareness Campaign",
    "category": "marketing-acquisition",
    "icon": "Megaphone",
    "description": "Increase brand visibility",
    "valueProp": "Increase brand visibility",
    "tagline": "Increase brand visibility",
    "deliverable": "Campaign report",
    "tiers": {
      "basic": 62,
      "standard": 285,
      "premium": 658
    },
    "days": 10,
    "subscriptionAvailable": true,
    "steps": [
      "Audit current marketing efforts",
      "Define goals and target audience",
      "Develop a strategy and campaign assets",
      "Execute and monitor performance",
      "And provide detailed reporting and optimization"
    ],
    "integrations": [
      "MailChimp",
      "HubSpot",
      "Google Analytics",
      "Hootsuite",
      "Facebook Ads"
    ],
    "faq": [
      {
        "q": "What is included in the Brand Awareness Campaign service?",
        "a": "Each Brand Awareness Campaign engagement includes Campaign report, delivered within 10 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Brand Awareness Campaign?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Brand Awareness Campaign?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (MailChimp, HubSpot, Google Analytics, Hootsuite)."
      },
      {
        "q": "How many revisions are included in Brand Awareness Campaign?",
        "a": "Each Brand Awareness Campaign engagement includes Campaign report, delivered within 10 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Brand Awareness Campaign?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-114",
    "slug": "viral-marketing-strategy",
    "title": "Viral Marketing Strategy",
    "category": "marketing-acquisition",
    "icon": "Megaphone",
    "description": "Plan campaigns aimed at virality",
    "valueProp": "Plan campaigns aimed at virality",
    "tagline": "Plan campaigns aimed at virality",
    "deliverable": "Campaign report",
    "tiers": {
      "basic": 101,
      "standard": 211,
      "premium": 562
    },
    "days": 4,
    "subscriptionAvailable": true,
    "steps": [
      "Audit current marketing efforts",
      "Define goals and target audience",
      "Develop a strategy and campaign assets",
      "Execute and monitor performance",
      "And provide detailed reporting and optimization"
    ],
    "integrations": [
      "MailChimp",
      "HubSpot",
      "Google Analytics",
      "Hootsuite",
      "Facebook Ads"
    ],
    "faq": [
      {
        "q": "What is included in the Viral Marketing Strategy service?",
        "a": "Each Viral Marketing Strategy engagement includes Campaign report, delivered within 4 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Viral Marketing Strategy?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Viral Marketing Strategy?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (MailChimp, HubSpot, Google Analytics, Hootsuite)."
      },
      {
        "q": "How many revisions are included in Viral Marketing Strategy?",
        "a": "Each Viral Marketing Strategy engagement includes Campaign report, delivered within 4 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Viral Marketing Strategy?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-115",
    "slug": "podcast-marketing",
    "title": "Podcast Marketing",
    "category": "marketing-acquisition",
    "icon": "Megaphone",
    "description": "Promote podcasts and grow audience",
    "valueProp": "Promote podcasts and grow audience",
    "tagline": "Promote podcasts and grow audience",
    "deliverable": "Campaign report",
    "tiers": {
      "basic": 94,
      "standard": 188,
      "premium": 570
    },
    "days": 5,
    "subscriptionAvailable": true,
    "steps": [
      "Audit current marketing efforts",
      "Define goals and target audience",
      "Develop a strategy and campaign assets",
      "Execute and monitor performance",
      "And provide detailed reporting and optimization"
    ],
    "integrations": [
      "MailChimp",
      "HubSpot",
      "Google Analytics",
      "Hootsuite",
      "Facebook Ads"
    ],
    "faq": [
      {
        "q": "What is included in the Podcast Marketing service?",
        "a": "Each Podcast Marketing engagement includes Campaign report, delivered within 5 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Podcast Marketing?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Podcast Marketing?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (MailChimp, HubSpot, Google Analytics, Hootsuite)."
      },
      {
        "q": "How many revisions are included in Podcast Marketing?",
        "a": "Each Podcast Marketing engagement includes Campaign report, delivered within 5 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Podcast Marketing?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-116",
    "slug": "affiliate-marketing-program",
    "title": "Affiliate Marketing Program",
    "category": "marketing-acquisition",
    "icon": "Megaphone",
    "description": "Set up affiliate marketing programs",
    "valueProp": "Set up affiliate marketing programs",
    "tagline": "Set up affiliate marketing programs",
    "deliverable": "Campaign report",
    "tiers": {
      "basic": 143,
      "standard": 329,
      "premium": 705
    },
    "days": 3,
    "subscriptionAvailable": true,
    "steps": [
      "Audit current marketing efforts",
      "Define goals and target audience",
      "Develop a strategy and campaign assets",
      "Execute and monitor performance",
      "And provide detailed reporting and optimization"
    ],
    "integrations": [
      "MailChimp",
      "HubSpot",
      "Google Analytics",
      "Hootsuite",
      "Facebook Ads"
    ],
    "faq": [
      {
        "q": "What is included in the Affiliate Marketing Program service?",
        "a": "Each Affiliate Marketing Program engagement includes Campaign report, delivered within 3 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Affiliate Marketing Program?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Affiliate Marketing Program?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (MailChimp, HubSpot, Google Analytics, Hootsuite)."
      },
      {
        "q": "How many revisions are included in Affiliate Marketing Program?",
        "a": "Each Affiliate Marketing Program engagement includes Campaign report, delivered within 3 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Affiliate Marketing Program?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-117",
    "slug": "market-research",
    "title": "Market Research",
    "category": "marketing-acquisition",
    "icon": "Megaphone",
    "description": "Conduct research on markets and competitors",
    "valueProp": "Conduct research on markets and competitors",
    "tagline": "Conduct research on markets and competitors",
    "deliverable": "Campaign report",
    "tiers": {
      "basic": 59,
      "standard": 187,
      "premium": 684
    },
    "days": 7,
    "subscriptionAvailable": true,
    "steps": [
      "Audit current marketing efforts",
      "Define goals and target audience",
      "Develop a strategy and campaign assets",
      "Execute and monitor performance",
      "And provide detailed reporting and optimization"
    ],
    "integrations": [
      "MailChimp",
      "HubSpot",
      "Google Analytics",
      "Hootsuite",
      "Facebook Ads"
    ],
    "faq": [
      {
        "q": "What is included in the Market Research service?",
        "a": "Each Market Research engagement includes Campaign report, delivered within 7 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Market Research?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Market Research?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (MailChimp, HubSpot, Google Analytics, Hootsuite)."
      },
      {
        "q": "How many revisions are included in Market Research?",
        "a": "Each Market Research engagement includes Campaign report, delivered within 7 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Market Research?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-118",
    "slug": "customer-journey-mapping",
    "title": "Customer Journey Mapping",
    "category": "marketing-acquisition",
    "icon": "Megaphone",
    "description": "Map customer experiences and touchpoints",
    "valueProp": "Map customer experiences and touchpoints",
    "tagline": "Map customer experiences and touchpoints",
    "deliverable": "Campaign report",
    "tiers": {
      "basic": 54,
      "standard": 227,
      "premium": 429
    },
    "days": 4,
    "subscriptionAvailable": true,
    "steps": [
      "Audit current marketing efforts",
      "Define goals and target audience",
      "Develop a strategy and campaign assets",
      "Execute and monitor performance",
      "And provide detailed reporting and optimization"
    ],
    "integrations": [
      "MailChimp",
      "HubSpot",
      "Google Analytics",
      "Hootsuite",
      "Facebook Ads"
    ],
    "faq": [
      {
        "q": "What is included in the Customer Journey Mapping service?",
        "a": "Each Customer Journey Mapping engagement includes Campaign report, delivered within 4 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Customer Journey Mapping?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Customer Journey Mapping?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (MailChimp, HubSpot, Google Analytics, Hootsuite)."
      },
      {
        "q": "How many revisions are included in Customer Journey Mapping?",
        "a": "Each Customer Journey Mapping engagement includes Campaign report, delivered within 4 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Customer Journey Mapping?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-119",
    "slug": "sales-funnel-design",
    "title": "Sales Funnel Design",
    "category": "marketing-acquisition",
    "icon": "Megaphone",
    "description": "Design sales funnels for conversions",
    "valueProp": "Design sales funnels for conversions",
    "tagline": "Design sales funnels for conversions",
    "deliverable": "Campaign report",
    "tiers": {
      "basic": 66,
      "standard": 202,
      "premium": 747
    },
    "days": 2,
    "subscriptionAvailable": true,
    "steps": [
      "Audit current marketing efforts",
      "Define goals and target audience",
      "Develop a strategy and campaign assets",
      "Execute and monitor performance",
      "And provide detailed reporting and optimization"
    ],
    "integrations": [
      "MailChimp",
      "HubSpot",
      "Google Analytics",
      "Hootsuite",
      "Facebook Ads"
    ],
    "faq": [
      {
        "q": "What is included in the Sales Funnel Design service?",
        "a": "Each Sales Funnel Design engagement includes Campaign report, delivered within 2 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Sales Funnel Design?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Sales Funnel Design?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (MailChimp, HubSpot, Google Analytics, Hootsuite)."
      },
      {
        "q": "How many revisions are included in Sales Funnel Design?",
        "a": "Each Sales Funnel Design engagement includes Campaign report, delivered within 2 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Sales Funnel Design?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-120",
    "slug": "public-relations-outreach",
    "title": "Public Relations Outreach",
    "category": "marketing-acquisition",
    "icon": "Megaphone",
    "description": "Manage PR and media relations",
    "valueProp": "Manage PR and media relations",
    "tagline": "Manage PR and media relations",
    "deliverable": "Campaign report",
    "tiers": {
      "basic": 141,
      "standard": 188,
      "premium": 467
    },
    "days": 9,
    "subscriptionAvailable": true,
    "steps": [
      "Audit current marketing efforts",
      "Define goals and target audience",
      "Develop a strategy and campaign assets",
      "Execute and monitor performance",
      "And provide detailed reporting and optimization"
    ],
    "integrations": [
      "MailChimp",
      "HubSpot",
      "Google Analytics",
      "Hootsuite",
      "Facebook Ads"
    ],
    "faq": [
      {
        "q": "What is included in the Public Relations Outreach service?",
        "a": "Each Public Relations Outreach engagement includes Campaign report, delivered within 9 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Public Relations Outreach?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Public Relations Outreach?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (MailChimp, HubSpot, Google Analytics, Hootsuite)."
      },
      {
        "q": "How many revisions are included in Public Relations Outreach?",
        "a": "Each Public Relations Outreach engagement includes Campaign report, delivered within 9 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Public Relations Outreach?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-121",
    "slug": "event-promotion",
    "title": "Event Promotion",
    "category": "marketing-acquisition",
    "icon": "Megaphone",
    "description": "Promote events online and offline",
    "valueProp": "Promote events online and offline",
    "tagline": "Promote events online and offline",
    "deliverable": "Campaign report",
    "tiers": {
      "basic": 147,
      "standard": 318,
      "premium": 542
    },
    "days": 2,
    "subscriptionAvailable": true,
    "steps": [
      "Audit current marketing efforts",
      "Define goals and target audience",
      "Develop a strategy and campaign assets",
      "Execute and monitor performance",
      "And provide detailed reporting and optimization"
    ],
    "integrations": [
      "MailChimp",
      "HubSpot",
      "Google Analytics",
      "Hootsuite",
      "Facebook Ads"
    ],
    "faq": [
      {
        "q": "What is included in the Event Promotion service?",
        "a": "Each Event Promotion engagement includes Campaign report, delivered within 2 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Event Promotion?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Event Promotion?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (MailChimp, HubSpot, Google Analytics, Hootsuite)."
      },
      {
        "q": "How many revisions are included in Event Promotion?",
        "a": "Each Event Promotion engagement includes Campaign report, delivered within 2 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Event Promotion?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-122",
    "slug": "webinar-marketing",
    "title": "Webinar Marketing",
    "category": "marketing-acquisition",
    "icon": "Megaphone",
    "description": "Market webinars to target audiences",
    "valueProp": "Market webinars to target audiences",
    "tagline": "Market webinars to target audiences",
    "deliverable": "Campaign report",
    "tiers": {
      "basic": 108,
      "standard": 201,
      "premium": 647
    },
    "days": 8,
    "subscriptionAvailable": true,
    "steps": [
      "Audit current marketing efforts",
      "Define goals and target audience",
      "Develop a strategy and campaign assets",
      "Execute and monitor performance",
      "And provide detailed reporting and optimization"
    ],
    "integrations": [
      "MailChimp",
      "HubSpot",
      "Google Analytics",
      "Hootsuite",
      "Facebook Ads"
    ],
    "faq": [
      {
        "q": "What is included in the Webinar Marketing service?",
        "a": "Each Webinar Marketing engagement includes Campaign report, delivered within 8 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Webinar Marketing?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Webinar Marketing?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (MailChimp, HubSpot, Google Analytics, Hootsuite)."
      },
      {
        "q": "How many revisions are included in Webinar Marketing?",
        "a": "Each Webinar Marketing engagement includes Campaign report, delivered within 8 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Webinar Marketing?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-123",
    "slug": "community-management",
    "title": "Community Management",
    "category": "marketing-acquisition",
    "icon": "Megaphone",
    "description": "Manage online communities and forums",
    "valueProp": "Manage online communities and forums",
    "tagline": "Manage online communities and forums",
    "deliverable": "Campaign report",
    "tiers": {
      "basic": 84,
      "standard": 244,
      "premium": 438
    },
    "days": 3,
    "subscriptionAvailable": true,
    "steps": [
      "Audit current marketing efforts",
      "Define goals and target audience",
      "Develop a strategy and campaign assets",
      "Execute and monitor performance",
      "And provide detailed reporting and optimization"
    ],
    "integrations": [
      "MailChimp",
      "HubSpot",
      "Google Analytics",
      "Hootsuite",
      "Facebook Ads"
    ],
    "faq": [
      {
        "q": "What is included in the Community Management service?",
        "a": "Each Community Management engagement includes Campaign report, delivered within 3 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Community Management?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Community Management?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (MailChimp, HubSpot, Google Analytics, Hootsuite)."
      },
      {
        "q": "How many revisions are included in Community Management?",
        "a": "Each Community Management engagement includes Campaign report, delivered within 3 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Community Management?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-124",
    "slug": "brand-reputation-management",
    "title": "Brand Reputation Management",
    "category": "marketing-acquisition",
    "icon": "Megaphone",
    "description": "Monitor and manage online reputation",
    "valueProp": "Monitor and manage online reputation",
    "tagline": "Monitor and manage online reputation",
    "deliverable": "Campaign report",
    "tiers": {
      "basic": 53,
      "standard": 262,
      "premium": 664
    },
    "days": 9,
    "subscriptionAvailable": true,
    "steps": [
      "Audit current marketing efforts",
      "Define goals and target audience",
      "Develop a strategy and campaign assets",
      "Execute and monitor performance",
      "And provide detailed reporting and optimization"
    ],
    "integrations": [
      "MailChimp",
      "HubSpot",
      "Google Analytics",
      "Hootsuite",
      "Facebook Ads"
    ],
    "faq": [
      {
        "q": "What is included in the Brand Reputation Management service?",
        "a": "Each Brand Reputation Management engagement includes Campaign report, delivered within 9 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Brand Reputation Management?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Brand Reputation Management?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (MailChimp, HubSpot, Google Analytics, Hootsuite)."
      },
      {
        "q": "How many revisions are included in Brand Reputation Management?",
        "a": "Each Brand Reputation Management engagement includes Campaign report, delivered within 9 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Brand Reputation Management?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-125",
    "slug": "marketing-collateral-creation",
    "title": "Marketing Collateral Creation",
    "category": "marketing-acquisition",
    "icon": "Megaphone",
    "description": "Create brochures and collateral",
    "valueProp": "Create brochures and collateral",
    "tagline": "Create brochures and collateral",
    "deliverable": "Campaign report",
    "tiers": {
      "basic": 136,
      "standard": 350,
      "premium": 652
    },
    "days": 10,
    "subscriptionAvailable": true,
    "steps": [
      "Audit current marketing efforts",
      "Define goals and target audience",
      "Develop a strategy and campaign assets",
      "Execute and monitor performance",
      "And provide detailed reporting and optimization"
    ],
    "integrations": [
      "MailChimp",
      "HubSpot",
      "Google Analytics",
      "Hootsuite",
      "Facebook Ads"
    ],
    "faq": [
      {
        "q": "What is included in the Marketing Collateral Creation service?",
        "a": "Each Marketing Collateral Creation engagement includes Campaign report, delivered within 10 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Marketing Collateral Creation?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Marketing Collateral Creation?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (MailChimp, HubSpot, Google Analytics, Hootsuite)."
      },
      {
        "q": "How many revisions are included in Marketing Collateral Creation?",
        "a": "Each Marketing Collateral Creation engagement includes Campaign report, delivered within 10 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Marketing Collateral Creation?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-126",
    "slug": "video-editing-register",
    "title": "Video Editing",
    "category": "video-creative",
    "icon": "Video",
    "description": "Edit footage into polished videos",
    "valueProp": "Edit footage into polished videos",
    "tagline": "Edit footage into polished videos",
    "deliverable": "Video file (MP4)",
    "tiers": {
      "basic": 73,
      "standard": 250,
      "premium": 592
    },
    "days": 3,
    "subscriptionAvailable": true,
    "steps": [
      "Discuss objectives and style",
      "Develop script and storyboard",
      "Produce and edit the video or animation",
      "Incorporate feedback",
      "And deliver the final high‑quality file"
    ],
    "integrations": [
      "Adobe Premiere",
      "After Effects",
      "Final Cut Pro",
      "Canva"
    ],
    "faq": [
      {
        "q": "What is included in the Video Editing service?",
        "a": "Each Video Editing engagement includes Video file (MP4), delivered within 3 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Video Editing?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Video Editing?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Adobe Premiere, After Effects, Final Cut Pro, Canva)."
      },
      {
        "q": "How many revisions are included in Video Editing?",
        "a": "Each Video Editing engagement includes Video file (MP4), delivered within 3 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Video Editing?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-127",
    "slug": "short-form-video-editing",
    "title": "Short-Form Video Editing",
    "category": "video-creative",
    "icon": "Video",
    "description": "Edit content for reels and shorts",
    "valueProp": "Edit content for reels and shorts",
    "tagline": "Edit content for reels and shorts",
    "deliverable": "Video file (MP4)",
    "tiers": {
      "basic": 87,
      "standard": 336,
      "premium": 462
    },
    "days": 2,
    "subscriptionAvailable": true,
    "steps": [
      "Discuss objectives and style",
      "Develop script and storyboard",
      "Produce and edit the video or animation",
      "Incorporate feedback",
      "And deliver the final high‑quality file"
    ],
    "integrations": [
      "Adobe Premiere",
      "After Effects",
      "Final Cut Pro",
      "Canva"
    ],
    "faq": [
      {
        "q": "What is included in the Short-Form Video Editing service?",
        "a": "Each Short-Form Video Editing engagement includes Video file (MP4), delivered within 2 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Short-Form Video Editing?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Short-Form Video Editing?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Adobe Premiere, After Effects, Final Cut Pro, Canva)."
      },
      {
        "q": "How many revisions are included in Short-Form Video Editing?",
        "a": "Each Short-Form Video Editing engagement includes Video file (MP4), delivered within 2 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Short-Form Video Editing?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-128",
    "slug": "explainer-video-creation",
    "title": "Explainer Video Creation",
    "category": "video-creative",
    "icon": "Video",
    "description": "Create animated explainer videos",
    "valueProp": "Create animated explainer videos",
    "tagline": "Create animated explainer videos",
    "deliverable": "Video file (MP4)",
    "tiers": {
      "basic": 146,
      "standard": 250,
      "premium": 636
    },
    "days": 9,
    "subscriptionAvailable": true,
    "steps": [
      "Discuss objectives and style",
      "Develop script and storyboard",
      "Produce and edit the video or animation",
      "Incorporate feedback",
      "And deliver the final high‑quality file"
    ],
    "integrations": [
      "Adobe Premiere",
      "After Effects",
      "Final Cut Pro",
      "Canva"
    ],
    "faq": [
      {
        "q": "What is included in the Explainer Video Creation service?",
        "a": "Each Explainer Video Creation engagement includes Video file (MP4), delivered within 9 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Explainer Video Creation?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Explainer Video Creation?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Adobe Premiere, After Effects, Final Cut Pro, Canva)."
      },
      {
        "q": "How many revisions are included in Explainer Video Creation?",
        "a": "Each Explainer Video Creation engagement includes Video file (MP4), delivered within 9 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Explainer Video Creation?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-129",
    "slug": "2d-animation",
    "title": "2D Animation",
    "category": "video-creative",
    "icon": "Video",
    "description": "Produce two-dimensional animations",
    "valueProp": "Produce two-dimensional animations",
    "tagline": "Produce two-dimensional animations",
    "deliverable": "Video file (MP4)",
    "tiers": {
      "basic": 117,
      "standard": 316,
      "premium": 409
    },
    "days": 7,
    "subscriptionAvailable": true,
    "steps": [
      "Discuss objectives and style",
      "Develop script and storyboard",
      "Produce and edit the video or animation",
      "Incorporate feedback",
      "And deliver the final high‑quality file"
    ],
    "integrations": [
      "Adobe Premiere",
      "After Effects",
      "Final Cut Pro",
      "Canva"
    ],
    "faq": [
      {
        "q": "What is included in the 2D Animation service?",
        "a": "Each 2D Animation engagement includes Video file (MP4), delivered within 7 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for 2D Animation?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start 2D Animation?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Adobe Premiere, After Effects, Final Cut Pro, Canva)."
      },
      {
        "q": "How many revisions are included in 2D Animation?",
        "a": "Each 2D Animation engagement includes Video file (MP4), delivered within 7 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after 2D Animation?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-130",
    "slug": "3d-animation",
    "title": "3D Animation",
    "category": "video-creative",
    "icon": "Video",
    "description": "Create three-dimensional animations",
    "valueProp": "Create three-dimensional animations",
    "tagline": "Create three-dimensional animations",
    "deliverable": "Video file (MP4)",
    "tiers": {
      "basic": 99,
      "standard": 317,
      "premium": 561
    },
    "days": 2,
    "subscriptionAvailable": true,
    "steps": [
      "Discuss objectives and style",
      "Develop script and storyboard",
      "Produce and edit the video or animation",
      "Incorporate feedback",
      "And deliver the final high‑quality file"
    ],
    "integrations": [
      "Adobe Premiere",
      "After Effects",
      "Final Cut Pro",
      "Canva"
    ],
    "faq": [
      {
        "q": "What is included in the 3D Animation service?",
        "a": "Each 3D Animation engagement includes Video file (MP4), delivered within 2 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for 3D Animation?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start 3D Animation?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Adobe Premiere, After Effects, Final Cut Pro, Canva)."
      },
      {
        "q": "How many revisions are included in 3D Animation?",
        "a": "Each 3D Animation engagement includes Video file (MP4), delivered within 2 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after 3D Animation?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-131",
    "slug": "motion-graphics-register",
    "title": "Motion Graphics",
    "category": "video-creative",
    "icon": "Video",
    "description": "Animate graphics for motion projects",
    "valueProp": "Animate graphics for motion projects",
    "tagline": "Animate graphics for motion projects",
    "deliverable": "Video file (MP4)",
    "tiers": {
      "basic": 95,
      "standard": 175,
      "premium": 671
    },
    "days": 5,
    "subscriptionAvailable": true,
    "steps": [
      "Discuss objectives and style",
      "Develop script and storyboard",
      "Produce and edit the video or animation",
      "Incorporate feedback",
      "And deliver the final high‑quality file"
    ],
    "integrations": [
      "Adobe Premiere",
      "After Effects",
      "Final Cut Pro",
      "Canva"
    ],
    "faq": [
      {
        "q": "What is included in the Motion Graphics service?",
        "a": "Each Motion Graphics engagement includes Video file (MP4), delivered within 5 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Motion Graphics?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Motion Graphics?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Adobe Premiere, After Effects, Final Cut Pro, Canva)."
      },
      {
        "q": "How many revisions are included in Motion Graphics?",
        "a": "Each Motion Graphics engagement includes Video file (MP4), delivered within 5 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Motion Graphics?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-132",
    "slug": "whiteboard-animation",
    "title": "Whiteboard Animation",
    "category": "video-creative",
    "icon": "Video",
    "description": "Create whiteboard-style animations",
    "valueProp": "Create whiteboard-style animations",
    "tagline": "Create whiteboard-style animations",
    "deliverable": "Video file (MP4)",
    "tiers": {
      "basic": 97,
      "standard": 276,
      "premium": 657
    },
    "days": 6,
    "subscriptionAvailable": true,
    "steps": [
      "Discuss objectives and style",
      "Develop script and storyboard",
      "Produce and edit the video or animation",
      "Incorporate feedback",
      "And deliver the final high‑quality file"
    ],
    "integrations": [
      "Adobe Premiere",
      "After Effects",
      "Final Cut Pro",
      "Canva"
    ],
    "faq": [
      {
        "q": "What is included in the Whiteboard Animation service?",
        "a": "Each Whiteboard Animation engagement includes Video file (MP4), delivered within 6 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Whiteboard Animation?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Whiteboard Animation?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Adobe Premiere, After Effects, Final Cut Pro, Canva)."
      },
      {
        "q": "How many revisions are included in Whiteboard Animation?",
        "a": "Each Whiteboard Animation engagement includes Video file (MP4), delivered within 6 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Whiteboard Animation?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-133",
    "slug": "video-advertising",
    "title": "Video Advertising",
    "category": "video-creative",
    "icon": "Video",
    "description": "Produce video advertisements",
    "valueProp": "Produce video advertisements",
    "tagline": "Produce video advertisements",
    "deliverable": "Video file (MP4)",
    "tiers": {
      "basic": 54,
      "standard": 335,
      "premium": 485
    },
    "days": 6,
    "subscriptionAvailable": true,
    "steps": [
      "Discuss objectives and style",
      "Develop script and storyboard",
      "Produce and edit the video or animation",
      "Incorporate feedback",
      "And deliver the final high‑quality file"
    ],
    "integrations": [
      "Adobe Premiere",
      "After Effects",
      "Final Cut Pro",
      "Canva"
    ],
    "faq": [
      {
        "q": "What is included in the Video Advertising service?",
        "a": "Each Video Advertising engagement includes Video file (MP4), delivered within 6 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Video Advertising?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Video Advertising?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Adobe Premiere, After Effects, Final Cut Pro, Canva)."
      },
      {
        "q": "How many revisions are included in Video Advertising?",
        "a": "Each Video Advertising engagement includes Video file (MP4), delivered within 6 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Video Advertising?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-134",
    "slug": "intro-and-outro-clips",
    "title": "Intro & Outro Clips",
    "category": "video-creative",
    "icon": "Video",
    "description": "Design intros and outros for videos",
    "valueProp": "Design intros and outros for videos",
    "tagline": "Design intros and outros for videos",
    "deliverable": "Video file (MP4)",
    "tiers": {
      "basic": 61,
      "standard": 376,
      "premium": 762
    },
    "days": 9,
    "subscriptionAvailable": true,
    "steps": [
      "Discuss objectives and style",
      "Develop script and storyboard",
      "Produce and edit the video or animation",
      "Incorporate feedback",
      "And deliver the final high‑quality file"
    ],
    "integrations": [
      "Adobe Premiere",
      "After Effects",
      "Final Cut Pro",
      "Canva"
    ],
    "faq": [
      {
        "q": "What is included in the Intro & Outro Clips service?",
        "a": "Each Intro & Outro Clips engagement includes Video file (MP4), delivered within 9 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Intro & Outro Clips?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Intro & Outro Clips?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Adobe Premiere, After Effects, Final Cut Pro, Canva)."
      },
      {
        "q": "How many revisions are included in Intro & Outro Clips?",
        "a": "Each Intro & Outro Clips engagement includes Video file (MP4), delivered within 9 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Intro & Outro Clips?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-135",
    "slug": "course-video-production",
    "title": "Course Video Production",
    "category": "video-creative",
    "icon": "Video",
    "description": "Produce video courses and tutorials",
    "valueProp": "Produce video courses and tutorials",
    "tagline": "Produce video courses and tutorials",
    "deliverable": "Video file (MP4)",
    "tiers": {
      "basic": 70,
      "standard": 237,
      "premium": 651
    },
    "days": 8,
    "subscriptionAvailable": true,
    "steps": [
      "Discuss objectives and style",
      "Develop script and storyboard",
      "Produce and edit the video or animation",
      "Incorporate feedback",
      "And deliver the final high‑quality file"
    ],
    "integrations": [
      "Adobe Premiere",
      "After Effects",
      "Final Cut Pro",
      "Canva"
    ],
    "faq": [
      {
        "q": "What is included in the Course Video Production service?",
        "a": "Each Course Video Production engagement includes Video file (MP4), delivered within 8 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Course Video Production?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Course Video Production?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Adobe Premiere, After Effects, Final Cut Pro, Canva)."
      },
      {
        "q": "How many revisions are included in Course Video Production?",
        "a": "Each Course Video Production engagement includes Video file (MP4), delivered within 8 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Course Video Production?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-136",
    "slug": "cinematic-trailer",
    "title": "Cinematic Trailer",
    "category": "video-creative",
    "icon": "Video",
    "description": "Create cinematic trailers",
    "valueProp": "Create cinematic trailers",
    "tagline": "Create cinematic trailers",
    "deliverable": "Video file (MP4)",
    "tiers": {
      "basic": 65,
      "standard": 395,
      "premium": 703
    },
    "days": 8,
    "subscriptionAvailable": true,
    "steps": [
      "Discuss objectives and style",
      "Develop script and storyboard",
      "Produce and edit the video or animation",
      "Incorporate feedback",
      "And deliver the final high‑quality file"
    ],
    "integrations": [
      "Adobe Premiere",
      "After Effects",
      "Final Cut Pro",
      "Canva"
    ],
    "faq": [
      {
        "q": "What is included in the Cinematic Trailer service?",
        "a": "Each Cinematic Trailer engagement includes Video file (MP4), delivered within 8 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Cinematic Trailer?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Cinematic Trailer?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Adobe Premiere, After Effects, Final Cut Pro, Canva)."
      },
      {
        "q": "How many revisions are included in Cinematic Trailer?",
        "a": "Each Cinematic Trailer engagement includes Video file (MP4), delivered within 8 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Cinematic Trailer?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-137",
    "slug": "video-voiceover",
    "title": "Video Voiceover",
    "category": "video-creative",
    "icon": "Video",
    "description": "Provide voiceovers for videos",
    "valueProp": "Provide voiceovers for videos",
    "tagline": "Provide voiceovers for videos",
    "deliverable": "Video file (MP4)",
    "tiers": {
      "basic": 142,
      "standard": 220,
      "premium": 571
    },
    "days": 3,
    "subscriptionAvailable": true,
    "steps": [
      "Discuss objectives and style",
      "Develop script and storyboard",
      "Produce and edit the video or animation",
      "Incorporate feedback",
      "And deliver the final high‑quality file"
    ],
    "integrations": [
      "Adobe Premiere",
      "After Effects",
      "Final Cut Pro",
      "Canva"
    ],
    "faq": [
      {
        "q": "What is included in the Video Voiceover service?",
        "a": "Each Video Voiceover engagement includes Video file (MP4), delivered within 3 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Video Voiceover?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Video Voiceover?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Adobe Premiere, After Effects, Final Cut Pro, Canva)."
      },
      {
        "q": "How many revisions are included in Video Voiceover?",
        "a": "Each Video Voiceover engagement includes Video file (MP4), delivered within 3 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Video Voiceover?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-138",
    "slug": "storyboarding-register",
    "title": "Storyboarding",
    "category": "video-creative",
    "icon": "Video",
    "description": "Plan visuals with storyboards",
    "valueProp": "Plan visuals with storyboards",
    "tagline": "Plan visuals with storyboards",
    "deliverable": "Video file (MP4)",
    "tiers": {
      "basic": 51,
      "standard": 209,
      "premium": 798
    },
    "days": 8,
    "subscriptionAvailable": true,
    "steps": [
      "Discuss objectives and style",
      "Develop script and storyboard",
      "Produce and edit the video or animation",
      "Incorporate feedback",
      "And deliver the final high‑quality file"
    ],
    "integrations": [
      "Adobe Premiere",
      "After Effects",
      "Final Cut Pro",
      "Canva"
    ],
    "faq": [
      {
        "q": "What is included in the Storyboarding service?",
        "a": "Each Storyboarding engagement includes Video file (MP4), delivered within 8 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Storyboarding?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Storyboarding?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Adobe Premiere, After Effects, Final Cut Pro, Canva)."
      },
      {
        "q": "How many revisions are included in Storyboarding?",
        "a": "Each Storyboarding engagement includes Video file (MP4), delivered within 8 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Storyboarding?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-139",
    "slug": "video-scriptwriting",
    "title": "Video Scriptwriting",
    "category": "video-creative",
    "icon": "Video",
    "description": "Write scripts for video production",
    "valueProp": "Write scripts for video production",
    "tagline": "Write scripts for video production",
    "deliverable": "Video file (MP4)",
    "tiers": {
      "basic": 147,
      "standard": 183,
      "premium": 609
    },
    "days": 4,
    "subscriptionAvailable": true,
    "steps": [
      "Discuss objectives and style",
      "Develop script and storyboard",
      "Produce and edit the video or animation",
      "Incorporate feedback",
      "And deliver the final high‑quality file"
    ],
    "integrations": [
      "Adobe Premiere",
      "After Effects",
      "Final Cut Pro",
      "Canva"
    ],
    "faq": [
      {
        "q": "What is included in the Video Scriptwriting service?",
        "a": "Each Video Scriptwriting engagement includes Video file (MP4), delivered within 4 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Video Scriptwriting?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Video Scriptwriting?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Adobe Premiere, After Effects, Final Cut Pro, Canva)."
      },
      {
        "q": "How many revisions are included in Video Scriptwriting?",
        "a": "Each Video Scriptwriting engagement includes Video file (MP4), delivered within 4 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Video Scriptwriting?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-140",
    "slug": "video-subtitling",
    "title": "Video Subtitling",
    "category": "video-creative",
    "icon": "Video",
    "description": "Add subtitles to videos",
    "valueProp": "Add subtitles to videos",
    "tagline": "Add subtitles to videos",
    "deliverable": "Video file (MP4)",
    "tiers": {
      "basic": 89,
      "standard": 162,
      "premium": 774
    },
    "days": 2,
    "subscriptionAvailable": true,
    "steps": [
      "Discuss objectives and style",
      "Develop script and storyboard",
      "Produce and edit the video or animation",
      "Incorporate feedback",
      "And deliver the final high‑quality file"
    ],
    "integrations": [
      "Adobe Premiere",
      "After Effects",
      "Final Cut Pro",
      "Canva"
    ],
    "faq": [
      {
        "q": "What is included in the Video Subtitling service?",
        "a": "Each Video Subtitling engagement includes Video file (MP4), delivered within 2 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Video Subtitling?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Video Subtitling?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Adobe Premiere, After Effects, Final Cut Pro, Canva)."
      },
      {
        "q": "How many revisions are included in Video Subtitling?",
        "a": "Each Video Subtitling engagement includes Video file (MP4), delivered within 2 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Video Subtitling?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-141",
    "slug": "product-demo-video",
    "title": "Product Demo Video",
    "category": "video-creative",
    "icon": "Video",
    "description": "Create product demonstration videos",
    "valueProp": "Create product demonstration videos",
    "tagline": "Create product demonstration videos",
    "deliverable": "Video file (MP4)",
    "tiers": {
      "basic": 106,
      "standard": 187,
      "premium": 512
    },
    "days": 9,
    "subscriptionAvailable": true,
    "steps": [
      "Discuss objectives and style",
      "Develop script and storyboard",
      "Produce and edit the video or animation",
      "Incorporate feedback",
      "And deliver the final high‑quality file"
    ],
    "integrations": [
      "Adobe Premiere",
      "After Effects",
      "Final Cut Pro",
      "Canva"
    ],
    "faq": [
      {
        "q": "What is included in the Product Demo Video service?",
        "a": "Each Product Demo Video engagement includes Video file (MP4), delivered within 9 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Product Demo Video?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Product Demo Video?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Adobe Premiere, After Effects, Final Cut Pro, Canva)."
      },
      {
        "q": "How many revisions are included in Product Demo Video?",
        "a": "Each Product Demo Video engagement includes Video file (MP4), delivered within 9 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Product Demo Video?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-142",
    "slug": "live-streaming-setup",
    "title": "Live Streaming Setup",
    "category": "video-creative",
    "icon": "Video",
    "description": "Set up live streaming systems",
    "valueProp": "Set up live streaming systems",
    "tagline": "Set up live streaming systems",
    "deliverable": "Video file (MP4)",
    "tiers": {
      "basic": 103,
      "standard": 316,
      "premium": 509
    },
    "days": 7,
    "subscriptionAvailable": true,
    "steps": [
      "Discuss objectives and style",
      "Develop script and storyboard",
      "Produce and edit the video or animation",
      "Incorporate feedback",
      "And deliver the final high‑quality file"
    ],
    "integrations": [
      "Adobe Premiere",
      "After Effects",
      "Final Cut Pro",
      "Canva"
    ],
    "faq": [
      {
        "q": "What is included in the Live Streaming Setup service?",
        "a": "Each Live Streaming Setup engagement includes Video file (MP4), delivered within 7 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Live Streaming Setup?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Live Streaming Setup?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Adobe Premiere, After Effects, Final Cut Pro, Canva)."
      },
      {
        "q": "How many revisions are included in Live Streaming Setup?",
        "a": "Each Live Streaming Setup engagement includes Video file (MP4), delivered within 7 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Live Streaming Setup?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-143",
    "slug": "color-grading",
    "title": "Color Grading",
    "category": "video-creative",
    "icon": "Video",
    "description": "Apply color correction and grading",
    "valueProp": "Apply color correction and grading",
    "tagline": "Apply color correction and grading",
    "deliverable": "Video file (MP4)",
    "tiers": {
      "basic": 97,
      "standard": 358,
      "premium": 768
    },
    "days": 3,
    "subscriptionAvailable": true,
    "steps": [
      "Discuss objectives and style",
      "Develop script and storyboard",
      "Produce and edit the video or animation",
      "Incorporate feedback",
      "And deliver the final high‑quality file"
    ],
    "integrations": [
      "Adobe Premiere",
      "After Effects",
      "Final Cut Pro",
      "Canva"
    ],
    "faq": [
      {
        "q": "What is included in the Color Grading service?",
        "a": "Each Color Grading engagement includes Video file (MP4), delivered within 3 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Color Grading?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Color Grading?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Adobe Premiere, After Effects, Final Cut Pro, Canva)."
      },
      {
        "q": "How many revisions are included in Color Grading?",
        "a": "Each Color Grading engagement includes Video file (MP4), delivered within 3 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Color Grading?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-144",
    "slug": "reels-and-tiktok-editing",
    "title": "Reels & TikTok Editing",
    "category": "video-creative",
    "icon": "Video",
    "description": "Edit short social videos",
    "valueProp": "Edit short social videos",
    "tagline": "Edit short social videos",
    "deliverable": "Video file (MP4)",
    "tiers": {
      "basic": 120,
      "standard": 368,
      "premium": 493
    },
    "days": 6,
    "subscriptionAvailable": true,
    "steps": [
      "Discuss objectives and style",
      "Develop script and storyboard",
      "Produce and edit the video or animation",
      "Incorporate feedback",
      "And deliver the final high‑quality file"
    ],
    "integrations": [
      "Adobe Premiere",
      "After Effects",
      "Final Cut Pro",
      "Canva"
    ],
    "faq": [
      {
        "q": "What is included in the Reels & TikTok Editing service?",
        "a": "Each Reels & TikTok Editing engagement includes Video file (MP4), delivered within 6 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Reels & TikTok Editing?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Reels & TikTok Editing?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Adobe Premiere, After Effects, Final Cut Pro, Canva)."
      },
      {
        "q": "How many revisions are included in Reels & TikTok Editing?",
        "a": "Each Reels & TikTok Editing engagement includes Video file (MP4), delivered within 6 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Reels & TikTok Editing?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-145",
    "slug": "video-content-strategy",
    "title": "Video Content Strategy",
    "category": "video-creative",
    "icon": "Video",
    "description": "Plan video content strategies",
    "valueProp": "Plan video content strategies",
    "tagline": "Plan video content strategies",
    "deliverable": "Video file (MP4)",
    "tiers": {
      "basic": 109,
      "standard": 367,
      "premium": 520
    },
    "days": 3,
    "subscriptionAvailable": true,
    "steps": [
      "Discuss objectives and style",
      "Develop script and storyboard",
      "Produce and edit the video or animation",
      "Incorporate feedback",
      "And deliver the final high‑quality file"
    ],
    "integrations": [
      "Adobe Premiere",
      "After Effects",
      "Final Cut Pro",
      "Canva"
    ],
    "faq": [
      {
        "q": "What is included in the Video Content Strategy service?",
        "a": "Each Video Content Strategy engagement includes Video file (MP4), delivered within 3 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Video Content Strategy?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Video Content Strategy?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Adobe Premiere, After Effects, Final Cut Pro, Canva)."
      },
      {
        "q": "How many revisions are included in Video Content Strategy?",
        "a": "Each Video Content Strategy engagement includes Video file (MP4), delivered within 3 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Video Content Strategy?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-146",
    "slug": "stop-motion-animation",
    "title": "Stop Motion Animation",
    "category": "video-creative",
    "icon": "Video",
    "description": "Create stop-motion animations",
    "valueProp": "Create stop-motion animations",
    "tagline": "Create stop-motion animations",
    "deliverable": "Video file (MP4)",
    "tiers": {
      "basic": 132,
      "standard": 214,
      "premium": 670
    },
    "days": 3,
    "subscriptionAvailable": true,
    "steps": [
      "Discuss objectives and style",
      "Develop script and storyboard",
      "Produce and edit the video or animation",
      "Incorporate feedback",
      "And deliver the final high‑quality file"
    ],
    "integrations": [
      "Adobe Premiere",
      "After Effects",
      "Final Cut Pro",
      "Canva"
    ],
    "faq": [
      {
        "q": "What is included in the Stop Motion Animation service?",
        "a": "Each Stop Motion Animation engagement includes Video file (MP4), delivered within 3 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Stop Motion Animation?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Stop Motion Animation?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Adobe Premiere, After Effects, Final Cut Pro, Canva)."
      },
      {
        "q": "How many revisions are included in Stop Motion Animation?",
        "a": "Each Stop Motion Animation engagement includes Video file (MP4), delivered within 3 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Stop Motion Animation?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-147",
    "slug": "vr-ar-video-production",
    "title": "VR/AR Video Production",
    "category": "video-creative",
    "icon": "Video",
    "description": "Produce virtual/augmented reality content",
    "valueProp": "Produce virtual/augmented reality content",
    "tagline": "Produce virtual/augmented reality content",
    "deliverable": "Video file (MP4)",
    "tiers": {
      "basic": 128,
      "standard": 306,
      "premium": 704
    },
    "days": 7,
    "subscriptionAvailable": true,
    "steps": [
      "Discuss objectives and style",
      "Develop script and storyboard",
      "Produce and edit the video or animation",
      "Incorporate feedback",
      "And deliver the final high‑quality file"
    ],
    "integrations": [
      "Adobe Premiere",
      "After Effects",
      "Final Cut Pro",
      "Canva"
    ],
    "faq": [
      {
        "q": "What is included in the VR/AR Video Production service?",
        "a": "Each VR/AR Video Production engagement includes Video file (MP4), delivered within 7 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for VR/AR Video Production?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start VR/AR Video Production?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Adobe Premiere, After Effects, Final Cut Pro, Canva)."
      },
      {
        "q": "How many revisions are included in VR/AR Video Production?",
        "a": "Each VR/AR Video Production engagement includes Video file (MP4), delivered within 7 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after VR/AR Video Production?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-148",
    "slug": "music-video-production",
    "title": "Music Video Production",
    "category": "video-creative",
    "icon": "Video",
    "description": "Create music videos",
    "valueProp": "Create music videos",
    "tagline": "Create music videos",
    "deliverable": "Video file (MP4)",
    "tiers": {
      "basic": 59,
      "standard": 388,
      "premium": 717
    },
    "days": 7,
    "subscriptionAvailable": true,
    "steps": [
      "Discuss objectives and style",
      "Develop script and storyboard",
      "Produce and edit the video or animation",
      "Incorporate feedback",
      "And deliver the final high‑quality file"
    ],
    "integrations": [
      "Adobe Premiere",
      "After Effects",
      "Final Cut Pro",
      "Canva"
    ],
    "faq": [
      {
        "q": "What is included in the Music Video Production service?",
        "a": "Each Music Video Production engagement includes Video file (MP4), delivered within 7 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Music Video Production?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Music Video Production?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Adobe Premiere, After Effects, Final Cut Pro, Canva)."
      },
      {
        "q": "How many revisions are included in Music Video Production?",
        "a": "Each Music Video Production engagement includes Video file (MP4), delivered within 7 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Music Video Production?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-149",
    "slug": "corporate-video-production",
    "title": "Corporate Video Production",
    "category": "video-creative",
    "icon": "Video",
    "description": "Produce corporate videos",
    "valueProp": "Produce corporate videos",
    "tagline": "Produce corporate videos",
    "deliverable": "Video file (MP4)",
    "tiers": {
      "basic": 55,
      "standard": 235,
      "premium": 654
    },
    "days": 10,
    "subscriptionAvailable": true,
    "steps": [
      "Discuss objectives and style",
      "Develop script and storyboard",
      "Produce and edit the video or animation",
      "Incorporate feedback",
      "And deliver the final high‑quality file"
    ],
    "integrations": [
      "Adobe Premiere",
      "After Effects",
      "Final Cut Pro",
      "Canva"
    ],
    "faq": [
      {
        "q": "What is included in the Corporate Video Production service?",
        "a": "Each Corporate Video Production engagement includes Video file (MP4), delivered within 10 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Corporate Video Production?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Corporate Video Production?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Adobe Premiere, After Effects, Final Cut Pro, Canva)."
      },
      {
        "q": "How many revisions are included in Corporate Video Production?",
        "a": "Each Corporate Video Production engagement includes Video file (MP4), delivered within 10 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Corporate Video Production?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-150",
    "slug": "video-hosting-and-management",
    "title": "Video Hosting & Management",
    "category": "video-creative",
    "icon": "Video",
    "description": "Manage video hosting platforms",
    "valueProp": "Manage video hosting platforms",
    "tagline": "Manage video hosting platforms",
    "deliverable": "Video file (MP4)",
    "tiers": {
      "basic": 53,
      "standard": 341,
      "premium": 566
    },
    "days": 10,
    "subscriptionAvailable": true,
    "steps": [
      "Discuss objectives and style",
      "Develop script and storyboard",
      "Produce and edit the video or animation",
      "Incorporate feedback",
      "And deliver the final high‑quality file"
    ],
    "integrations": [
      "Adobe Premiere",
      "After Effects",
      "Final Cut Pro",
      "Canva"
    ],
    "faq": [
      {
        "q": "What is included in the Video Hosting & Management service?",
        "a": "Each Video Hosting & Management engagement includes Video file (MP4), delivered within 10 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Video Hosting & Management?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Video Hosting & Management?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Adobe Premiere, After Effects, Final Cut Pro, Canva)."
      },
      {
        "q": "How many revisions are included in Video Hosting & Management?",
        "a": "Each Video Hosting & Management engagement includes Video file (MP4), delivered within 10 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Video Hosting & Management?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-151",
    "slug": "voice-over-recording",
    "title": "Voice-Over Recording",
    "category": "video-creative",
    "icon": "Video",
    "description": "Record professional voiceovers",
    "valueProp": "Record professional voiceovers",
    "tagline": "Record professional voiceovers",
    "deliverable": "Audio file (MP3)",
    "tiers": {
      "basic": 65,
      "standard": 104,
      "premium": 575
    },
    "days": 4,
    "subscriptionAvailable": true,
    "steps": [
      "Define the desired sound and style",
      "Compose or record the audio",
      "Mix and master to professional standards",
      "And deliver final audio files in required formats"
    ],
    "integrations": [
      "Pro Tools",
      "Logic Pro",
      "Ableton Live",
      "Audacity"
    ],
    "faq": [
      {
        "q": "What is included in the Voice-Over Recording service?",
        "a": "Each Voice-Over Recording engagement includes Audio file (MP3), delivered within 4 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Voice-Over Recording?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Voice-Over Recording?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Pro Tools, Logic Pro, Ableton Live, Audacity)."
      },
      {
        "q": "How many revisions are included in Voice-Over Recording?",
        "a": "Each Voice-Over Recording engagement includes Audio file (MP3), delivered within 4 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Voice-Over Recording?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-152",
    "slug": "podcast-production",
    "title": "Podcast Production",
    "category": "video-creative",
    "icon": "Video",
    "description": "Produce and edit podcasts",
    "valueProp": "Produce and edit podcasts",
    "tagline": "Produce and edit podcasts",
    "deliverable": "Audio file (MP3)",
    "tiers": {
      "basic": 99,
      "standard": 246,
      "premium": 552
    },
    "days": 6,
    "subscriptionAvailable": true,
    "steps": [
      "Define the desired sound and style",
      "Compose or record the audio",
      "Mix and master to professional standards",
      "And deliver final audio files in required formats"
    ],
    "integrations": [
      "Pro Tools",
      "Logic Pro",
      "Ableton Live",
      "Audacity"
    ],
    "faq": [
      {
        "q": "What is included in the Podcast Production service?",
        "a": "Each Podcast Production engagement includes Audio file (MP3), delivered within 6 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Podcast Production?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Podcast Production?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Pro Tools, Logic Pro, Ableton Live, Audacity)."
      },
      {
        "q": "How many revisions are included in Podcast Production?",
        "a": "Each Podcast Production engagement includes Audio file (MP3), delivered within 6 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Podcast Production?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-153",
    "slug": "music-composition",
    "title": "Music Composition",
    "category": "video-creative",
    "icon": "Video",
    "description": "Compose original music pieces",
    "valueProp": "Compose original music pieces",
    "tagline": "Compose original music pieces",
    "deliverable": "Audio file (MP3)",
    "tiers": {
      "basic": 32,
      "standard": 248,
      "premium": 567
    },
    "days": 3,
    "subscriptionAvailable": true,
    "steps": [
      "Define the desired sound and style",
      "Compose or record the audio",
      "Mix and master to professional standards",
      "And deliver final audio files in required formats"
    ],
    "integrations": [
      "Pro Tools",
      "Logic Pro",
      "Ableton Live",
      "Audacity"
    ],
    "faq": [
      {
        "q": "What is included in the Music Composition service?",
        "a": "Each Music Composition engagement includes Audio file (MP3), delivered within 3 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Music Composition?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Music Composition?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Pro Tools, Logic Pro, Ableton Live, Audacity)."
      },
      {
        "q": "How many revisions are included in Music Composition?",
        "a": "Each Music Composition engagement includes Audio file (MP3), delivered within 3 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Music Composition?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-154",
    "slug": "jingle-creation",
    "title": "Jingle Creation",
    "category": "video-creative",
    "icon": "Video",
    "description": "Create jingles for ads",
    "valueProp": "Create jingles for ads",
    "tagline": "Create jingles for ads",
    "deliverable": "Audio file (MP3)",
    "tiers": {
      "basic": 60,
      "standard": 297,
      "premium": 648
    },
    "days": 5,
    "subscriptionAvailable": true,
    "steps": [
      "Define the desired sound and style",
      "Compose or record the audio",
      "Mix and master to professional standards",
      "And deliver final audio files in required formats"
    ],
    "integrations": [
      "Pro Tools",
      "Logic Pro",
      "Ableton Live",
      "Audacity"
    ],
    "faq": [
      {
        "q": "What is included in the Jingle Creation service?",
        "a": "Each Jingle Creation engagement includes Audio file (MP3), delivered within 5 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Jingle Creation?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Jingle Creation?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Pro Tools, Logic Pro, Ableton Live, Audacity)."
      },
      {
        "q": "How many revisions are included in Jingle Creation?",
        "a": "Each Jingle Creation engagement includes Audio file (MP3), delivered within 5 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Jingle Creation?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-155",
    "slug": "sound-design",
    "title": "Sound Design",
    "category": "video-creative",
    "icon": "Video",
    "description": "Design sound effects and atmospheres",
    "valueProp": "Design sound effects and atmospheres",
    "tagline": "Design sound effects and atmospheres",
    "deliverable": "Audio file (MP3)",
    "tiers": {
      "basic": 90,
      "standard": 296,
      "premium": 636
    },
    "days": 4,
    "subscriptionAvailable": true,
    "steps": [
      "Define the desired sound and style",
      "Compose or record the audio",
      "Mix and master to professional standards",
      "And deliver final audio files in required formats"
    ],
    "integrations": [
      "Pro Tools",
      "Logic Pro",
      "Ableton Live",
      "Audacity"
    ],
    "faq": [
      {
        "q": "What is included in the Sound Design service?",
        "a": "Each Sound Design engagement includes Audio file (MP3), delivered within 4 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Sound Design?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Sound Design?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Pro Tools, Logic Pro, Ableton Live, Audacity)."
      },
      {
        "q": "How many revisions are included in Sound Design?",
        "a": "Each Sound Design engagement includes Audio file (MP3), delivered within 4 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Sound Design?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-156",
    "slug": "audio-mixing-and-mastering",
    "title": "Audio Mixing & Mastering",
    "category": "video-creative",
    "icon": "Video",
    "description": "Mix and master audio tracks",
    "valueProp": "Mix and master audio tracks",
    "tagline": "Mix and master audio tracks",
    "deliverable": "Audio file (MP3)",
    "tiers": {
      "basic": 70,
      "standard": 101,
      "premium": 410
    },
    "days": 4,
    "subscriptionAvailable": true,
    "steps": [
      "Define the desired sound and style",
      "Compose or record the audio",
      "Mix and master to professional standards",
      "And deliver final audio files in required formats"
    ],
    "integrations": [
      "Pro Tools",
      "Logic Pro",
      "Ableton Live",
      "Audacity"
    ],
    "faq": [
      {
        "q": "What is included in the Audio Mixing & Mastering service?",
        "a": "Each Audio Mixing & Mastering engagement includes Audio file (MP3), delivered within 4 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Audio Mixing & Mastering?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Audio Mixing & Mastering?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Pro Tools, Logic Pro, Ableton Live, Audacity)."
      },
      {
        "q": "How many revisions are included in Audio Mixing & Mastering?",
        "a": "Each Audio Mixing & Mastering engagement includes Audio file (MP3), delivered within 4 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Audio Mixing & Mastering?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-157",
    "slug": "instrumental-session",
    "title": "Instrumental Session",
    "category": "video-creative",
    "icon": "Video",
    "description": "Provide instrumental recordings",
    "valueProp": "Provide instrumental recordings",
    "tagline": "Provide instrumental recordings",
    "deliverable": "Audio file (MP3)",
    "tiers": {
      "basic": 68,
      "standard": 241,
      "premium": 586
    },
    "days": 6,
    "subscriptionAvailable": true,
    "steps": [
      "Define the desired sound and style",
      "Compose or record the audio",
      "Mix and master to professional standards",
      "And deliver final audio files in required formats"
    ],
    "integrations": [
      "Pro Tools",
      "Logic Pro",
      "Ableton Live",
      "Audacity"
    ],
    "faq": [
      {
        "q": "What is included in the Instrumental Session service?",
        "a": "Each Instrumental Session engagement includes Audio file (MP3), delivered within 6 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Instrumental Session?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Instrumental Session?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Pro Tools, Logic Pro, Ableton Live, Audacity)."
      },
      {
        "q": "How many revisions are included in Instrumental Session?",
        "a": "Each Instrumental Session engagement includes Audio file (MP3), delivered within 6 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Instrumental Session?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-158",
    "slug": "audiobook-narration",
    "title": "Audiobook Narration",
    "category": "video-creative",
    "icon": "Video",
    "description": "Narrate audiobooks",
    "valueProp": "Narrate audiobooks",
    "tagline": "Narrate audiobooks",
    "deliverable": "Audio file (MP3)",
    "tiers": {
      "basic": 93,
      "standard": 129,
      "premium": 567
    },
    "days": 1,
    "subscriptionAvailable": true,
    "steps": [
      "Define the desired sound and style",
      "Compose or record the audio",
      "Mix and master to professional standards",
      "And deliver final audio files in required formats"
    ],
    "integrations": [
      "Pro Tools",
      "Logic Pro",
      "Ableton Live",
      "Audacity"
    ],
    "faq": [
      {
        "q": "What is included in the Audiobook Narration service?",
        "a": "Each Audiobook Narration engagement includes Audio file (MP3), delivered within 1 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Audiobook Narration?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Audiobook Narration?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Pro Tools, Logic Pro, Ableton Live, Audacity)."
      },
      {
        "q": "How many revisions are included in Audiobook Narration?",
        "a": "Each Audiobook Narration engagement includes Audio file (MP3), delivered within 1 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Audiobook Narration?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-159",
    "slug": "meditation-music",
    "title": "Meditation Music",
    "category": "video-creative",
    "icon": "Video",
    "description": "Compose meditation and ambient music",
    "valueProp": "Compose meditation and ambient music",
    "tagline": "Compose meditation and ambient music",
    "deliverable": "Audio file (MP3)",
    "tiers": {
      "basic": 91,
      "standard": 106,
      "premium": 389
    },
    "days": 5,
    "subscriptionAvailable": true,
    "steps": [
      "Define the desired sound and style",
      "Compose or record the audio",
      "Mix and master to professional standards",
      "And deliver final audio files in required formats"
    ],
    "integrations": [
      "Pro Tools",
      "Logic Pro",
      "Ableton Live",
      "Audacity"
    ],
    "faq": [
      {
        "q": "What is included in the Meditation Music service?",
        "a": "Each Meditation Music engagement includes Audio file (MP3), delivered within 5 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Meditation Music?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Meditation Music?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Pro Tools, Logic Pro, Ableton Live, Audacity)."
      },
      {
        "q": "How many revisions are included in Meditation Music?",
        "a": "Each Meditation Music engagement includes Audio file (MP3), delivered within 5 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Meditation Music?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-160",
    "slug": "sound-effects-library",
    "title": "Sound Effects Library",
    "category": "video-creative",
    "icon": "Video",
    "description": "Create collections of sound effects",
    "valueProp": "Create collections of sound effects",
    "tagline": "Create collections of sound effects",
    "deliverable": "Audio file (MP3)",
    "tiers": {
      "basic": 49,
      "standard": 137,
      "premium": 360
    },
    "days": 5,
    "subscriptionAvailable": true,
    "steps": [
      "Define the desired sound and style",
      "Compose or record the audio",
      "Mix and master to professional standards",
      "And deliver final audio files in required formats"
    ],
    "integrations": [
      "Pro Tools",
      "Logic Pro",
      "Ableton Live",
      "Audacity"
    ],
    "faq": [
      {
        "q": "What is included in the Sound Effects Library service?",
        "a": "Each Sound Effects Library engagement includes Audio file (MP3), delivered within 5 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Sound Effects Library?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Sound Effects Library?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Pro Tools, Logic Pro, Ableton Live, Audacity)."
      },
      {
        "q": "How many revisions are included in Sound Effects Library?",
        "a": "Each Sound Effects Library engagement includes Audio file (MP3), delivered within 5 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Sound Effects Library?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-161",
    "slug": "dj-drops",
    "title": "DJ Drops",
    "category": "video-creative",
    "icon": "Video",
    "description": "Produce DJ voice drops",
    "valueProp": "Produce DJ voice drops",
    "tagline": "Produce DJ voice drops",
    "deliverable": "Audio file (MP3)",
    "tiers": {
      "basic": 58,
      "standard": 151,
      "premium": 637
    },
    "days": 5,
    "subscriptionAvailable": true,
    "steps": [
      "Define the desired sound and style",
      "Compose or record the audio",
      "Mix and master to professional standards",
      "And deliver final audio files in required formats"
    ],
    "integrations": [
      "Pro Tools",
      "Logic Pro",
      "Ableton Live",
      "Audacity"
    ],
    "faq": [
      {
        "q": "What is included in the DJ Drops service?",
        "a": "Each DJ Drops engagement includes Audio file (MP3), delivered within 5 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for DJ Drops?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start DJ Drops?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Pro Tools, Logic Pro, Ableton Live, Audacity)."
      },
      {
        "q": "How many revisions are included in DJ Drops?",
        "a": "Each DJ Drops engagement includes Audio file (MP3), delivered within 5 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after DJ Drops?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-162",
    "slug": "vocal-tuning",
    "title": "Vocal Tuning",
    "category": "video-creative",
    "icon": "Video",
    "description": "Tune and edit vocals",
    "valueProp": "Tune and edit vocals",
    "tagline": "Tune and edit vocals",
    "deliverable": "Audio file (MP3)",
    "tiers": {
      "basic": 78,
      "standard": 105,
      "premium": 316
    },
    "days": 6,
    "subscriptionAvailable": true,
    "steps": [
      "Define the desired sound and style",
      "Compose or record the audio",
      "Mix and master to professional standards",
      "And deliver final audio files in required formats"
    ],
    "integrations": [
      "Pro Tools",
      "Logic Pro",
      "Ableton Live",
      "Audacity"
    ],
    "faq": [
      {
        "q": "What is included in the Vocal Tuning service?",
        "a": "Each Vocal Tuning engagement includes Audio file (MP3), delivered within 6 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Vocal Tuning?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Vocal Tuning?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Pro Tools, Logic Pro, Ableton Live, Audacity)."
      },
      {
        "q": "How many revisions are included in Vocal Tuning?",
        "a": "Each Vocal Tuning engagement includes Audio file (MP3), delivered within 6 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Vocal Tuning?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-163",
    "slug": "podcast-editing",
    "title": "Podcast Editing",
    "category": "video-creative",
    "icon": "Video",
    "description": "Edit podcasts for clarity",
    "valueProp": "Edit podcasts for clarity",
    "tagline": "Edit podcasts for clarity",
    "deliverable": "Audio file (MP3)",
    "tiers": {
      "basic": 94,
      "standard": 231,
      "premium": 301
    },
    "days": 2,
    "subscriptionAvailable": true,
    "steps": [
      "Define the desired sound and style",
      "Compose or record the audio",
      "Mix and master to professional standards",
      "And deliver final audio files in required formats"
    ],
    "integrations": [
      "Pro Tools",
      "Logic Pro",
      "Ableton Live",
      "Audacity"
    ],
    "faq": [
      {
        "q": "What is included in the Podcast Editing service?",
        "a": "Each Podcast Editing engagement includes Audio file (MP3), delivered within 2 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Podcast Editing?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Podcast Editing?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Pro Tools, Logic Pro, Ableton Live, Audacity)."
      },
      {
        "q": "How many revisions are included in Podcast Editing?",
        "a": "Each Podcast Editing engagement includes Audio file (MP3), delivered within 2 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Podcast Editing?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-164",
    "slug": "music-transcription",
    "title": "Music Transcription",
    "category": "video-creative",
    "icon": "Video",
    "description": "Transcribe music into notation",
    "valueProp": "Transcribe music into notation",
    "tagline": "Transcribe music into notation",
    "deliverable": "Audio file (MP3)",
    "tiers": {
      "basic": 78,
      "standard": 149,
      "premium": 503
    },
    "days": 3,
    "subscriptionAvailable": true,
    "steps": [
      "Define the desired sound and style",
      "Compose or record the audio",
      "Mix and master to professional standards",
      "And deliver final audio files in required formats"
    ],
    "integrations": [
      "Pro Tools",
      "Logic Pro",
      "Ableton Live",
      "Audacity"
    ],
    "faq": [
      {
        "q": "What is included in the Music Transcription service?",
        "a": "Each Music Transcription engagement includes Audio file (MP3), delivered within 3 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Music Transcription?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Music Transcription?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Pro Tools, Logic Pro, Ableton Live, Audacity)."
      },
      {
        "q": "How many revisions are included in Music Transcription?",
        "a": "Each Music Transcription engagement includes Audio file (MP3), delivered within 3 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Music Transcription?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-165",
    "slug": "songwriting",
    "title": "Songwriting",
    "category": "video-creative",
    "icon": "Video",
    "description": "Write songs and lyrics",
    "valueProp": "Write songs and lyrics",
    "tagline": "Write songs and lyrics",
    "deliverable": "Audio file (MP3)",
    "tiers": {
      "basic": 63,
      "standard": 282,
      "premium": 536
    },
    "days": 3,
    "subscriptionAvailable": true,
    "steps": [
      "Define the desired sound and style",
      "Compose or record the audio",
      "Mix and master to professional standards",
      "And deliver final audio files in required formats"
    ],
    "integrations": [
      "Pro Tools",
      "Logic Pro",
      "Ableton Live",
      "Audacity"
    ],
    "faq": [
      {
        "q": "What is included in the Songwriting service?",
        "a": "Each Songwriting engagement includes Audio file (MP3), delivered within 3 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Songwriting?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Songwriting?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Pro Tools, Logic Pro, Ableton Live, Audacity)."
      },
      {
        "q": "How many revisions are included in Songwriting?",
        "a": "Each Songwriting engagement includes Audio file (MP3), delivered within 3 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Songwriting?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-166",
    "slug": "data-analysis",
    "title": "Data Analysis",
    "category": "data-ai",
    "icon": "BrainCircuit",
    "description": "Analyze data to derive insights",
    "valueProp": "Analyze data to derive insights",
    "tagline": "Analyze data to derive insights",
    "deliverable": "Report/dashboard",
    "tiers": {
      "basic": 166,
      "standard": 280,
      "premium": 762
    },
    "days": 13,
    "subscriptionAvailable": true,
    "steps": [
      "Collect and clean data",
      "Perform exploratory analysis and modeling",
      "Build dashboards and visualizations",
      "Interpret results with actionable insights",
      "And deliver reports for decision‑making"
    ],
    "integrations": [
      "Power BI",
      "Tableau",
      "Excel",
      "Python",
      "SQL databases"
    ],
    "faq": [
      {
        "q": "What is included in the Data Analysis service?",
        "a": "Each Data Analysis engagement includes Report/dashboard, delivered within 13 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Data Analysis?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Data Analysis?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Power BI, Tableau, Excel, Python)."
      },
      {
        "q": "How many revisions are included in Data Analysis?",
        "a": "Each Data Analysis engagement includes Report/dashboard, delivered within 13 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Data Analysis?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-167",
    "slug": "dashboard-development",
    "title": "Dashboard Development",
    "category": "data-ai",
    "icon": "BrainCircuit",
    "description": "Develop interactive dashboards",
    "valueProp": "Develop interactive dashboards",
    "tagline": "Develop interactive dashboards",
    "deliverable": "Report/dashboard",
    "tiers": {
      "basic": 169,
      "standard": 286,
      "premium": 907
    },
    "days": 8,
    "subscriptionAvailable": true,
    "steps": [
      "Collect and clean data",
      "Perform exploratory analysis and modeling",
      "Build dashboards and visualizations",
      "Interpret results with actionable insights",
      "And deliver reports for decision‑making"
    ],
    "integrations": [
      "Power BI",
      "Tableau",
      "Excel",
      "Python",
      "SQL databases"
    ],
    "faq": [
      {
        "q": "What is included in the Dashboard Development service?",
        "a": "Each Dashboard Development engagement includes Report/dashboard, delivered within 8 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Dashboard Development?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Dashboard Development?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Power BI, Tableau, Excel, Python)."
      },
      {
        "q": "How many revisions are included in Dashboard Development?",
        "a": "Each Dashboard Development engagement includes Report/dashboard, delivered within 8 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Dashboard Development?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-168",
    "slug": "data-visualization",
    "title": "Data Visualization",
    "category": "data-ai",
    "icon": "BrainCircuit",
    "description": "Create charts and visualizations",
    "valueProp": "Create charts and visualizations",
    "tagline": "Create charts and visualizations",
    "deliverable": "Report/dashboard",
    "tiers": {
      "basic": 132,
      "standard": 231,
      "premium": 791
    },
    "days": 5,
    "subscriptionAvailable": true,
    "steps": [
      "Collect and clean data",
      "Perform exploratory analysis and modeling",
      "Build dashboards and visualizations",
      "Interpret results with actionable insights",
      "And deliver reports for decision‑making"
    ],
    "integrations": [
      "Power BI",
      "Tableau",
      "Excel",
      "Python",
      "SQL databases"
    ],
    "faq": [
      {
        "q": "What is included in the Data Visualization service?",
        "a": "Each Data Visualization engagement includes Report/dashboard, delivered within 5 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Data Visualization?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Data Visualization?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Power BI, Tableau, Excel, Python)."
      },
      {
        "q": "How many revisions are included in Data Visualization?",
        "a": "Each Data Visualization engagement includes Report/dashboard, delivered within 5 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Data Visualization?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-169",
    "slug": "business-intelligence-reporting",
    "title": "Business Intelligence Reporting",
    "category": "data-ai",
    "icon": "BrainCircuit",
    "description": "Generate BI reports",
    "valueProp": "Generate BI reports",
    "tagline": "Generate BI reports",
    "deliverable": "Report/dashboard",
    "tiers": {
      "basic": 143,
      "standard": 223,
      "premium": 731
    },
    "days": 14,
    "subscriptionAvailable": true,
    "steps": [
      "Collect and clean data",
      "Perform exploratory analysis and modeling",
      "Build dashboards and visualizations",
      "Interpret results with actionable insights",
      "And deliver reports for decision‑making"
    ],
    "integrations": [
      "Power BI",
      "Tableau",
      "Excel",
      "Python",
      "SQL databases"
    ],
    "faq": [
      {
        "q": "What is included in the Business Intelligence Reporting service?",
        "a": "Each Business Intelligence Reporting engagement includes Report/dashboard, delivered within 14 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Business Intelligence Reporting?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Business Intelligence Reporting?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Power BI, Tableau, Excel, Python)."
      },
      {
        "q": "How many revisions are included in Business Intelligence Reporting?",
        "a": "Each Business Intelligence Reporting engagement includes Report/dashboard, delivered within 14 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Business Intelligence Reporting?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-170",
    "slug": "data-engineering-pipelines",
    "title": "Data Engineering Pipelines",
    "category": "data-ai",
    "icon": "BrainCircuit",
    "description": "Build data pipelines",
    "valueProp": "Build data pipelines",
    "tagline": "Build data pipelines",
    "deliverable": "Report/dashboard",
    "tiers": {
      "basic": 109,
      "standard": 382,
      "premium": 688
    },
    "days": 14,
    "subscriptionAvailable": true,
    "steps": [
      "Collect and clean data",
      "Perform exploratory analysis and modeling",
      "Build dashboards and visualizations",
      "Interpret results with actionable insights",
      "And deliver reports for decision‑making"
    ],
    "integrations": [
      "Power BI",
      "Tableau",
      "Excel",
      "Python",
      "SQL databases"
    ],
    "faq": [
      {
        "q": "What is included in the Data Engineering Pipelines service?",
        "a": "Each Data Engineering Pipelines engagement includes Report/dashboard, delivered within 14 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Data Engineering Pipelines?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Data Engineering Pipelines?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Power BI, Tableau, Excel, Python)."
      },
      {
        "q": "How many revisions are included in Data Engineering Pipelines?",
        "a": "Each Data Engineering Pipelines engagement includes Report/dashboard, delivered within 14 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Data Engineering Pipelines?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-171",
    "slug": "statistical-modeling",
    "title": "Statistical Modeling",
    "category": "data-ai",
    "icon": "BrainCircuit",
    "description": "Build and evaluate statistical models",
    "valueProp": "Build and evaluate statistical models",
    "tagline": "Build and evaluate statistical models",
    "deliverable": "Report/dashboard",
    "tiers": {
      "basic": 105,
      "standard": 211,
      "premium": 648
    },
    "days": 6,
    "subscriptionAvailable": true,
    "steps": [
      "Collect and clean data",
      "Perform exploratory analysis and modeling",
      "Build dashboards and visualizations",
      "Interpret results with actionable insights",
      "And deliver reports for decision‑making"
    ],
    "integrations": [
      "Power BI",
      "Tableau",
      "Excel",
      "Python",
      "SQL databases"
    ],
    "faq": [
      {
        "q": "What is included in the Statistical Modeling service?",
        "a": "Each Statistical Modeling engagement includes Report/dashboard, delivered within 6 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Statistical Modeling?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Statistical Modeling?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Power BI, Tableau, Excel, Python)."
      },
      {
        "q": "How many revisions are included in Statistical Modeling?",
        "a": "Each Statistical Modeling engagement includes Report/dashboard, delivered within 6 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Statistical Modeling?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-172",
    "slug": "machine-learning-analytics",
    "title": "Machine Learning Analytics",
    "category": "data-ai",
    "icon": "BrainCircuit",
    "description": "Apply ML for data analytics",
    "valueProp": "Apply ML for data analytics",
    "tagline": "Apply ML for data analytics",
    "deliverable": "Report/dashboard",
    "tiers": {
      "basic": 107,
      "standard": 214,
      "premium": 505
    },
    "days": 9,
    "subscriptionAvailable": true,
    "steps": [
      "Collect and clean data",
      "Perform exploratory analysis and modeling",
      "Build dashboards and visualizations",
      "Interpret results with actionable insights",
      "And deliver reports for decision‑making"
    ],
    "integrations": [
      "Power BI",
      "Tableau",
      "Excel",
      "Python",
      "SQL databases"
    ],
    "faq": [
      {
        "q": "What is included in the Machine Learning Analytics service?",
        "a": "Each Machine Learning Analytics engagement includes Report/dashboard, delivered within 9 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Machine Learning Analytics?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Machine Learning Analytics?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Power BI, Tableau, Excel, Python)."
      },
      {
        "q": "How many revisions are included in Machine Learning Analytics?",
        "a": "Each Machine Learning Analytics engagement includes Report/dashboard, delivered within 9 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Machine Learning Analytics?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-173",
    "slug": "predictive-analytics",
    "title": "Predictive Analytics",
    "category": "data-ai",
    "icon": "BrainCircuit",
    "description": "Forecast future trends",
    "valueProp": "Forecast future trends",
    "tagline": "Forecast future trends",
    "deliverable": "Report/dashboard",
    "tiers": {
      "basic": 103,
      "standard": 263,
      "premium": 719
    },
    "days": 9,
    "subscriptionAvailable": true,
    "steps": [
      "Collect and clean data",
      "Perform exploratory analysis and modeling",
      "Build dashboards and visualizations",
      "Interpret results with actionable insights",
      "And deliver reports for decision‑making"
    ],
    "integrations": [
      "Power BI",
      "Tableau",
      "Excel",
      "Python",
      "SQL databases"
    ],
    "faq": [
      {
        "q": "What is included in the Predictive Analytics service?",
        "a": "Each Predictive Analytics engagement includes Report/dashboard, delivered within 9 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Predictive Analytics?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Predictive Analytics?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Power BI, Tableau, Excel, Python)."
      },
      {
        "q": "How many revisions are included in Predictive Analytics?",
        "a": "Each Predictive Analytics engagement includes Report/dashboard, delivered within 9 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Predictive Analytics?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-174",
    "slug": "data-cleaning-and-preparation",
    "title": "Data Cleaning & Preparation",
    "category": "data-ai",
    "icon": "BrainCircuit",
    "description": "Prepare datasets for analysis",
    "valueProp": "Prepare datasets for analysis",
    "tagline": "Prepare datasets for analysis",
    "deliverable": "Report/dashboard",
    "tiers": {
      "basic": 161,
      "standard": 397,
      "premium": 883
    },
    "days": 11,
    "subscriptionAvailable": true,
    "steps": [
      "Collect and clean data",
      "Perform exploratory analysis and modeling",
      "Build dashboards and visualizations",
      "Interpret results with actionable insights",
      "And deliver reports for decision‑making"
    ],
    "integrations": [
      "Power BI",
      "Tableau",
      "Excel",
      "Python",
      "SQL databases"
    ],
    "faq": [
      {
        "q": "What is included in the Data Cleaning & Preparation service?",
        "a": "Each Data Cleaning & Preparation engagement includes Report/dashboard, delivered within 11 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Data Cleaning & Preparation?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Data Cleaning & Preparation?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Power BI, Tableau, Excel, Python)."
      },
      {
        "q": "How many revisions are included in Data Cleaning & Preparation?",
        "a": "Each Data Cleaning & Preparation engagement includes Report/dashboard, delivered within 11 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Data Cleaning & Preparation?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-175",
    "slug": "report-automation",
    "title": "Report Automation",
    "category": "data-ai",
    "icon": "BrainCircuit",
    "description": "Automate repetitive reporting",
    "valueProp": "Automate repetitive reporting",
    "tagline": "Automate repetitive reporting",
    "deliverable": "Report/dashboard",
    "tiers": {
      "basic": 110,
      "standard": 442,
      "premium": 856
    },
    "days": 9,
    "subscriptionAvailable": true,
    "steps": [
      "Collect and clean data",
      "Perform exploratory analysis and modeling",
      "Build dashboards and visualizations",
      "Interpret results with actionable insights",
      "And deliver reports for decision‑making"
    ],
    "integrations": [
      "Power BI",
      "Tableau",
      "Excel",
      "Python",
      "SQL databases"
    ],
    "faq": [
      {
        "q": "What is included in the Report Automation service?",
        "a": "Each Report Automation engagement includes Report/dashboard, delivered within 9 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Report Automation?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Report Automation?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Power BI, Tableau, Excel, Python)."
      },
      {
        "q": "How many revisions are included in Report Automation?",
        "a": "Each Report Automation engagement includes Report/dashboard, delivered within 9 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Report Automation?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-176",
    "slug": "data-warehousing",
    "title": "Data Warehousing",
    "category": "data-ai",
    "icon": "BrainCircuit",
    "description": "Design and implement warehouses",
    "valueProp": "Design and implement warehouses",
    "tagline": "Design and implement warehouses",
    "deliverable": "Report/dashboard",
    "tiers": {
      "basic": 186,
      "standard": 457,
      "premium": 782
    },
    "days": 13,
    "subscriptionAvailable": true,
    "steps": [
      "Collect and clean data",
      "Perform exploratory analysis and modeling",
      "Build dashboards and visualizations",
      "Interpret results with actionable insights",
      "And deliver reports for decision‑making"
    ],
    "integrations": [
      "Power BI",
      "Tableau",
      "Excel",
      "Python",
      "SQL databases"
    ],
    "faq": [
      {
        "q": "What is included in the Data Warehousing service?",
        "a": "Each Data Warehousing engagement includes Report/dashboard, delivered within 13 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Data Warehousing?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Data Warehousing?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Power BI, Tableau, Excel, Python)."
      },
      {
        "q": "How many revisions are included in Data Warehousing?",
        "a": "Each Data Warehousing engagement includes Report/dashboard, delivered within 13 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Data Warehousing?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-177",
    "slug": "etl-processes",
    "title": "ETL Processes",
    "category": "data-ai",
    "icon": "BrainCircuit",
    "description": "Extract, transform, load data",
    "valueProp": "Extract, transform, load data",
    "tagline": "Extract, transform, load data",
    "deliverable": "Report/dashboard",
    "tiers": {
      "basic": 166,
      "standard": 406,
      "premium": 518
    },
    "days": 7,
    "subscriptionAvailable": true,
    "steps": [
      "Collect and clean data",
      "Perform exploratory analysis and modeling",
      "Build dashboards and visualizations",
      "Interpret results with actionable insights",
      "And deliver reports for decision‑making"
    ],
    "integrations": [
      "Power BI",
      "Tableau",
      "Excel",
      "Python",
      "SQL databases"
    ],
    "faq": [
      {
        "q": "What is included in the ETL Processes service?",
        "a": "Each ETL Processes engagement includes Report/dashboard, delivered within 7 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for ETL Processes?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start ETL Processes?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Power BI, Tableau, Excel, Python)."
      },
      {
        "q": "How many revisions are included in ETL Processes?",
        "a": "Each ETL Processes engagement includes Report/dashboard, delivered within 7 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after ETL Processes?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-178",
    "slug": "data-mining",
    "title": "Data Mining",
    "category": "data-ai",
    "icon": "BrainCircuit",
    "description": "Discover patterns in data",
    "valueProp": "Discover patterns in data",
    "tagline": "Discover patterns in data",
    "deliverable": "Report/dashboard",
    "tiers": {
      "basic": 190,
      "standard": 461,
      "premium": 536
    },
    "days": 5,
    "subscriptionAvailable": true,
    "steps": [
      "Collect and clean data",
      "Perform exploratory analysis and modeling",
      "Build dashboards and visualizations",
      "Interpret results with actionable insights",
      "And deliver reports for decision‑making"
    ],
    "integrations": [
      "Power BI",
      "Tableau",
      "Excel",
      "Python",
      "SQL databases"
    ],
    "faq": [
      {
        "q": "What is included in the Data Mining service?",
        "a": "Each Data Mining engagement includes Report/dashboard, delivered within 5 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Data Mining?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Data Mining?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Power BI, Tableau, Excel, Python)."
      },
      {
        "q": "How many revisions are included in Data Mining?",
        "a": "Each Data Mining engagement includes Report/dashboard, delivered within 5 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Data Mining?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-179",
    "slug": "data-governance-consulting",
    "title": "Data Governance Consulting",
    "category": "data-ai",
    "icon": "BrainCircuit",
    "description": "Advise on data governance",
    "valueProp": "Advise on data governance",
    "tagline": "Advise on data governance",
    "deliverable": "Report/dashboard",
    "tiers": {
      "basic": 147,
      "standard": 211,
      "premium": 857
    },
    "days": 8,
    "subscriptionAvailable": true,
    "steps": [
      "Collect and clean data",
      "Perform exploratory analysis and modeling",
      "Build dashboards and visualizations",
      "Interpret results with actionable insights",
      "And deliver reports for decision‑making"
    ],
    "integrations": [
      "Power BI",
      "Tableau",
      "Excel",
      "Python",
      "SQL databases"
    ],
    "faq": [
      {
        "q": "What is included in the Data Governance Consulting service?",
        "a": "Each Data Governance Consulting engagement includes Report/dashboard, delivered within 8 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Data Governance Consulting?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Data Governance Consulting?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Power BI, Tableau, Excel, Python)."
      },
      {
        "q": "How many revisions are included in Data Governance Consulting?",
        "a": "Each Data Governance Consulting engagement includes Report/dashboard, delivered within 8 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Data Governance Consulting?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-180",
    "slug": "kpi-development",
    "title": "KPI Development",
    "category": "data-ai",
    "icon": "BrainCircuit",
    "description": "Define key performance indicators",
    "valueProp": "Define key performance indicators",
    "tagline": "Define key performance indicators",
    "deliverable": "Report/dashboard",
    "tiers": {
      "basic": 195,
      "standard": 234,
      "premium": 615
    },
    "days": 7,
    "subscriptionAvailable": true,
    "steps": [
      "Collect and clean data",
      "Perform exploratory analysis and modeling",
      "Build dashboards and visualizations",
      "Interpret results with actionable insights",
      "And deliver reports for decision‑making"
    ],
    "integrations": [
      "Power BI",
      "Tableau",
      "Excel",
      "Python",
      "SQL databases"
    ],
    "faq": [
      {
        "q": "What is included in the KPI Development service?",
        "a": "Each KPI Development engagement includes Report/dashboard, delivered within 7 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for KPI Development?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start KPI Development?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Power BI, Tableau, Excel, Python)."
      },
      {
        "q": "How many revisions are included in KPI Development?",
        "a": "Each KPI Development engagement includes Report/dashboard, delivered within 7 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after KPI Development?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-181",
    "slug": "business-plan-writing-register",
    "title": "Business Plan Writing",
    "category": "finance-fundraising",
    "icon": "Banknote",
    "description": "Write comprehensive business plans",
    "valueProp": "Write comprehensive business plans",
    "tagline": "Write comprehensive business plans",
    "deliverable": "Report/plan",
    "tiers": {
      "basic": 112,
      "standard": 230,
      "premium": 926
    },
    "days": 4,
    "subscriptionAvailable": true,
    "steps": [
      "Analyze your current business data and objectives",
      "Perform financial modeling or strategic analysis",
      "Draft the plan or report",
      "Review and refine with stakeholders",
      "And deliver final documents"
    ],
    "integrations": [
      "Excel",
      "QuickBooks",
      "PowerPoint",
      "Business Intelligence Tools"
    ],
    "faq": [
      {
        "q": "What is included in the Business Plan Writing service?",
        "a": "Each Business Plan Writing engagement includes Report/plan, delivered within 4 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Business Plan Writing?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Business Plan Writing?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Excel, QuickBooks, PowerPoint, Business Intelligence Tools)."
      },
      {
        "q": "How many revisions are included in Business Plan Writing?",
        "a": "Each Business Plan Writing engagement includes Report/plan, delivered within 4 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Business Plan Writing?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-182",
    "slug": "financial-forecasting",
    "title": "Financial Forecasting",
    "category": "finance-fundraising",
    "icon": "Banknote",
    "description": "Predict financial performance",
    "valueProp": "Predict financial performance",
    "tagline": "Predict financial performance",
    "deliverable": "Report/plan",
    "tiers": {
      "basic": 188,
      "standard": 395,
      "premium": 815
    },
    "days": 11,
    "subscriptionAvailable": true,
    "steps": [
      "Analyze your current business data and objectives",
      "Perform financial modeling or strategic analysis",
      "Draft the plan or report",
      "Review and refine with stakeholders",
      "And deliver final documents"
    ],
    "integrations": [
      "Excel",
      "QuickBooks",
      "PowerPoint",
      "Business Intelligence Tools"
    ],
    "faq": [
      {
        "q": "What is included in the Financial Forecasting service?",
        "a": "Each Financial Forecasting engagement includes Report/plan, delivered within 11 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Financial Forecasting?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Financial Forecasting?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Excel, QuickBooks, PowerPoint, Business Intelligence Tools)."
      },
      {
        "q": "How many revisions are included in Financial Forecasting?",
        "a": "Each Financial Forecasting engagement includes Report/plan, delivered within 11 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Financial Forecasting?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-183",
    "slug": "budgeting-and-financial-modeling",
    "title": "Budgeting & Financial Modeling",
    "category": "finance-fundraising",
    "icon": "Banknote",
    "description": "Create budgets and models",
    "valueProp": "Create budgets and models",
    "tagline": "Create budgets and models",
    "deliverable": "Report/plan",
    "tiers": {
      "basic": 193,
      "standard": 444,
      "premium": 888
    },
    "days": 4,
    "subscriptionAvailable": true,
    "steps": [
      "Analyze your current business data and objectives",
      "Perform financial modeling or strategic analysis",
      "Draft the plan or report",
      "Review and refine with stakeholders",
      "And deliver final documents"
    ],
    "integrations": [
      "Excel",
      "QuickBooks",
      "PowerPoint",
      "Business Intelligence Tools"
    ],
    "faq": [
      {
        "q": "What is included in the Budgeting & Financial Modeling service?",
        "a": "Each Budgeting & Financial Modeling engagement includes Report/plan, delivered within 4 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Budgeting & Financial Modeling?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Budgeting & Financial Modeling?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Excel, QuickBooks, PowerPoint, Business Intelligence Tools)."
      },
      {
        "q": "How many revisions are included in Budgeting & Financial Modeling?",
        "a": "Each Budgeting & Financial Modeling engagement includes Report/plan, delivered within 4 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Budgeting & Financial Modeling?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-184",
    "slug": "pitch-deck-creation",
    "title": "Pitch Deck Creation",
    "category": "finance-fundraising",
    "icon": "Banknote",
    "description": "Design investor pitch decks",
    "valueProp": "Design investor pitch decks",
    "tagline": "Design investor pitch decks",
    "deliverable": "Report/plan",
    "tiers": {
      "basic": 151,
      "standard": 288,
      "premium": 844
    },
    "days": 5,
    "subscriptionAvailable": true,
    "steps": [
      "Analyze your current business data and objectives",
      "Perform financial modeling or strategic analysis",
      "Draft the plan or report",
      "Review and refine with stakeholders",
      "And deliver final documents"
    ],
    "integrations": [
      "Excel",
      "QuickBooks",
      "PowerPoint",
      "Business Intelligence Tools"
    ],
    "faq": [
      {
        "q": "What is included in the Pitch Deck Creation service?",
        "a": "Each Pitch Deck Creation engagement includes Report/plan, delivered within 5 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Pitch Deck Creation?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Pitch Deck Creation?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Excel, QuickBooks, PowerPoint, Business Intelligence Tools)."
      },
      {
        "q": "How many revisions are included in Pitch Deck Creation?",
        "a": "Each Pitch Deck Creation engagement includes Report/plan, delivered within 5 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Pitch Deck Creation?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-185",
    "slug": "market-analysis",
    "title": "Market Analysis",
    "category": "finance-fundraising",
    "icon": "Banknote",
    "description": "Analyze market and industry trends",
    "valueProp": "Analyze market and industry trends",
    "tagline": "Analyze market and industry trends",
    "deliverable": "Report/plan",
    "tiers": {
      "basic": 194,
      "standard": 356,
      "premium": 708
    },
    "days": 4,
    "subscriptionAvailable": true,
    "steps": [
      "Analyze your current business data and objectives",
      "Perform financial modeling or strategic analysis",
      "Draft the plan or report",
      "Review and refine with stakeholders",
      "And deliver final documents"
    ],
    "integrations": [
      "Excel",
      "QuickBooks",
      "PowerPoint",
      "Business Intelligence Tools"
    ],
    "faq": [
      {
        "q": "What is included in the Market Analysis service?",
        "a": "Each Market Analysis engagement includes Report/plan, delivered within 4 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Market Analysis?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Market Analysis?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Excel, QuickBooks, PowerPoint, Business Intelligence Tools)."
      },
      {
        "q": "How many revisions are included in Market Analysis?",
        "a": "Each Market Analysis engagement includes Report/plan, delivered within 4 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Market Analysis?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-186",
    "slug": "swot-analysis",
    "title": "SWOT Analysis",
    "category": "finance-fundraising",
    "icon": "Banknote",
    "description": "Assess strengths, weaknesses, opportunities, threats",
    "valueProp": "Assess strengths, weaknesses, opportunities, threats",
    "tagline": "Assess strengths, weaknesses, opportunities, threats",
    "deliverable": "Report/plan",
    "tiers": {
      "basic": 160,
      "standard": 272,
      "premium": 718
    },
    "days": 6,
    "subscriptionAvailable": true,
    "steps": [
      "Analyze your current business data and objectives",
      "Perform financial modeling or strategic analysis",
      "Draft the plan or report",
      "Review and refine with stakeholders",
      "And deliver final documents"
    ],
    "integrations": [
      "Excel",
      "QuickBooks",
      "PowerPoint",
      "Business Intelligence Tools"
    ],
    "faq": [
      {
        "q": "What is included in the SWOT Analysis service?",
        "a": "Each SWOT Analysis engagement includes Report/plan, delivered within 6 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for SWOT Analysis?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start SWOT Analysis?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Excel, QuickBooks, PowerPoint, Business Intelligence Tools)."
      },
      {
        "q": "How many revisions are included in SWOT Analysis?",
        "a": "Each SWOT Analysis engagement includes Report/plan, delivered within 6 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after SWOT Analysis?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-187",
    "slug": "feasibility-study",
    "title": "Feasibility Study",
    "category": "finance-fundraising",
    "icon": "Banknote",
    "description": "Evaluate viability of projects",
    "valueProp": "Evaluate viability of projects",
    "tagline": "Evaluate viability of projects",
    "deliverable": "Report/plan",
    "tiers": {
      "basic": 184,
      "standard": 454,
      "premium": 897
    },
    "days": 7,
    "subscriptionAvailable": true,
    "steps": [
      "Analyze your current business data and objectives",
      "Perform financial modeling or strategic analysis",
      "Draft the plan or report",
      "Review and refine with stakeholders",
      "And deliver final documents"
    ],
    "integrations": [
      "Excel",
      "QuickBooks",
      "PowerPoint",
      "Business Intelligence Tools"
    ],
    "faq": [
      {
        "q": "What is included in the Feasibility Study service?",
        "a": "Each Feasibility Study engagement includes Report/plan, delivered within 7 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Feasibility Study?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Feasibility Study?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Excel, QuickBooks, PowerPoint, Business Intelligence Tools)."
      },
      {
        "q": "How many revisions are included in Feasibility Study?",
        "a": "Each Feasibility Study engagement includes Report/plan, delivered within 7 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Feasibility Study?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-188",
    "slug": "competitor-analysis",
    "title": "Competitor Analysis",
    "category": "finance-fundraising",
    "icon": "Banknote",
    "description": "Analyze competitors and positioning",
    "valueProp": "Analyze competitors and positioning",
    "tagline": "Analyze competitors and positioning",
    "deliverable": "Report/plan",
    "tiers": {
      "basic": 142,
      "standard": 461,
      "premium": 792
    },
    "days": 7,
    "subscriptionAvailable": true,
    "steps": [
      "Analyze your current business data and objectives",
      "Perform financial modeling or strategic analysis",
      "Draft the plan or report",
      "Review and refine with stakeholders",
      "And deliver final documents"
    ],
    "integrations": [
      "Excel",
      "QuickBooks",
      "PowerPoint",
      "Business Intelligence Tools"
    ],
    "faq": [
      {
        "q": "What is included in the Competitor Analysis service?",
        "a": "Each Competitor Analysis engagement includes Report/plan, delivered within 7 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Competitor Analysis?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Competitor Analysis?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Excel, QuickBooks, PowerPoint, Business Intelligence Tools)."
      },
      {
        "q": "How many revisions are included in Competitor Analysis?",
        "a": "Each Competitor Analysis engagement includes Report/plan, delivered within 7 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Competitor Analysis?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-189",
    "slug": "pricing-strategy",
    "title": "Pricing Strategy",
    "category": "finance-fundraising",
    "icon": "Banknote",
    "description": "Develop pricing models",
    "valueProp": "Develop pricing models",
    "tagline": "Develop pricing models",
    "deliverable": "Report/plan",
    "tiers": {
      "basic": 187,
      "standard": 222,
      "premium": 867
    },
    "days": 8,
    "subscriptionAvailable": true,
    "steps": [
      "Analyze your current business data and objectives",
      "Perform financial modeling or strategic analysis",
      "Draft the plan or report",
      "Review and refine with stakeholders",
      "And deliver final documents"
    ],
    "integrations": [
      "Excel",
      "QuickBooks",
      "PowerPoint",
      "Business Intelligence Tools"
    ],
    "faq": [
      {
        "q": "What is included in the Pricing Strategy service?",
        "a": "Each Pricing Strategy engagement includes Report/plan, delivered within 8 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Pricing Strategy?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Pricing Strategy?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Excel, QuickBooks, PowerPoint, Business Intelligence Tools)."
      },
      {
        "q": "How many revisions are included in Pricing Strategy?",
        "a": "Each Pricing Strategy engagement includes Report/plan, delivered within 8 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Pricing Strategy?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-190",
    "slug": "cost-reduction-analysis",
    "title": "Cost Reduction Analysis",
    "category": "finance-fundraising",
    "icon": "Banknote",
    "description": "Identify cost-saving opportunities",
    "valueProp": "Identify cost-saving opportunities",
    "tagline": "Identify cost-saving opportunities",
    "deliverable": "Report/plan",
    "tiers": {
      "basic": 110,
      "standard": 451,
      "premium": 802
    },
    "days": 4,
    "subscriptionAvailable": true,
    "steps": [
      "Analyze your current business data and objectives",
      "Perform financial modeling or strategic analysis",
      "Draft the plan or report",
      "Review and refine with stakeholders",
      "And deliver final documents"
    ],
    "integrations": [
      "Excel",
      "QuickBooks",
      "PowerPoint",
      "Business Intelligence Tools"
    ],
    "faq": [
      {
        "q": "What is included in the Cost Reduction Analysis service?",
        "a": "Each Cost Reduction Analysis engagement includes Report/plan, delivered within 4 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Cost Reduction Analysis?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Cost Reduction Analysis?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Excel, QuickBooks, PowerPoint, Business Intelligence Tools)."
      },
      {
        "q": "How many revisions are included in Cost Reduction Analysis?",
        "a": "Each Cost Reduction Analysis engagement includes Report/plan, delivered within 4 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Cost Reduction Analysis?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-191",
    "slug": "business-process-mapping",
    "title": "Business Process Mapping",
    "category": "finance-fundraising",
    "icon": "Banknote",
    "description": "Map and optimize processes",
    "valueProp": "Map and optimize processes",
    "tagline": "Map and optimize processes",
    "deliverable": "Report/plan",
    "tiers": {
      "basic": 164,
      "standard": 276,
      "premium": 712
    },
    "days": 6,
    "subscriptionAvailable": true,
    "steps": [
      "Analyze your current business data and objectives",
      "Perform financial modeling or strategic analysis",
      "Draft the plan or report",
      "Review and refine with stakeholders",
      "And deliver final documents"
    ],
    "integrations": [
      "Excel",
      "QuickBooks",
      "PowerPoint",
      "Business Intelligence Tools"
    ],
    "faq": [
      {
        "q": "What is included in the Business Process Mapping service?",
        "a": "Each Business Process Mapping engagement includes Report/plan, delivered within 6 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Business Process Mapping?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Business Process Mapping?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Excel, QuickBooks, PowerPoint, Business Intelligence Tools)."
      },
      {
        "q": "How many revisions are included in Business Process Mapping?",
        "a": "Each Business Process Mapping engagement includes Report/plan, delivered within 6 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Business Process Mapping?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-192",
    "slug": "risk-management-assessment",
    "title": "Risk Management Assessment",
    "category": "finance-fundraising",
    "icon": "Banknote",
    "description": "Assess business risks",
    "valueProp": "Assess business risks",
    "tagline": "Assess business risks",
    "deliverable": "Report/plan",
    "tiers": {
      "basic": 151,
      "standard": 241,
      "premium": 573
    },
    "days": 6,
    "subscriptionAvailable": true,
    "steps": [
      "Analyze your current business data and objectives",
      "Perform financial modeling or strategic analysis",
      "Draft the plan or report",
      "Review and refine with stakeholders",
      "And deliver final documents"
    ],
    "integrations": [
      "Excel",
      "QuickBooks",
      "PowerPoint",
      "Business Intelligence Tools"
    ],
    "faq": [
      {
        "q": "What is included in the Risk Management Assessment service?",
        "a": "Each Risk Management Assessment engagement includes Report/plan, delivered within 6 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Risk Management Assessment?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Risk Management Assessment?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Excel, QuickBooks, PowerPoint, Business Intelligence Tools)."
      },
      {
        "q": "How many revisions are included in Risk Management Assessment?",
        "a": "Each Risk Management Assessment engagement includes Report/plan, delivered within 6 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Risk Management Assessment?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-193",
    "slug": "operational-efficiency-improvement",
    "title": "Operational Efficiency Improvement",
    "category": "finance-fundraising",
    "icon": "Banknote",
    "description": "Improve operational workflows",
    "valueProp": "Improve operational workflows",
    "tagline": "Improve operational workflows",
    "deliverable": "Report/plan",
    "tiers": {
      "basic": 166,
      "standard": 309,
      "premium": 640
    },
    "days": 4,
    "subscriptionAvailable": true,
    "steps": [
      "Analyze your current business data and objectives",
      "Perform financial modeling or strategic analysis",
      "Draft the plan or report",
      "Review and refine with stakeholders",
      "And deliver final documents"
    ],
    "integrations": [
      "Excel",
      "QuickBooks",
      "PowerPoint",
      "Business Intelligence Tools"
    ],
    "faq": [
      {
        "q": "What is included in the Operational Efficiency Improvement service?",
        "a": "Each Operational Efficiency Improvement engagement includes Report/plan, delivered within 4 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Operational Efficiency Improvement?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Operational Efficiency Improvement?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Excel, QuickBooks, PowerPoint, Business Intelligence Tools)."
      },
      {
        "q": "How many revisions are included in Operational Efficiency Improvement?",
        "a": "Each Operational Efficiency Improvement engagement includes Report/plan, delivered within 4 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Operational Efficiency Improvement?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-194",
    "slug": "hr-policies-drafting",
    "title": "HR Policies Drafting",
    "category": "finance-fundraising",
    "icon": "Banknote",
    "description": "Draft HR policies and procedures",
    "valueProp": "Draft HR policies and procedures",
    "tagline": "Draft HR policies and procedures",
    "deliverable": "Report/plan",
    "tiers": {
      "basic": 197,
      "standard": 336,
      "premium": 982
    },
    "days": 7,
    "subscriptionAvailable": true,
    "steps": [
      "Analyze your current business data and objectives",
      "Perform financial modeling or strategic analysis",
      "Draft the plan or report",
      "Review and refine with stakeholders",
      "And deliver final documents"
    ],
    "integrations": [
      "Excel",
      "QuickBooks",
      "PowerPoint",
      "Business Intelligence Tools"
    ],
    "faq": [
      {
        "q": "What is included in the HR Policies Drafting service?",
        "a": "Each HR Policies Drafting engagement includes Report/plan, delivered within 7 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for HR Policies Drafting?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start HR Policies Drafting?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Excel, QuickBooks, PowerPoint, Business Intelligence Tools)."
      },
      {
        "q": "How many revisions are included in HR Policies Drafting?",
        "a": "Each HR Policies Drafting engagement includes Report/plan, delivered within 7 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after HR Policies Drafting?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-195",
    "slug": "outsourcing-strategy",
    "title": "Outsourcing Strategy",
    "category": "finance-fundraising",
    "icon": "Banknote",
    "description": "Plan outsourcing solutions",
    "valueProp": "Plan outsourcing solutions",
    "tagline": "Plan outsourcing solutions",
    "deliverable": "Report/plan",
    "tiers": {
      "basic": 109,
      "standard": 381,
      "premium": 742
    },
    "days": 10,
    "subscriptionAvailable": true,
    "steps": [
      "Analyze your current business data and objectives",
      "Perform financial modeling or strategic analysis",
      "Draft the plan or report",
      "Review and refine with stakeholders",
      "And deliver final documents"
    ],
    "integrations": [
      "Excel",
      "QuickBooks",
      "PowerPoint",
      "Business Intelligence Tools"
    ],
    "faq": [
      {
        "q": "What is included in the Outsourcing Strategy service?",
        "a": "Each Outsourcing Strategy engagement includes Report/plan, delivered within 10 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Outsourcing Strategy?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Outsourcing Strategy?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Excel, QuickBooks, PowerPoint, Business Intelligence Tools)."
      },
      {
        "q": "How many revisions are included in Outsourcing Strategy?",
        "a": "Each Outsourcing Strategy engagement includes Report/plan, delivered within 10 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Outsourcing Strategy?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-196",
    "slug": "business-coaching",
    "title": "Business Coaching",
    "category": "finance-fundraising",
    "icon": "Banknote",
    "description": "Provide coaching for leaders",
    "valueProp": "Provide coaching for leaders",
    "tagline": "Provide coaching for leaders",
    "deliverable": "Report/plan",
    "tiers": {
      "basic": 188,
      "standard": 438,
      "premium": 697
    },
    "days": 11,
    "subscriptionAvailable": true,
    "steps": [
      "Analyze your current business data and objectives",
      "Perform financial modeling or strategic analysis",
      "Draft the plan or report",
      "Review and refine with stakeholders",
      "And deliver final documents"
    ],
    "integrations": [
      "Excel",
      "QuickBooks",
      "PowerPoint",
      "Business Intelligence Tools"
    ],
    "faq": [
      {
        "q": "What is included in the Business Coaching service?",
        "a": "Each Business Coaching engagement includes Report/plan, delivered within 11 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Business Coaching?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Business Coaching?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Excel, QuickBooks, PowerPoint, Business Intelligence Tools)."
      },
      {
        "q": "How many revisions are included in Business Coaching?",
        "a": "Each Business Coaching engagement includes Report/plan, delivered within 11 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Business Coaching?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-197",
    "slug": "virtual-cfo-services",
    "title": "Virtual CFO Services",
    "category": "finance-fundraising",
    "icon": "Banknote",
    "description": "Offer virtual financial management",
    "valueProp": "Offer virtual financial management",
    "tagline": "Offer virtual financial management",
    "deliverable": "Report/plan",
    "tiers": {
      "basic": 142,
      "standard": 239,
      "premium": 675
    },
    "days": 11,
    "subscriptionAvailable": true,
    "steps": [
      "Analyze your current business data and objectives",
      "Perform financial modeling or strategic analysis",
      "Draft the plan or report",
      "Review and refine with stakeholders",
      "And deliver final documents"
    ],
    "integrations": [
      "Excel",
      "QuickBooks",
      "PowerPoint",
      "Business Intelligence Tools"
    ],
    "faq": [
      {
        "q": "What is included in the Virtual CFO Services service?",
        "a": "Each Virtual CFO Services engagement includes Report/plan, delivered within 11 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Virtual CFO Services?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Virtual CFO Services?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Excel, QuickBooks, PowerPoint, Business Intelligence Tools)."
      },
      {
        "q": "How many revisions are included in Virtual CFO Services?",
        "a": "Each Virtual CFO Services engagement includes Report/plan, delivered within 11 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Virtual CFO Services?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-198",
    "slug": "kpi-dashboard-creation",
    "title": "KPI Dashboard Creation",
    "category": "finance-fundraising",
    "icon": "Banknote",
    "description": "Develop KPI dashboards",
    "valueProp": "Develop KPI dashboards",
    "tagline": "Develop KPI dashboards",
    "deliverable": "Report/plan",
    "tiers": {
      "basic": 191,
      "standard": 284,
      "premium": 726
    },
    "days": 3,
    "subscriptionAvailable": true,
    "steps": [
      "Analyze your current business data and objectives",
      "Perform financial modeling or strategic analysis",
      "Draft the plan or report",
      "Review and refine with stakeholders",
      "And deliver final documents"
    ],
    "integrations": [
      "Excel",
      "QuickBooks",
      "PowerPoint",
      "Business Intelligence Tools"
    ],
    "faq": [
      {
        "q": "What is included in the KPI Dashboard Creation service?",
        "a": "Each KPI Dashboard Creation engagement includes Report/plan, delivered within 3 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for KPI Dashboard Creation?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start KPI Dashboard Creation?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Excel, QuickBooks, PowerPoint, Business Intelligence Tools)."
      },
      {
        "q": "How many revisions are included in KPI Dashboard Creation?",
        "a": "Each KPI Dashboard Creation engagement includes Report/plan, delivered within 3 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after KPI Dashboard Creation?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-199",
    "slug": "exit-strategy-planning",
    "title": "Exit Strategy Planning",
    "category": "finance-fundraising",
    "icon": "Banknote",
    "description": "Plan business exits and succession",
    "valueProp": "Plan business exits and succession",
    "tagline": "Plan business exits and succession",
    "deliverable": "Report/plan",
    "tiers": {
      "basic": 139,
      "standard": 306,
      "premium": 879
    },
    "days": 5,
    "subscriptionAvailable": true,
    "steps": [
      "Analyze your current business data and objectives",
      "Perform financial modeling or strategic analysis",
      "Draft the plan or report",
      "Review and refine with stakeholders",
      "And deliver final documents"
    ],
    "integrations": [
      "Excel",
      "QuickBooks",
      "PowerPoint",
      "Business Intelligence Tools"
    ],
    "faq": [
      {
        "q": "What is included in the Exit Strategy Planning service?",
        "a": "Each Exit Strategy Planning engagement includes Report/plan, delivered within 5 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Exit Strategy Planning?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Exit Strategy Planning?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Excel, QuickBooks, PowerPoint, Business Intelligence Tools)."
      },
      {
        "q": "How many revisions are included in Exit Strategy Planning?",
        "a": "Each Exit Strategy Planning engagement includes Report/plan, delivered within 5 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Exit Strategy Planning?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  },
  {
    "id": "reg-200",
    "slug": "regulatory-compliance-consulting",
    "title": "Regulatory Compliance Consulting",
    "category": "finance-fundraising",
    "icon": "Banknote",
    "description": "Advise on compliance requirements",
    "valueProp": "Advise on compliance requirements",
    "tagline": "Advise on compliance requirements",
    "deliverable": "Report/plan",
    "tiers": {
      "basic": 105,
      "standard": 473,
      "premium": 727
    },
    "days": 5,
    "subscriptionAvailable": true,
    "steps": [
      "Analyze your current business data and objectives",
      "Perform financial modeling or strategic analysis",
      "Draft the plan or report",
      "Review and refine with stakeholders",
      "And deliver final documents"
    ],
    "integrations": [
      "Excel",
      "QuickBooks",
      "PowerPoint",
      "Business Intelligence Tools"
    ],
    "faq": [
      {
        "q": "What is included in the Regulatory Compliance Consulting service?",
        "a": "Each Regulatory Compliance Consulting engagement includes Report/plan, delivered within 5 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "How do you ensure quality for Regulatory Compliance Consulting?",
        "a": "Quality is ensured through a structured intake, a single point of accountability, and a review checkpoint before final hand-off. Premium tier adds an extended QA pass."
      },
      {
        "q": "What information do you need to start Regulatory Compliance Consulting?",
        "a": "To start we need a short brief: your goal, target audience, brand or technical references, and any existing assets or accounts to integrate (Excel, QuickBooks, PowerPoint, Business Intelligence Tools)."
      },
      {
        "q": "How many revisions are included in Regulatory Compliance Consulting?",
        "a": "Each Regulatory Compliance Consulting engagement includes Report/plan, delivered within 5 days. Three tiers are available (Basic, Standard, Premium) so you can match scope to budget."
      },
      {
        "q": "Do you offer support or maintenance after Regulatory Compliance Consulting?",
        "a": "Yes — a monthly subscription is available with continued support, updates, and small change requests rolled into the plan."
      }
    ]
  }
];

function tierBand(price: number) {
  // Render as a small range around the seed price (+/- 15%) for visual variety.
  const lo = Math.max(10, Math.round(price * 0.85));
  const hi = Math.round(price * 1.15);
  return { min: lo, max: hi };
}

function eurBand(usd: number) {
  const band = tierBand(usd);
  return { min: Math.max(1, Math.round(band.min * USD_TO_EUR)), max: Math.max(1, Math.round(band.max * USD_TO_EUR)) };
}

function leadBand(days: number) {
  return { min: Math.max(1, days - 1), max: days + 2 };
}

export const microservicesRegister: Microservice[] = ROWS.map((r) => ({
  id: r.id,
  slug: r.slug,
  name: { en: r.title, fr: r.title },
  tagline: { en: r.tagline, fr: r.tagline },
  description: { en: r.description, fr: r.description },
  category: r.category,
  pricing_model: "per_use",
  pricing_xof: `€${Math.round(r.tiers.standard * USD_TO_EUR)}`,
  pricing_eur: `€${Math.round(r.tiers.standard * USD_TO_EUR)}`,
  target_countries: ["UEMOA-all"],
  icon: r.icon,
  featured: false,
  how_it_works: { en: r.steps, fr: r.steps },
  integrations: r.integrations,
  faq: r.faq.map((f) => ({ q: { en: f.q, fr: f.q }, a: { en: f.a, fr: f.a } })),
  requires_scoping_call: false,
  tiers: {
    basic:    { price_usd: tierBand(r.tiers.basic),    price_eur: eurBand(r.tiers.basic),    lead_days: leadBand(Math.max(1, r.days - 1)), scope: { en: "Essential scope", fr: "Périmètre essentiel" } },
    standard: { price_usd: tierBand(r.tiers.standard), price_eur: eurBand(r.tiers.standard), lead_days: leadBand(r.days),                  scope: { en: "Recommended scope", fr: "Périmètre recommandé" } },
    premium:  { price_usd: tierBand(r.tiers.premium),  price_eur: eurBand(r.tiers.premium),  lead_days: leadBand(r.days + 2),              scope: { en: "Comprehensive scope", fr: "Périmètre complet" } },
  },
  deliverable: { en: r.deliverable, fr: r.deliverable },
  value_prop: { en: r.valueProp, fr: r.valueProp },
  subscription_available: r.subscriptionAvailable,
}));
